var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _rect2, _path1522, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageLlamalend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_6545_375133)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3605 17.9562L13.9719 18.2619L13.7997 17.6124L15.2744 17.3426L15.3605 17.9562Z",
    fill: "#0000FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9714 18.2614L12.7648 18.671L12.5041 17.993L13.7991 17.6119L13.9714 18.2614Z",
    fill: "#0000FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2733 17.342L13.7985 17.6118L13.6434 16.8539L15.1962 16.6248L15.2733 17.342Z",
    fill: "#0028FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7991 17.6114L12.5041 17.9925L12.2689 17.2012L13.644 16.8535L13.7991 17.6114Z",
    fill: "#0018FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4529 18.4513L14.1566 18.7872L13.9714 18.2619L15.36 17.9562L15.4529 18.4513Z",
    fill: "#0000F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1571 18.7867L13.0454 19.2195L12.7653 18.6709L13.9719 18.2614L14.1571 18.7867Z",
    fill: "#0000DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.197 16.6252L13.6442 16.8543L13.5099 16.006L15.1307 15.8216L15.197 16.6252Z",
    fill: "#0058FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6445 16.8538L12.2694 17.2015L12.0654 16.3159L13.5103 16.0055L13.6445 16.8538Z",
    fill: "#0048FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.878 17.7549L15.3603 17.9563L15.2743 17.3428L16.8722 17.1831L16.878 17.7549Z",
    fill: "#0014FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5509 18.8155L14.3507 19.1753L14.1569 18.7869L15.4533 18.451L15.5509 18.8155Z",
    fill: "#0000DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.765 18.6717L11.7758 19.1789L11.4282 18.4809L12.5042 17.9937L12.765 18.6717Z",
    fill: "#0000E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 19.1755L13.3371 19.6256L13.0444 19.2199L14.1562 18.7871L14.35 19.1755Z",
    fill: "#0000C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.872 17.1822L15.274 17.3419L15.197 16.6247L16.8677 16.5117L16.872 17.1822Z",
    fill: "#003CFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5038 17.993L11.4278 18.4803L11.1141 17.6644L12.2687 17.2018L12.5038 17.993Z",
    fill: "#0008FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8852 18.2136L15.4535 18.451L15.3605 17.9559L16.8782 17.7544L16.8852 18.2136Z",
    fill: "#0000FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0449 19.2201L12.1488 19.7423L11.7757 19.1788L12.7649 18.6715L13.0449 19.2201Z",
    fill: "#0000C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 15.8209L13.5101 16.0053L13.4001 15.0868L15.0772 14.95L15.1309 15.8209Z",
    fill: "#0090FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5096 16.006L12.0647 16.3164L11.897 15.3573L13.3995 15.0875L13.5096 16.006Z",
    fill: "#0084FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.868 16.512L15.1973 16.6251L15.131 15.8214L16.8653 15.7589L16.868 16.512Z",
    fill: "#0068FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2692 17.2021L11.1146 17.6647L10.8423 16.7503L12.0652 16.3164L12.2692 17.2021Z",
    fill: "#003CFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8923 18.5487L15.5501 18.8153L15.4525 18.4508L16.8842 18.2134L16.8923 18.5487Z",
    fill: "#0000F6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6508 19.0401L14.5483 19.4169L14.3506 19.1754L15.5508 18.8156L15.6508 19.0401Z",
    fill: "#0000D1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3373 19.6257L12.5382 20.1575L12.1484 19.7422L13.0446 19.22L13.3373 19.6257Z",
    fill: "#0000AD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5481 19.4167L13.6357 19.8778L13.3374 19.6254L14.3503 19.1753L14.5481 19.4167Z",
    fill: "#0000BB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8653 15.7587L15.131 15.8211L15.0773 14.9503L16.8641 14.941L16.8653 15.7587Z",
    fill: "#009CFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0648 16.316L10.8419 16.7499L10.6177 15.7586L11.8971 15.3569L12.0648 16.316Z",
    fill: "#0078FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9023 18.7515L15.651 19.0397L15.551 18.8152L16.8932 18.5486L16.9023 18.7515Z",
    fill: "#0000ED"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0772 14.9501L13.4001 15.0869L13.3171 14.1201L15.0373 14.0328L15.0772 14.9501Z",
    fill: "#00CCFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.456 17.6518L16.8775 17.7541L16.8718 17.1823L18.5219 17.1261L18.456 17.6518Z",
    fill: "#002CFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3998 15.0875L11.8972 15.3574L11.77 14.3477L13.3168 14.1207L13.3998 15.0875Z",
    fill: "#00C4FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3864 18.071L16.8845 18.2133L16.8774 17.7541L18.456 17.6519L18.3864 18.071Z",
    fill: "#0014FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5221 17.1263L16.872 17.1825L16.8677 16.512L18.5827 16.5068L18.5221 17.1263Z",
    fill: "#0050FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7753 19.1783L11.0201 19.7708L10.5916 19.0624L11.4277 18.4803L11.7753 19.1783Z",
    fill: "#0000DA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4281 18.4807L10.592 19.0628L10.2051 18.232L11.1144 17.6649L11.4281 18.4807Z",
    fill: "#0000FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6356 19.8777L12.9354 20.4134L12.5383 20.1571L13.3373 19.6253L13.6356 19.8777Z",
    fill: "#0000A4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1488 19.742L11.4804 20.3403L11.0205 19.771L11.7757 19.1785L12.1488 19.742Z",
    fill: "#0000B6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7507 19.1177L14.7452 19.5039L14.5483 19.4162L15.6508 19.0394L15.7507 19.1177Z",
    fill: "#0000D6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3152 18.3741L16.8929 18.5493L16.8848 18.214L18.3867 18.0718L18.3152 18.3741Z",
    fill: "#0004FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.583 16.5068L16.868 16.512L16.8652 15.7589L18.6369 15.8085L18.583 16.5068Z",
    fill: "#0078FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7453 19.5048L13.9328 19.9701L13.6361 19.878L14.5484 19.417L14.7453 19.5048Z",
    fill: "#0000BF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8641 14.9409L15.0773 14.9501L15.0374 14.0328L16.8646 14.0785L16.8641 14.9409Z",
    fill: "#00D8FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1142 17.6645L10.2049 18.2317L9.86899 17.2982L10.842 16.7501L11.1142 17.6645Z",
    fill: "#0034FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9113 18.8168L15.7501 19.1187L15.6502 19.0404L16.9015 18.7521L16.9113 18.8168Z",
    fill: "#0000F1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5385 20.1569L11.9606 20.7563L11.4803 20.34L12.1487 19.7417L12.5385 20.1569Z",
    fill: "#00009F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8974 15.3567L10.618 15.7584L10.4476 14.7136L11.7702 14.347L11.8974 15.3567Z",
    fill: "#00BCFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2435 18.5514L16.902 18.7517L16.8929 18.5489L18.3152 18.3737L18.2435 18.5514Z",
    fill: "#0000FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0374 14.0336L13.3172 14.1208L13.2634 13.129L15.0125 13.0921L15.0374 14.0336Z",
    fill: "#23FFD4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6364 15.8083L16.8648 15.7587L16.8636 14.941L18.6822 15.048L18.6364 15.8083Z",
    fill: "#00ACFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3171 14.1205L11.7703 14.3474L11.687 13.3114L13.2633 13.1287L13.3171 14.1205Z",
    fill: "#1CFFDB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9323 19.9696L13.3303 20.5036L12.9354 20.4133L13.6356 19.8776L13.9323 19.9696Z",
    fill: "#0000AD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.842 16.7502L9.86902 17.2983L9.59229 16.2841L10.6178 15.7589L10.842 16.7502Z",
    fill: "#0070FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8481 19.0475L14.9365 19.4354L14.7453 19.5046L15.7508 19.1183L15.8481 19.0475Z",
    fill: "#0000E8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9354 20.4139L12.4497 21.0095L11.9604 20.7569L12.5383 20.1575L12.9354 20.4139Z",
    fill: "#000096"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8642 14.0792L15.0371 14.0336L15.0122 13.0921L16.8664 13.1929L16.8642 14.0792Z",
    fill: "#26FFD1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1732 18.5993L16.9117 18.8162L16.9019 18.7514L18.2433 18.5511L18.1732 18.5993Z",
    fill: "#0000FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0163 17.6395L18.4562 17.6518L18.5221 17.1261L20.1429 17.1624L20.0163 17.6395Z",
    fill: "#0044FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8822 18.0164L18.3871 18.0711L18.4566 17.6519L20.0166 17.6396L19.8822 18.0164Z",
    fill: "#002CFF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9359 19.4357L14.2202 19.8984L13.9323 19.9701L14.7448 19.5048L14.9359 19.4357Z",
    fill: "#0000D1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6822 15.0486L16.8636 14.9416L16.8641 14.0792L18.7187 14.2449L18.6822 15.0486Z",
    fill: "#00E0FB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9218 18.7407L15.8477 19.0476L15.7503 19.1184L16.9115 18.8165L16.9218 18.7407Z",
    fill: "#0000FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1429 17.1627L18.5222 17.1263L18.5828 16.5068L20.2586 16.5968L20.1429 17.1627Z",
    fill: "#0064FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7699 14.3479L10.4473 14.7145L10.3353 13.6414L11.6866 13.3118L11.7699 14.3479Z",
    fill: "#19FFDE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7431 18.2835L18.3154 18.3735L18.3869 18.0711L19.8821 18.0164L19.7431 18.2835Z",
    fill: "#001CFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0205 19.7715L10.4977 20.4306L9.99838 19.7219L10.592 19.063L11.0205 19.7715Z",
    fill: "#0000D1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4799 20.3403L11.033 20.9956L10.4973 20.4302L11.02 19.771L11.4799 20.3403Z",
    fill: "#0000A8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0119 13.0915L13.2628 13.1284L13.2397 12.1359L15.0027 12.149L15.0119 13.0915Z",
    fill: "#5AFF9D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2582 16.5968L18.5824 16.5069L18.6362 15.8086L20.3601 15.9559L20.2582 16.5968Z",
    fill: "#008CFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5921 19.062L9.99848 19.721L9.54755 18.8857L10.2052 18.2313L10.5921 19.062Z",
    fill: "#0000FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6175 15.7588L9.59199 16.2839L9.38153 15.2129L10.4471 14.714L10.6175 15.7588Z",
    fill: "#00B8FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2636 13.1284L11.6874 13.311L11.6504 12.2739L13.2406 12.1359L13.2636 13.1284Z",
    fill: "#5AFF9D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6031 18.4339L18.2438 18.551L18.3156 18.3733L19.7432 18.2833L19.6031 18.4339Z",
    fill: "#0018FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2208 19.8979L13.714 20.4245L13.3309 20.5037L13.9329 19.9697L14.2208 19.8979Z",
    fill: "#0000BF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3302 20.5042L12.9361 21.0914L12.4496 21.0095L12.9352 20.4139L13.3302 20.5042Z",
    fill: "#00009B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9607 20.7561L11.593 21.4034L11.0335 20.9951L11.4804 20.3398L11.9607 20.7561Z",
    fill: "#000092"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1062 18.5161L16.9219 18.7403L16.9116 18.8161L18.1731 18.5992L18.1062 18.5161Z",
    fill: "#000CFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2054 18.2314L9.54774 18.8858L9.1561 17.9436L9.86944 17.2979L10.2054 18.2314Z",
    fill: "#002CFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8666 13.1922L15.0125 13.0914L15.0033 12.1489L16.8704 12.304L16.8666 13.1922Z",
    fill: "#5DFF9A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M18.719 14.2441L16.8644 14.0785L16.8666 13.1922L18.7453 13.4166L18.719 14.2441Z",
    fill: "#2CFFCA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.36 15.956L18.6361 15.8087L18.6818 15.0485L20.4455 15.2557L20.36 15.956Z",
    fill: "#00B8FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9405 18.8278L15.1172 19.2093L14.9365 19.4351L15.8482 19.0472L15.9405 18.8278Z",
    fill: "#0000FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9327 18.525L15.9403 18.828L15.848 19.0474L16.9222 18.7405L16.9327 18.525Z",
    fill: "#000CFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4647 18.4639L18.173 18.5992L18.2432 18.551L19.6025 18.4339L19.4647 18.4639Z",
    fill: "#0018FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1168 19.2095L14.4923 19.6627L14.2204 19.898L14.9361 19.4353L15.1168 19.2095Z",
    fill: "#0000F1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6865 13.3114L10.3352 13.6409L10.2849 12.5655L11.6496 12.2742L11.6865 13.3114Z",
    fill: "#56FFA0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4504 21.0091L12.1633 21.6447L11.5934 21.4038L11.9611 20.7565L12.4504 21.0091Z",
    fill: "#000089"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M9.869 17.298L9.15566 17.9437L8.83301 16.9168L9.59225 16.2838L9.869 17.298Z",
    fill: "#006CFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4473 14.7138L9.38171 15.2127L9.24316 14.1107L10.3353 13.6406L10.4473 14.7138Z",
    fill: "#16FFE1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4461 15.2554L18.6825 15.0482L18.719 14.2444L20.5131 14.5126L20.4461 15.2554Z",
    fill: "#06ECF1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0027 12.1491L13.2397 12.136L13.2484 11.1675L15.0096 11.2291L15.0027 12.1491Z",
    fill: "#94FF63"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0446 18.3029L16.9327 18.5249L16.9222 18.7403L18.1065 18.5162L18.0446 18.3029Z",
    fill: "#0024FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7134 20.4244L13.4081 20.9989L12.9362 21.0909L13.3303 20.5037L13.7134 20.4244Z",
    fill: "#0000AD"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2864 18.0385L19.882 18.0164L20.0165 17.6396L21.4727 17.7049L21.2864 18.0385Z",
    fill: "#0044FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4725 17.7052L20.0163 17.6399L20.1429 17.1627L21.6477 17.2775L21.4725 17.7052Z",
    fill: "#005CFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7455 13.4169L16.8669 13.1926L16.8707 12.3043L18.7609 12.586L18.7455 13.4169Z",
    fill: "#5DFF9A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2398 12.136L11.6496 12.274L11.6604 11.2615L13.2484 11.1675L13.2398 12.136Z",
    fill: "#94FF63"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3328 18.3721L18.1063 18.516L18.1732 18.5992L19.4648 18.4639L19.3328 18.3721Z",
    fill: "#0028FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4929 19.6627L14.0759 20.1762L13.7142 20.4245L14.221 19.898L14.4929 19.6627Z",
    fill: "#0000DF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0933 18.2696L19.7429 18.2835L19.8818 18.0164L21.2862 18.0385L21.0933 18.2696Z",
    fill: "#0038FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6472 17.2778L20.1424 17.163L20.2581 16.5972L21.8069 16.7664L21.6472 17.2778Z",
    fill: "#0078FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8704 12.3044L15.0033 12.1494L15.0101 11.2293L16.8757 11.4364L16.8704 12.3044Z",
    fill: "#90FF66"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12.936 21.0915L12.7288 21.712L12.1623 21.6452L12.4494 21.0096L12.936 21.0915Z",
    fill: "#00008D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0247 18.464L15.282 18.8311L15.1164 19.2094L15.9397 18.8279L16.0247 18.464Z",
    fill: "#001CFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8987 18.3924L19.6029 18.434L19.743 18.2834L21.0934 18.2695L20.8987 18.3924Z",
    fill: "#0034FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9428 18.1743L16.0249 18.4644L15.9399 18.8282L16.9323 18.5253L16.9428 18.1743Z",
    fill: "#0030FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8068 16.766L20.258 16.5968L20.3599 15.9559L21.9471 16.1833L21.8068 16.766Z",
    fill: "#00A0FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5132 14.5126L18.7191 14.2444L18.7454 13.4168L20.5598 13.7457L20.5132 14.5126Z",
    fill: "#33FFC4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59272 16.2838L8.83348 16.9168L8.58807 15.8293L9.38225 15.2129L9.59272 16.2838Z",
    fill: "#00B0FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4977 20.43L10.1891 21.1317L9.633 20.4331L9.99833 19.7213L10.4977 20.43Z",
    fill: "#0000C8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0332 20.9955L10.7854 21.6835L10.1888 21.1318L10.4974 20.4302L11.0332 20.9955Z",
    fill: "#0000A4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2823 18.8311L14.7411 19.268L14.4922 19.6626L15.1167 19.2093L15.2823 18.8311Z",
    fill: "#0008FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99848 19.7217L9.63314 20.4335L9.13086 19.6043L9.54756 18.8864L9.99848 19.7217Z",
    fill: "#0000FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6504 12.2743L10.2856 12.5656L10.2988 11.5147L11.6611 11.2618L11.6504 12.2743Z",
    fill: "#94FF63"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7072 18.4037L19.4653 18.4641L19.6031 18.434L20.8989 18.3924L20.7072 18.4037Z",
    fill: "#0034FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2099 18.1605L18.0444 18.3032L18.1064 18.5166L19.3329 18.3726L19.2099 18.1605Z",
    fill: "#003CFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M10.336 13.641L9.24386 14.111L9.18134 13.0047L10.2856 12.5656L10.336 13.641Z",
    fill: "#56FFA0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5926 21.4033L11.4081 22.0743L10.7853 21.6829L11.0331 20.9949L11.5926 21.4033Z",
    fill: "#000089"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9893 17.9635L16.9433 18.1737L16.9328 18.5246L18.0447 18.3026L17.9893 17.9635Z",
    fill: "#0044FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9477 16.183L20.3605 15.9555L20.4461 15.2552L22.0649 15.5433L21.9477 16.183Z",
    fill: "#00C8FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7603 12.5857L16.8701 12.304L16.8754 11.436L18.7642 11.7723L18.7603 12.5857Z",
    fill: "#90FF66"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0099 11.2294L13.2487 11.1678L13.2891 10.2479L15.0328 10.3553L15.0099 11.2294Z",
    fill: "#CAFF2C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0752 20.1763L13.8538 20.7338L13.4082 20.9991L13.7135 20.4246L14.0752 20.1763Z",
    fill: "#0000CD"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54767 18.8862L9.13097 19.6042L8.69467 18.6641L9.15601 17.944L9.54767 18.8862Z",
    fill: "#0028FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2491 11.1678L11.661 11.2619L11.7197 10.2998L13.2895 10.2479L13.2491 11.1678Z",
    fill: "#CEFF29"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8754 11.4365L15.0098 11.2294L15.0327 10.3553L16.8821 10.611L16.8754 11.4365Z",
    fill: "#C7FF30"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4085 20.999L13.279 21.6014L12.7295 21.7115L12.9366 21.091L13.4085 20.999Z",
    fill: "#00009F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5596 13.7458L18.7451 13.4169L18.7604 12.5859L20.5846 12.9739L20.5596 13.7458Z",
    fill: "#60FF97"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5227 18.3029L19.3327 18.3724L19.4647 18.4642L20.7066 18.4038L20.5227 18.3029Z",
    fill: "#0040FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7414 19.2681L14.4066 19.763L14.0755 20.1761L14.4925 19.6627L14.7414 19.2681Z",
    fill: "#0000FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1622 21.6444L12.0421 22.2959L11.4079 22.0745L11.5924 21.4034L12.1622 21.6444Z",
    fill: "#000080"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38181 15.213L8.58763 15.8294L8.42612 14.7076L9.24325 14.111L9.38181 15.213Z",
    fill: "#16FFE1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0648 15.543L20.446 15.2549L20.5129 14.5122L22.156 14.862L22.0648 15.543Z",
    fill: "#0FF8E7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9534 17.6949L16.1008 17.9632L16.0254 18.4639L16.9432 18.1738L16.9534 17.6949Z",
    fill: "#0058FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1006 17.9635L15.4285 18.3083L15.2824 18.8313L16.0252 18.4641L16.1006 17.9635Z",
    fill: "#0048FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0992 17.8325L17.9891 17.9641L18.0445 18.3032L19.2099 18.1604L19.0992 17.8325Z",
    fill: "#0058FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15573 17.944L8.69439 18.6641L8.33496 17.635L8.83308 16.917L9.15573 17.944Z",
    fill: "#0068FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5149 18.1245L21.2858 18.0382L21.4722 17.7047L22.7397 17.8335L22.5149 18.1245Z",
    fill: "#0060FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2829 18.3205L21.0938 18.2695L21.2867 18.0384L22.5157 18.1247L22.2829 18.3205Z",
    fill: "#0054FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7397 17.8339L21.4722 17.7051L21.6474 17.2775L22.9508 17.4549L22.7397 17.8339Z",
    fill: "#0074FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9413 17.5062L16.9527 17.6949L16.9426 18.1738L17.9886 17.9636L17.9413 17.5062Z",
    fill: "#006CFF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4285 18.3086L14.9606 18.7226L14.7412 19.2684L15.2824 18.8315L15.4285 18.3086Z",
    fill: "#0038FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3513 18.0913L19.2098 18.16L19.3328 18.3721L20.5228 18.3026L20.3513 18.0913Z",
    fill: "#0054FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7638 11.7726L16.875 11.4364L16.8817 10.6108L18.7561 10.9976L18.7638 11.7726Z",
    fill: "#C1FF36"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7294 21.712L12.6731 22.3419L12.0427 22.2967L12.1628 21.6451L12.7294 21.712Z",
    fill: "#000084"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2848 12.5651L9.18051 13.0043L9.19638 11.9212L10.298 11.5142L10.2848 12.5651Z",
    fill: "#97FF60"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0472 18.4163L20.8984 18.3924L21.0931 18.2695L22.2823 18.3206L22.0472 18.4163Z",
    fill: "#004CFF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M11.661 11.262L10.2987 11.5148L10.3758 10.515L11.7197 10.2999L11.661 11.262Z",
    fill: "#D1FF26"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9514 17.4545L21.6479 17.277L21.8077 16.7656L23.1437 16.9967L22.9514 17.4545Z",
    fill: "#0090FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1558 14.8623L20.5127 14.5125L20.5593 13.7456L22.2185 14.1567L22.1558 14.8623Z",
    fill: "#36FFC1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5847 12.9735L18.7606 12.5855L18.7645 11.7721L20.5872 12.2161L20.5847 12.9735Z",
    fill: "#8DFF6A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.033 10.3555L13.2894 10.2481L13.3609 9.4007L15.0715 9.54996L15.033 10.3555Z",
    fill: "#FFEA00"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4067 19.7628L14.2621 20.2996L13.8542 20.7335L14.0756 20.1759L14.4067 19.7628Z",
    fill: "#0000FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8152 18.4093L20.7064 18.4037L20.8981 18.3924L22.0468 18.4163L21.8152 18.4093Z",
    fill: "#0050FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8539 20.7337L13.7976 21.3154L13.2788 21.6013L13.4084 20.9989L13.8539 20.7337Z",
    fill: "#0000C4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1435 16.9966L21.8075 16.7656L21.9477 16.1829L23.3121 16.4713L23.1435 16.9966Z",
    fill: "#00B0FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M16.882 10.6108L15.0326 10.3551L15.0711 9.54962L16.8899 9.84916L16.882 10.6108Z",
    fill: "#FBF100"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0037 17.3963L17.9419 17.5066L17.9892 17.9641L19.0993 17.8326L19.0037 17.3963Z",
    fill: "#0080FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2894 10.2473L11.7196 10.2992L11.8253 9.41255L13.3609 9.3999L13.2894 10.2473Z",
    fill: "#FFE200"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24365 14.1113L8.42652 14.7079L8.3537 13.5789L9.18114 13.005L9.24365 14.1113Z",
    fill: "#53FFA4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83376 16.9163L8.33564 17.6344L8.06235 16.5408L8.58838 15.8289L8.83376 16.9163Z",
    fill: "#00B0FF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9609 18.722L14.6985 19.1934L14.4067 19.7628L14.7415 19.2679L14.9609 18.722Z",
    fill: "#002CFF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1967 17.7747L19.0991 17.8324L19.2099 18.1603L20.3514 18.0916L20.1967 17.7747Z",
    fill: "#0070FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7857 21.6834L10.733 22.3496L10.1115 21.8071L10.1892 21.1317L10.7857 21.6834Z",
    fill: "#00009F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1891 21.1312L10.1115 21.8067L9.53207 21.1156L9.63304 20.4326L10.1891 21.1312Z",
    fill: "#0000C8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9633 17.0992L16.1649 17.3372L16.1011 17.9633L16.9537 17.6951L16.9633 17.0992Z",
    fill: "#008CFF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5938 18.2996L20.5233 18.3028L20.7072 18.4038L21.816 18.4094L21.5938 18.2996Z",
    fill: "#005CFF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1647 17.3377L15.5516 17.6528L15.4289 18.3086L16.1009 17.9638L16.1647 17.3377Z",
    fill: "#007CFF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3118 16.4714L21.9474 16.183L22.0647 15.5433L23.4523 15.8914L23.3118 16.4714Z",
    fill: "#00D8FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4088 22.0749L11.3819 22.7305L10.7332 22.3497L10.786 21.6834L11.4088 22.0749Z",
    fill: "#000089"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2783 21.6012L13.2838 22.208L12.6725 22.3412L12.7289 21.7113L13.2783 21.6012Z",
    fill: "#00009B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2191 14.1571L20.5599 13.746L20.5849 12.9741L22.2515 13.4447L22.2191 14.1571Z",
    fill: "#63FF94"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63315 20.4332L9.53218 21.1163L9.00879 20.2929L9.13084 19.6041L9.63315 20.4332Z",
    fill: "#0000FA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9036 16.9414L16.9627 17.0995L16.9531 17.6953L17.9416 17.5066L17.9036 16.9414Z",
    fill: "#009CFF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7567 10.9975L16.8823 10.6107L16.8903 9.84912L18.7374 10.281L18.7567 10.9975Z",
    fill: "#F1FC06"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 12.2164L18.7643 11.7724L18.7565 10.9974L20.5669 11.4929L20.587 12.2164Z",
    fill: "#BEFF39"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5516 17.6526L15.1449 18.0376L14.9609 18.7225L15.4288 18.3085L15.5516 17.6526Z",
    fill: "#0070FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0429 22.2962L12.0423 22.9403L11.3818 22.7305L11.4087 22.0748L12.0429 22.2962Z",
    fill: "#000080"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3863 18.0897L20.3516 18.0918L20.5231 18.3031L21.5936 18.2999L21.3863 18.0897Z",
    fill: "#006CFF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2984 11.5146L9.19678 11.9216L9.29156 10.8894L10.3755 10.5148L10.2984 11.5146Z",
    fill: "#D4FF23"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4523 15.8921L22.0646 15.544L22.1558 14.8629L23.5612 15.2718L23.4523 15.8921Z",
    fill: "#19FFDE"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7191 10.2995L10.3752 10.5146L10.5151 9.59205L11.8249 9.4129L11.7191 10.2995Z",
    fill: "#FFDB00"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13057 19.6035L9.00852 20.2923L8.55389 19.3558L8.69428 18.6634L9.13057 19.6035Z",
    fill: "#0024FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0624 17.3597L19.0031 17.3963L19.0987 17.8325L20.1963 17.7749L20.0624 17.3597Z",
    fill: "#0094FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9256 16.8616L17.9037 16.9411L17.9417 17.5063L19.0035 17.396L18.9256 16.8616Z",
    fill: "#00ACFF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0716 9.55006L13.361 9.40079L13.4622 8.64874L15.125 8.83484L15.0716 9.55006Z",
    fill: "#FFB200"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58742 15.8294L8.06139 16.5412L7.88168 15.4092L8.42592 14.7075L8.58742 15.8294Z",
    fill: "#13FCE4"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2614 20.2999L14.2722 20.8589L13.7972 21.3154L13.8536 20.7337L14.2614 20.2999Z",
    fill: "#0000F1"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8905 9.84905L15.0716 9.54951L15.125 8.83429L16.8994 9.17175L16.8905 9.84905Z",
    fill: "#FFBD00"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6984 19.1932L14.6214 19.706L14.2619 20.2994L14.4066 19.7626L14.6984 19.1932Z",
    fill: "#0020FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22.251 13.4444L20.5843 12.9739L20.5869 12.2164L22.2521 12.7432L22.251 13.4444Z",
    fill: "#8DFF6A"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2321 18.4247L22.2827 18.3205L22.5155 18.1246L23.4914 18.2623L23.2321 18.4247Z",
    fill: "#006CFF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4913 18.2628L22.5155 18.1251L22.7403 17.8341L23.7416 18.0121L23.4913 18.2628Z",
    fill: "#0078FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18114 13.005L8.3537 13.5789L8.37238 12.4709L9.19701 11.9219L9.18114 13.005Z",
    fill: "#97FF60"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9701 18.4952L22.0475 18.4165L22.2827 18.3208L23.232 18.425L22.9701 18.4952Z",
    fill: "#0068FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7414 18.0119L22.7401 17.8339L22.9512 17.4549L23.9764 17.6792L23.7414 18.0119Z",
    fill: "#008CFF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3609 9.3998L11.8254 9.41245L11.9761 8.62512L13.4621 8.64774L13.3609 9.3998Z",
    fill: "#FFA700"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9717 16.4002L16.215 16.6L16.1646 17.3368L16.9629 17.0988L16.9717 16.4002Z",
    fill: "#00C4FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6728 22.3414L12.6982 22.9731L12.0418 22.9402L12.0425 22.2962L12.6728 22.3414Z",
    fill: "#000084"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7976 21.3156L13.8613 21.8984L13.2843 22.2083L13.2788 21.6015L13.7976 21.3156Z",
    fill: "#0000BB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1993 17.7836L20.197 17.7747L20.3517 18.0916L21.3864 18.0895L21.1993 17.7836Z",
    fill: "#0084FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1444 18.0376L14.9427 18.4808L14.6981 19.1939L14.9605 18.7225L15.1444 18.0376Z",
    fill: "#0068FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5612 15.271L22.1558 14.8621L22.2185 14.1566L23.6354 14.6257L23.5612 15.271Z",
    fill: "#3CFFBA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8761 16.2822L16.9717 16.4011L16.9629 17.0997L17.9037 16.9416L17.8761 16.2822Z",
    fill: "#00D0FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69444 18.6638L8.55406 19.3562L8.17953 18.3288L8.335 17.6348L8.69444 18.6638Z",
    fill: "#0064FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7117 18.4712L21.8156 18.4095L22.0472 18.4164L22.9698 18.4952L22.7117 18.4712Z",
    fill: "#0068FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2145 16.6004L15.6468 16.8788L15.551 17.6523L16.1641 17.3372L16.2145 16.6004Z",
    fill: "#00B8FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M23.976 17.6788L22.9509 17.4545L23.1431 16.9967L24.1898 17.2722L23.976 17.6788Z",
    fill: "#00A4FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5666 11.4932L18.7563 10.9977L18.737 10.2812L20.5241 10.8225L20.5666 11.4932Z",
    fill: "#EBFF0C"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7376 10.2812L16.8905 9.8493L16.8995 9.172L18.7071 9.64246L18.7376 10.2812Z",
    fill: "#FFC800"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9535 16.856L18.9258 16.8618L19.0037 17.3962L20.063 17.3596L19.9535 16.856Z",
    fill: "#00BCFF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4642 18.3535L21.5934 18.2996L21.8157 18.4094L22.7118 18.4711L22.4642 18.3535Z",
    fill: "#0074FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1895 17.2726L23.1429 16.9971L23.3115 16.4718L24.3767 16.8021L24.1895 17.2726Z",
    fill: "#00C4FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8675 16.2423L17.876 16.282L17.9037 16.9414L18.9256 16.8619L18.8675 16.2423Z",
    fill: "#00DCFE"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6474 16.8787L15.2881 17.229L15.1449 18.0371L15.5515 17.6522L15.6474 16.8787Z",
    fill: "#00B0FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2518 12.7432L20.5866 12.2165L20.5664 11.493L22.2215 12.0713L22.2518 12.7432Z",
    fill: "#B7FF40"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0368 17.3893L20.0627 17.3597L20.1966 17.7749L21.1989 17.7837L21.0368 17.3893Z",
    fill: "#00A4FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6354 14.626L22.2184 14.1569L22.2509 13.4445L23.6731 13.9721L23.6354 14.626Z",
    fill: "#63FF94"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2846 22.2083L13.3352 22.8274L12.6987 22.9733L12.6733 22.3415L13.2846 22.2083Z",
    fill: "#000096"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42609 14.7077L7.88185 15.4094L7.80112 14.2667L8.35326 13.5787L8.42609 14.7077Z",
    fill: "#53FFA4"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3752 10.5145L9.2912 10.8891L9.46349 9.93454L10.515 9.59192L10.3752 10.5145Z",
    fill: "#FFD700"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1247 8.83444L13.4619 8.64834L13.5904 8.01233L15.1917 8.22913L15.1247 8.83444Z",
    fill: "#FF7A00"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8249 9.41247L10.5151 9.59162L10.715 8.77106L11.9756 8.62512L11.8249 9.41247Z",
    fill: "#FF9C00"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M16.899 9.17157L15.1245 8.83411L15.1914 8.22882L16.9089 8.59717L16.899 9.17157Z",
    fill: "#FF8900"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2329 18.145L21.3859 18.0897L21.5932 18.2999L22.464 18.3537L22.2329 18.145Z",
    fill: "#0084FF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M10.733 22.3496L10.8084 22.958L10.1881 22.4165L10.1115 21.8071L10.733 22.3496Z",
    fill: "#00009F"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3774 16.8019L23.3122 16.4716L23.4527 15.8916L24.5332 16.279L24.3774 16.8019Z",
    fill: "#00E4F8"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1114 21.8073L10.1881 22.4166L9.60985 21.7272L9.53207 21.1162L10.1114 21.8073Z",
    fill: "#0000C8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6214 19.7067L14.6913 20.2415L14.2726 20.8591L14.2619 20.3001L14.6214 19.7067Z",
    fill: "#0018FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33489 17.6347L8.17943 18.3287L7.89471 17.2345L8.0616 16.541L8.33489 17.6347Z",
    fill: "#00ACFF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3811 22.73L11.4553 23.3382L10.8078 22.9575L10.7324 22.3491L11.3811 22.73Z",
    fill: "#000089"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9431 18.4811L14.923 18.967L14.6216 19.707L14.6985 19.1942L14.9431 18.4811Z",
    fill: "#005CFF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9795 15.6165L16.2506 15.7711L16.215 16.6006L16.9718 16.4008L16.9795 15.6165Z",
    fill: "#16FFE1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M14.273 20.859L14.39 21.4176L13.8618 21.8983L13.798 21.3155L14.273 20.859Z",
    fill: "#0000ED"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5244 10.8224L18.7373 10.2811L18.7069 9.6424L20.4604 10.2224L20.5244 10.8224Z",
    fill: "#FFD700"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8598 15.5449L16.9796 15.6168L16.9719 16.4011L17.8762 16.2822L17.8598 15.5449Z",
    fill: "#1CFFDB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19704 11.9214L8.37241 12.4704L8.48321 11.4117L9.29183 10.8892L9.19704 11.9214Z",
    fill: "#D7FF1F"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53219 21.116L9.60997 21.727L9.08767 20.906L9.00879 20.2926L9.53219 21.116Z",
    fill: "#0000FA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8718 16.2762L18.868 16.2423L18.9261 16.8619L19.9539 16.856L19.8718 16.2762Z",
    fill: "#02E8F4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 8.64834L11.9759 8.62572L12.1682 7.95947L13.5904 8.01235L13.4619 8.64834Z",
    fill: "#FF6F00"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7071 9.64233L16.8994 9.17187L16.9093 8.59747L18.6662 9.09879L18.7071 9.64233Z",
    fill: "#FF9800"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2511 15.7711L15.714 16.0069L15.6478 16.879L16.2155 16.6006L16.2511 15.7711Z",
    fill: "#13FCE4"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0243 17.85L21.1987 17.7837L21.3858 18.0896L22.2328 18.1449L22.0243 17.85Z",
    fill: "#009CFF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2881 17.2295L15.1335 17.6406L14.9431 18.4808L15.1448 18.0376L15.2881 17.2295Z",
    fill: "#00A8FF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9046 16.9159L19.9536 16.856L20.0631 17.3596L21.0373 17.3892L20.9046 16.9159Z",
    fill: "#00CCFF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5334 16.2793L23.453 15.8918L23.5619 15.2715L24.6537 15.717L24.5334 16.2793Z",
    fill: "#1FFFD7"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0415 22.9398L12.1145 23.5484L11.4553 23.3381L11.381 22.73L12.0415 22.9398Z",
    fill: "#000080"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6731 13.9726L22.251 13.445L22.2521 12.7438L23.6729 13.3265L23.6731 13.9726Z",
    fill: "#8DFF6A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2217 12.0714L20.5666 11.4931L20.5241 10.8224L22.1603 11.4463L22.2217 12.0714Z",
    fill: "#E1FF16"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8311 15.5522L17.8597 15.5441L17.8762 16.2814L18.8677 16.2417L18.8311 15.5522Z",
    fill: "#23FFD4"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00854 20.2932L9.08741 20.9065L8.6338 19.9731L8.55389 19.3568L9.00854 20.2932Z",
    fill: "#0024FF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8755 18.5719L23.2316 18.4255L23.4909 18.263L24.1492 18.44L23.8755 18.5719Z",
    fill: "#0084FF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8616 21.8983L13.9359 22.5047L13.3351 22.8273L13.2845 22.2082L13.8616 21.8983Z",
    fill: "#0000BB"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5989 18.6184L22.9696 18.4951L23.2315 18.4249L23.8754 18.5714L23.5989 18.6184Z",
    fill: "#0080FF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1495 18.4392L23.4912 18.2622L23.7415 18.0115L24.4136 18.2256L24.1495 18.4392Z",
    fill: "#0090FF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3265 18.5794L22.7116 18.4713L22.9696 18.4953L23.5989 18.6185L23.3265 18.5794Z",
    fill: "#0084FF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4132 18.2255L23.7411 18.0114L23.976 17.6787L24.661 17.9355L24.4132 18.2255Z",
    fill: "#00A0FF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7135 16.0071L15.3864 16.318L15.2881 17.2296L15.6474 16.8793L15.7135 16.0071Z",
    fill: "#0CF4EB"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06151 16.5418L7.89463 17.2353L7.70752 16.1006L7.8818 15.4098L8.06151 16.5418Z",
    fill: "#13FCE4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8438 17.4756L21.0368 17.389L21.1988 17.7833L22.0244 17.8496L21.8438 17.4756Z",
    fill: "#00B8FF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9087 8.5976L15.1913 8.22925L15.2702 7.7511L16.9191 8.14232L16.9087 8.5976Z",
    fill: "#FF6000"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M24.653 15.7169L23.5612 15.2714L23.6355 14.6261L24.7346 15.1294L24.653 15.7169Z",
    fill: "#43FFB4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35326 13.5783L7.80112 14.2663L7.82252 13.1414L8.37194 12.4703L8.35326 13.5783Z",
    fill: "#97FF60"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6982 22.9728L12.7702 23.5826L12.1149 23.5486L12.0418 22.9399L12.6982 22.9728Z",
    fill: "#000084"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1918 8.2296L13.5905 8.01281L13.7433 7.51105L15.2707 7.75145L15.1918 8.2296Z",
    fill: "#FF4E00"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4606 10.2223L18.7071 9.64229L18.6662 9.09875L20.3767 9.70935L20.4606 10.2223Z",
    fill: "#FFAB00"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0652 18.4547L22.4642 18.3533L22.7118 18.471L23.3267 18.5791L23.0652 18.4547Z",
    fill: "#008CFF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8185 15.6348L18.8306 15.553L18.8672 16.2425L19.8709 16.2764L19.8185 15.6348Z",
    fill: "#2CFFCA"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6612 17.936L23.9763 17.6792L24.19 17.2726L24.8865 17.5767L24.6612 17.936Z",
    fill: "#00B8FF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5152 9.59214L9.46371 9.93476L9.71007 9.08366L10.7151 8.77161L10.5152 9.59214Z",
    fill: "#FF9400"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9759 8.62573L10.7153 8.77167L10.9707 8.07593L12.1682 7.95947L11.9759 8.62573Z",
    fill: "#FF6400"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8039 16.3747L19.8706 16.2757L19.9527 16.8555L20.9037 16.9154L20.8039 16.3747Z",
    fill: "#0CF4EB"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8546 14.7474L16.9857 14.7658L16.9792 15.6159L17.8593 15.544L17.8546 14.7474Z",
    fill: "#50FFA7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9854 14.7661L16.2696 14.8696L16.25 15.7709L16.9789 15.6162L16.9854 14.7661Z",
    fill: "#4DFFAA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6736 13.3263L22.2529 12.7435L22.2225 12.0716L23.6353 12.7049L23.6736 13.3263Z",
    fill: "#B4FF43"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M14.923 18.9669L15.0426 19.4767L14.6915 20.2417L14.6216 19.7069L14.923 18.9669Z",
    fill: "#0058FF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6653 9.09833L16.9084 8.59701L16.9188 8.14172L18.615 8.66521L18.6653 9.09833Z",
    fill: "#FF6F00"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55406 19.3564L8.63396 19.9727L8.26036 18.9488L8.17953 18.3289L8.55406 19.3564Z",
    fill: "#0068FF"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1608 11.4457L20.5246 10.8218L20.4606 10.2218L22.0697 10.8841L22.1608 11.4457Z",
    fill: "#FFE200"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6912 20.2413L14.8553 20.7763L14.3895 21.4176L14.2725 20.859L14.6912 20.2413Z",
    fill: "#0014FF"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1332 17.6404L15.1574 18.0973L14.9227 18.9666L14.9428 18.4807L15.1332 17.6404Z",
    fill: "#00A0FF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8211 18.2484L22.2331 18.145L22.4641 18.3538L23.0651 18.4551L22.8211 18.2484Z",
    fill: "#009CFF"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M18.817 14.811L17.8548 14.7482L17.8596 15.5448L18.8309 15.553L18.817 14.811Z",
    fill: "#53FFA4"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8859 17.5769L24.1895 17.2728L24.3766 16.8022L25.0829 17.1572L24.8859 17.5769Z",
    fill: "#00D4FF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5903 8.01266L12.168 7.95979L12.3972 7.43372L13.7431 7.51089L13.5903 8.01266Z",
    fill: "#FF3F00"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29171 10.8891L8.48309 11.4117L8.68438 10.4299L9.46399 9.93457L9.29171 10.8891Z",
    fill: "#FFD300"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2704 14.8694L15.7481 15.0575L15.7137 16.0065L16.2508 15.7707L16.2704 14.8694Z",
    fill: "#49FFAD"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6957 17.0312L20.9041 16.9153L21.0368 17.3887L21.8438 17.4753L21.6957 17.0312Z",
    fill: "#00DCFE"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7352 15.1299L23.6361 14.6266L23.6737 13.9727L24.7758 14.532L24.7352 15.1299Z",
    fill: "#66FF90"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3857 16.3172L15.2632 16.6929L15.1327 17.6399L15.2873 17.2288L15.3857 16.3172Z",
    fill: "#09F0EE"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M13.335 22.8276L13.4059 23.4394L12.7705 23.5834L12.6986 22.9735L13.335 22.8276Z",
    fill: "#00009B"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3898 21.4173L14.4857 22.0114L13.9358 22.5044L13.8615 21.8979L14.3898 21.4173Z",
    fill: "#0000E8"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M22.601 17.9637L22.0247 17.8496L22.2333 18.1445L22.8213 18.2479L22.601 17.9637Z",
    fill: "#00B0FF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M25.083 17.1567L24.3766 16.8018L24.5324 16.2789L25.2466 16.6869L25.083 17.1567Z",
    fill: "#0CF4EB"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7403 15.7803L19.8185 15.6344L19.871 16.276L20.8043 16.375L20.7403 15.7803Z",
    fill: "#33FFC4"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7975 14.9474L18.8167 14.8109L18.8307 15.5528L19.8186 15.6345L19.7975 14.9474Z",
    fill: "#56FFA0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9191 8.14232L15.2702 7.7511L15.3591 7.41418L16.9299 7.81946L16.9191 8.14232Z",
    fill: "#FF3B00"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8082 22.9581L10.9247 23.5041L10.3109 22.9682L10.188 22.4166L10.8082 22.9581Z",
    fill: "#0000A8"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6348 12.705L22.222 12.0717L22.1606 11.4466L23.559 12.1245L23.6348 12.705Z",
    fill: "#D7FF1F"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3766 9.70956L18.6661 9.09897L18.6157 8.66583L20.2747 9.29793L20.3766 9.70956Z",
    fill: "#FF8600"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1884 22.4167L10.3114 22.9683L9.73925 22.2864L9.6102 21.7274L10.1884 22.4167Z",
    fill: "#0000CD"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88185 15.4091L7.70757 16.1L7.62372 14.9526L7.80112 14.2664L7.88185 15.4091Z",
    fill: "#53FFA4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7481 15.0582L15.4368 15.3259L15.3866 16.3181L15.7137 16.0072L15.7481 15.0582Z",
    fill: "#46FFB1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2709 7.75085L13.7435 7.51045L13.9168 7.15784L15.3598 7.41393L15.2709 7.75085Z",
    fill: "#FF2900"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17943 18.3293L8.26025 18.9492L7.97634 17.859L7.89471 17.2352L8.17943 18.3293Z",
    fill: "#00B0FF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8619 13.9128L16.9907 13.8726L16.9857 14.7666L17.8546 14.7482L17.8619 13.9128Z",
    fill: "#80FF77"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4556 23.3385L11.5654 23.8809L10.9246 23.5038L10.8081 22.9578L11.4556 23.3385Z",
    fill: "#000092"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0699 10.8844L20.4608 10.2221L20.3768 9.70911L21.9513 10.4015L22.0699 10.8844Z",
    fill: "#FFB900"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9911 13.8726L16.2733 13.9203L16.2704 14.87L16.9861 14.7666L16.9911 13.8726Z",
    fill: "#80FF77"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5839 16.5284L20.804 16.375L20.9038 16.9157L21.6954 17.0316L21.5839 16.5284Z",
    fill: "#16FFE1"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6159 8.6658L16.9198 8.14232L16.9305 7.81946L18.5573 8.35562L18.6159 8.6658Z",
    fill: "#FF4E00"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M24.775 14.5318L23.673 13.9725L23.6727 13.3265L24.7733 13.9386L24.775 14.5318Z",
    fill: "#8AFF6D"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37169 12.4703L7.82227 13.1414L7.94651 12.063L8.4825 11.4116L8.37169 12.4703Z",
    fill: "#D7FF1F"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61003 21.7273L9.73908 22.2864L9.2224 21.4746L9.08774 20.9062L9.61003 21.7273Z",
    fill: "#0000FF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4101 17.6095L21.8441 17.4761L22.0247 17.8501L22.601 17.9642L22.4101 17.6095Z",
    fill: "#00C8FF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8263 14.0354L17.862 13.9124L17.8548 14.7478L18.817 14.8107L18.8263 14.0354Z",
    fill: "#80FF77"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2471 16.6868L24.5329 16.2788L24.6532 15.7166L25.3731 16.1785L25.2471 16.6868Z",
    fill: "#29FFCE"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1675 7.95898L10.9701 8.07544L11.2749 7.52453L12.3968 7.43292L12.1675 7.95898Z",
    fill: "#FF3000"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7154 8.77154L9.7103 9.08359L10.0252 8.35959L10.9707 8.07581L10.7154 8.77154Z",
    fill: "#FF5900"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8869 18.7776L23.5995 18.6184L23.876 18.5714L24.1679 18.751L23.8869 18.7776Z",
    fill: "#0098FF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1672 18.7511L23.8753 18.5715L24.1491 18.4396L24.4453 18.6462L24.1672 18.7511Z",
    fill: "#009CFF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1152 23.5489L12.2183 24.09L11.5657 23.8811L11.4559 23.3387L12.1152 23.5489Z",
    fill: "#000084"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6098 18.7256L23.3268 18.5796L23.5993 18.6187L23.8867 18.7779L23.6098 18.7256Z",
    fill: "#0098FF"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2732 13.9197L15.7492 14.0563L15.7479 15.0575L16.2702 14.8695L16.2732 13.9197Z",
    fill: "#80FF77"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4459 18.6466L24.1496 18.44L24.4137 18.2264L24.714 18.466L24.4459 18.6466Z",
    fill: "#00A4FF"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1574 18.097L15.316 18.5813L15.0424 19.476L14.9227 18.9663L15.1574 18.097Z",
    fill: "#009CFF"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9357 22.5045L14.0057 23.1188L13.4059 23.4388L13.335 22.8271L13.9357 22.5045Z",
    fill: "#0000BB"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0427 19.4764L15.2464 19.9887L14.8557 20.7764L14.6916 20.2414L15.0427 19.4764Z",
    fill: "#0054FF"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7425 7.50993L12.3967 7.43276L12.6572 7.06262L13.9158 7.15733L13.7425 7.50993Z",
    fill: "#FF1600"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7138 15.1471L19.7974 14.9476L19.8185 15.6347L20.7402 15.7806L20.7138 15.1471Z",
    fill: "#5AFF9D"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3434 18.5954L23.0648 18.4551L23.3263 18.5795L23.6092 18.7255L23.3434 18.5954Z",
    fill: "#00A0FF"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08725 20.9062L9.22191 21.4745L8.7733 20.5519L8.63364 19.9728L9.08725 20.9062Z",
    fill: "#0028FF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M15.264 16.6932L15.3188 17.1194L15.1577 18.097L15.1335 17.6402L15.264 16.6932Z",
    fill: "#06ECF1"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5589 12.1246L22.1606 11.4466L22.0695 10.8851L23.4474 11.6005L23.5589 12.1246Z",
    fill: "#FBF100"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8085 14.2329L18.826 14.0361L18.8167 14.8114L19.7975 14.9479L19.8085 14.2329Z",
    fill: "#80FF77"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7136 18.4655L24.4133 18.2258L24.6611 17.9359L24.9651 18.2136L24.7136 18.4655Z",
    fill: "#00B4FF"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2536 17.1927L21.696 17.0317L21.844 17.4758L22.4101 17.6093L22.2536 17.1927Z",
    fill: "#02E8F4"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2747 9.29805L18.6157 8.66595L18.5571 8.35577L20.1575 8.99951L20.2747 9.29805Z",
    fill: "#FF6400"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46369 9.93441L8.68408 10.4297L8.97182 9.55132L9.71004 9.08331L9.46369 9.93441Z",
    fill: "#FF9100"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3732 16.1793L24.6533 15.7174L24.7349 15.1299L25.4583 15.6455L25.3732 16.1793Z",
    fill: "#46FFB1"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5127 15.9785L20.7406 15.7801L20.8046 16.3748L21.5845 16.5282L21.5127 15.9785Z",
    fill: "#39FFBE"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9296 7.81908L15.3589 7.41381L15.4555 7.22864L16.9404 7.63855L16.9296 7.81908Z",
    fill: "#FF2200"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7734 13.9382L23.6728 13.3261L23.6345 12.7047L24.7292 13.3653L24.7734 13.9382Z",
    fill: "#ADFF49"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4364 15.3252L15.3301 15.663L15.2637 16.6931L15.3861 16.3174L15.4364 15.3252Z",
    fill: "#43FFB4"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M23.096 18.3909L22.8215 18.2484L23.0655 18.4551L23.344 18.5955L23.096 18.3909Z",
    fill: "#00B0FF"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9515 10.4014L20.377 9.709L20.2751 9.29736L21.8083 10.0106L21.9515 10.4014Z",
    fill: "#FF9800"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8554 20.776L14.9705 21.3586L14.4856 22.0115L14.3896 21.4173L14.8554 20.776Z",
    fill: "#0014FF"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8808 13.0602L16.994 12.9578L16.9906 13.8721L17.8617 13.9123L17.8808 13.0602Z",
    fill: "#B4FF43"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9655 18.2132L24.6615 17.9355L24.8867 17.5762L25.194 17.8962L24.9655 18.2132Z",
    fill: "#00C8FF"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7703 23.5827L12.8668 24.1245L12.2182 24.0897L12.1151 23.5486L12.7703 23.5827Z",
    fill: "#00008D"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5571 8.35549L16.9304 7.81932L16.9411 7.63879L18.4918 8.17764L18.5571 8.35549Z",
    fill: "#FF3800"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89463 17.2346L7.97625 17.8584L7.78979 16.7281L7.70752 16.0999L7.89463 17.2346Z",
    fill: "#13FCE4"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8589 13.2473L17.8812 13.0604L17.8622 13.9125L18.8264 14.0355L18.8589 13.2473Z",
    fill: "#ADFF49"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9941 12.9583L16.259 12.9473L16.2729 13.9203L16.9907 13.8726L16.9941 12.9583Z",
    fill: "#B7FF40"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M15.359 7.4134L13.916 7.1573L14.1053 6.96497L15.4556 7.22823L15.359 7.4134Z",
    fill: "#F60B00"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7488 14.0565L15.4364 14.2781L15.4362 15.3253L15.7475 15.0577L15.7488 14.0565Z",
    fill: "#80FF77"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80112 14.2666L7.62372 14.9528L7.64641 13.8214L7.82252 13.1417L7.80112 14.2666Z",
    fill: "#97FF60"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8716 18.1161L22.6009 17.9635L22.8212 18.2477L23.0957 18.3902L22.8716 18.1161Z",
    fill: "#00C0FF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63452 19.9722L8.77418 20.5513L8.40484 19.5395L8.26093 18.9482L8.63452 19.9722Z",
    fill: "#0068FF"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1355 16.7249L21.5845 16.5288L21.696 17.032L22.2535 17.193L22.1355 16.7249Z",
    fill: "#1FFFD7"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1933 17.8968L24.8861 17.5768L25.0831 17.157L25.3929 17.5226L25.1933 17.8968Z",
    fill: "#00E0FB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M20.726 14.4907L19.8084 14.2322L19.7974 14.9472L20.7138 15.1468L20.726 14.4907Z",
    fill: "#80FF77"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4581 15.6445L24.7347 15.1289L24.7753 14.5309L25.4996 15.0986L25.4581 15.6445Z",
    fill: "#66FF90"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4472 11.6L22.0692 10.8846L21.9507 10.4017L23.3027 11.1463L23.4472 11.6Z",
    fill: "#FFCC00"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8521 13.5084L18.859 13.2476L18.8265 14.0357L19.809 14.2325L19.8521 13.5084Z",
    fill: "#AAFF4D"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2592 12.9473L15.717 13.03L15.7491 14.0569L16.2731 13.9203L16.2592 12.9473Z",
    fill: "#BAFF3C"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4822 15.3966L20.7137 15.147L20.7401 15.7805L21.5122 15.9789L21.4822 15.3966Z",
    fill: "#5AFF9D"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1577 8.99915L18.5574 8.35542L18.492 8.17755L20.0282 8.82256L20.1577 8.99915Z",
    fill: "#FF4E00"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48277 11.412L7.94678 12.0633L8.17198 11.0598L8.68406 10.4302L8.48277 11.412Z",
    fill: "#FFD000"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7293 13.3655L23.6346 12.705L23.5588 12.1245L24.6435 12.8278L24.7293 13.3655Z",
    fill: "#D1FF26"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3971 7.43276L11.2752 7.52437L11.622 7.13479L12.6576 7.06262L12.3971 7.43276Z",
    fill: "#F10800"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6771 17.7798L22.4097 17.6095L22.6006 17.9642L22.8713 18.1168L22.6771 17.7798Z",
    fill: "#00D8FF"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4855 22.0122L14.5547 22.6297L14.0055 23.1195L13.9355 22.5051L14.4855 22.0122Z",
    fill: "#0000ED"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8076 10.0113L20.2743 9.29805L20.1571 8.99951L21.6435 9.72365L21.8076 10.0113Z",
    fill: "#FF7A00"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9165 7.15801L12.6579 7.0633L12.943 6.86084L14.1058 6.96567L13.9165 7.15801Z",
    fill: "#DF0000"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M17.912 12.2143L16.9963 12.048L16.9946 12.9579L17.8815 13.0603L17.912 12.2143Z",
    fill: "#E4FF13"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9407 7.63872L15.4557 7.22881L15.5575 7.20178L16.9512 7.6066L16.9407 7.63872Z",
    fill: "#FA0F00"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9707 8.07582L10.0252 8.35961L10.4013 7.78355L11.2756 7.5249L10.9707 8.07582Z",
    fill: "#FF2500"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3928 17.522L25.083 17.1565L25.2467 16.6866L25.5583 17.0997L25.3928 17.522Z",
    fill: "#16FFE1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4056 23.4388L13.4956 23.9835L12.8666 24.1246L12.7702 23.5828L13.4056 23.4388Z",
    fill: "#00009F"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4916 8.17723L16.9409 7.63839L16.9514 7.60626L18.4213 8.13743L18.4916 8.17723Z",
    fill: "#FF2500"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9134 12.4677L17.9114 12.2148L17.8809 13.0609L18.8585 13.2478L18.9134 12.4677Z",
    fill: "#DBFF1C"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9955 12.0484L16.228 11.9772L16.2586 12.9473L16.9938 12.9583L16.9955 12.0484Z",
    fill: "#EBFF0C"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3181 17.1196L15.5037 17.5788L15.3157 18.5816L15.1571 18.0973L15.3181 17.1196Z",
    fill: "#02E8F4"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0595 16.2167L21.5129 15.9786L21.5847 16.5284L22.1357 16.7245L22.0595 16.2167Z",
    fill: "#3CFFBA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M15.316 18.582L15.5508 19.0733L15.246 19.9891L15.0423 19.4768L15.316 18.582Z",
    fill: "#0098FF"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3301 15.6629L15.4006 16.0576L15.3184 17.1191L15.2637 16.693L15.3301 15.6629Z",
    fill: "#43FFB4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M15.456 7.2283L14.1057 6.96504L14.306 6.93976L15.5577 7.20128L15.456 7.2283Z",
    fill: "#DF0000"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9247 23.5043L11.0388 23.9618L10.4367 23.436L10.3109 22.9684L10.9247 23.5043Z",
    fill: "#0000B2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 15.0985L24.7755 14.5308L24.7738 13.9376L25.4966 14.5545L25.4998 15.0985Z",
    fill: "#8AFF6D"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3109 22.9683L10.4367 23.436L9.87558 22.7674L9.73877 22.2864L10.3109 22.9683Z",
    fill: "#0000DA"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7771 13.829L19.8519 13.5079L19.8088 14.232L20.7264 14.4905L20.7771 13.829Z",
    fill: "#A7FF50"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4362 14.2778L15.3296 14.5764L15.3298 15.6629L15.436 15.325L15.4362 14.2778Z",
    fill: "#80FF77"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M22.518 17.3882L22.2534 17.1929L22.41 17.6094L22.6774 17.7797L22.518 17.3882Z",
    fill: "#0CF4EB"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M23.807 18.9659L23.8863 18.7771L24.1673 18.7505L24.0848 18.9568L23.807 18.9659Z",
    fill: "#00A8FF"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3026 11.1465L21.9506 10.4018L21.8075 10.011L23.1287 10.7758L23.3026 11.1465Z",
    fill: "#FFAB00"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25999 18.9487L8.40391 19.54L8.12341 18.463L7.97607 17.8585L8.25999 18.9487Z",
    fill: "#00B0FF"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9264 12.7941L18.914 12.4671L18.8591 13.2472L19.8522 13.5081L19.9264 12.7941Z",
    fill: "#D4FF23"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5335 18.9027L23.6098 18.7252L23.8867 18.7775L23.8074 18.9663L23.5335 18.9027Z",
    fill: "#00ACFF"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71039 9.08386L8.97217 9.55187L9.33995 8.80137L10.0253 8.35986L9.71039 9.08386Z",
    fill: "#FF5500"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70757 16.0998L7.78984 16.728L7.70647 15.5853L7.62372 14.9525L7.70757 16.0998Z",
    fill: "#53FFA4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5661 23.881L11.668 24.3316L11.0394 23.9614L10.9253 23.5039L11.5661 23.881Z",
    fill: "#00009B"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0277 8.82248L18.4916 8.17748L18.4212 8.1377L19.8892 8.77335L20.0277 8.82248Z",
    fill: "#FF3F00"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0853 18.9575L24.1677 18.7512L24.4458 18.6463L24.3601 18.8759L24.0853 18.9575Z",
    fill: "#00ACFF"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7171 13.0294L15.3866 13.2036L15.4369 14.278L15.7492 14.0563L15.7171 13.0294Z",
    fill: "#BEFF39"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2459 19.9891L15.3771 20.5611L14.9702 21.3593L14.8552 20.7767L15.2459 19.9891Z",
    fill: "#0050FF"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M21.495 14.7968L20.7259 14.491L20.7137 15.1471L21.4822 15.3967L21.495 14.7968Z",
    fill: "#80FF77"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5582 17.1001L25.2466 16.687L25.3726 16.1788L25.6853 16.6403L25.5582 17.1001Z",
    fill: "#30FFC7"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6435 12.827L23.5588 12.1238L23.4473 11.5996L24.5179 12.3387L24.6435 12.827Z",
    fill: "#F1FC06"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2707 18.7677L23.3441 18.595L23.6099 18.725L23.5337 18.9025L23.2707 18.7677Z",
    fill: "#00B4FF"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73866 22.286L9.87547 22.767L9.36889 21.9713L9.22202 21.4742L9.73866 22.286Z",
    fill: "#0000FF"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6437 9.72283L20.1573 8.99869L20.0277 8.82208L21.4629 9.54666L21.6437 9.72283Z",
    fill: "#FF6400"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3604 18.8758L24.446 18.6462L24.7142 18.4656L24.6253 18.7237L24.3604 18.8758Z",
    fill: "#00B8FF"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9533 11.3976L16.9963 11.1675L16.9964 12.0482L17.912 12.2145L17.9533 11.3976Z",
    fill: "#FFD700"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2285 11.9772L15.6519 12.0052L15.7169 13.03L16.2591 12.9473L16.2285 11.9772Z",
    fill: "#F1FC06"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9519 7.6066L15.5583 7.20178L15.6625 7.33488L16.9618 7.7248L16.9519 7.6066Z",
    fill: "#ED0400"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4214 8.13822L16.9515 7.60706L16.9615 7.72526L18.3479 8.23847L18.4214 8.13822Z",
    fill: "#FF1E00"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9899 11.7166L17.9531 11.3978L17.9118 12.2147L18.9138 12.4675L18.9899 11.7166Z",
    fill: "#FFE200"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0249 18.5653L23.0957 18.3907L23.3438 18.5953L23.2704 18.7679L23.0249 18.5653Z",
    fill: "#00C0FF"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82259 13.1419L7.64648 13.8215L7.77646 12.735L7.94683 12.0635L7.82259 13.1419Z",
    fill: "#D7FF1F"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2183 24.0903L12.3078 24.5375L11.6677 24.3321L11.5658 23.8815L12.2183 24.0903Z",
    fill: "#000092"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9956 11.1674L16.1816 11.0364L16.2282 11.977L16.9957 12.0482L16.9956 11.1674Z",
    fill: "#FFCC00"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6248 18.7233L24.7138 18.4652L24.9653 18.2134L24.8731 18.5042L24.6248 18.7233Z",
    fill: "#00C4FF"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0271 15.6824L21.4828 15.3968L21.5128 15.9791L22.0594 16.2171L22.0271 15.6824Z",
    fill: "#5DFF9A"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3977 16.952L22.1354 16.7249L22.2535 17.193L22.518 17.3883L22.3977 16.952Z",
    fill: "#26FFD1"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4969 14.5554L24.7741 13.9385L24.7298 13.3655L25.4488 14.0274L25.4969 14.5554Z",
    fill: "#AAFF4D"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1055 6.96552L12.9427 6.86069L13.2449 6.83313L14.3058 6.94024L14.1055 6.96552Z",
    fill: "#C80000"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0056 23.119L14.0896 23.6688L13.4958 23.9837L13.4058 23.439L14.0056 23.119Z",
    fill: "#0000C4"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8027 18.2997L22.8713 18.1165L23.0953 18.3906L23.0245 18.5652L22.8027 18.2997Z",
    fill: "#00D0FF"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6575 7.06331L11.6219 7.13548L12.0017 6.91965L12.9426 6.86084L12.6575 7.06331Z",
    fill: "#CD0000"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8654 13.1799L19.9261 12.7943L19.8519 13.5082L20.7772 13.8293L20.8654 13.1799Z",
    fill: "#CEFF29"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8894 8.77335L18.4215 8.1377L18.348 8.23795L19.7457 8.85368L19.8894 8.77335Z",
    fill: "#FF3800"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0295 12.11L18.9896 11.7168L18.9136 12.4677L19.926 12.7947L20.0295 12.11Z",
    fill: "#FBF100"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6862 16.6404L25.3735 16.1789L25.4585 15.645L25.7715 16.1548L25.6862 16.6404Z",
    fill: "#4DFFAA"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22224 21.474L9.36911 21.9711L8.92937 21.0671L8.77362 20.5514L9.22224 21.474Z",
    fill: "#0030FF"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5576 7.20207L14.3058 6.94055L14.5118 7.08443L15.6618 7.33517L15.5576 7.20207Z",
    fill: "#D10000"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1292 10.7762L21.808 10.0114L21.6439 9.72375L22.9303 10.4989L23.1292 10.7762Z",
    fill: "#FF9100"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9706 21.3587L15.039 21.9799L14.5548 22.6291L14.4857 22.0116L14.9706 21.3587Z",
    fill: "#0014FF"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0043 10.6318L16.9946 10.3398L16.9965 11.1671L17.9535 11.3972L18.0043 10.6318Z",
    fill: "#FFA700"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 18.5046L24.9652 18.2138L25.1936 17.8968L25.0984 18.2241L24.873 18.5046Z",
    fill: "#00D8FF"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5505 14.1947L20.7767 13.8294L20.7259 14.4909L21.4949 14.7967L21.5505 14.1947Z",
    fill: "#A4FF53"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M21.463 9.54696L20.0278 8.82239L19.8893 8.77325L21.2703 9.48764L21.463 9.54696Z",
    fill: "#FF5500"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5184 12.339L23.4477 11.5999L23.3032 11.1463L24.3563 11.9133L24.5184 12.339Z",
    fill: "#FFDB00"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3477 8.23831L16.9613 7.7251L16.9704 7.99125L18.2731 8.47655L18.3477 8.23831Z",
    fill: "#FF1E00"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68428 10.4304L8.17221 11.06L8.49384 10.1584L8.97204 9.55206L8.68428 10.4304Z",
    fill: "#FF8D00"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0845 11.0149L18.0034 10.632L17.9525 11.3973L18.9893 11.7162L19.0845 11.0149Z",
    fill: "#FFB600"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M16.961 7.72519L15.6616 7.33527L15.7654 7.62583L16.9701 7.99135L16.961 7.72519Z",
    fill: "#F10800"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2755 7.52465L10.4012 7.7833L10.8291 7.37248L11.6223 7.13507L11.2755 7.52465Z",
    fill: "#E40000"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6107 17.978L22.6774 17.7796L22.8717 18.1166L22.8031 18.2998L22.6107 17.978Z",
    fill: "#02E8F4"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1815 11.0363L15.555 11.0104L15.6514 12.0049L16.2281 11.9768L16.1815 11.0363Z",
    fill: "#FFC100"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9941 10.3405L16.1206 10.1519L16.1819 11.0367L16.9959 11.1677L16.9941 10.3405Z",
    fill: "#FF9800"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8671 24.1247L12.9443 24.5722L12.308 24.5371L12.2184 24.0898L12.8671 24.1247Z",
    fill: "#000096"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M15.652 12.0049L15.2865 12.1315L15.3865 13.2039L15.717 13.0297L15.652 12.0049Z",
    fill: "#F8F500"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3194 16.4818L22.0589 16.2171L22.1352 16.7249L22.3974 16.952L22.3194 16.4818Z",
    fill: "#43FFB4"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97699 17.8584L8.12432 18.4629L7.94033 17.3466L7.79053 16.7281L7.97699 17.8584Z",
    fill: "#13FCE4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7455 8.85353L18.3477 8.23779L18.2731 8.47603L19.6004 9.0617L19.7455 8.85353Z",
    fill: "#FF3800"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3867 13.2036L15.2629 13.4624L15.3304 14.5765L15.4371 14.278L15.3867 13.2036Z",
    fill: "#C1FF36"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0398 15.1346L21.4955 14.797L21.4828 15.3969L22.0271 15.6825L22.0398 15.1346Z",
    fill: "#80FF77"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M18.063 9.93953L16.9906 9.58948L16.9941 10.3402L18.0039 10.6322L18.063 9.93953Z",
    fill: "#FF7E00"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0985 18.2241L25.1937 17.8967L25.3933 17.5225L25.2951 17.889L25.0985 18.2241Z",
    fill: "#09F0EE"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3296 14.5773L15.4003 14.9404L15.4002 16.0584L15.3298 15.6637L15.3296 14.5773Z",
    fill: "#83FF73"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1594 11.473L19.0845 11.0153L18.9893 11.7165L20.0292 12.1098L20.1594 11.473Z",
    fill: "#FFC400"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2738 8.47651L16.971 7.99121L16.9791 8.39859L18.2001 8.84672L18.2738 8.47651Z",
    fill: "#FF2900"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4004 16.0584L15.6001 16.4933L15.5038 17.5791L15.3182 17.12L15.4004 16.0584Z",
    fill: "#40FFB7"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1968 10.3828L18.0629 9.93945L18.0038 10.6321L19.0849 11.0151L19.1968 10.3828Z",
    fill: "#FF9100"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4484 14.0273L24.7294 13.3654L24.6436 12.8276L25.3564 13.5293L25.4484 14.0273Z",
    fill: "#CAFF2C"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7711 16.1546L25.4582 15.6448L25.4998 15.0989L25.8121 15.6555L25.7711 16.1546Z",
    fill: "#6AFF8D"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9888 12.5602L20.0295 12.1099L19.926 12.7945L20.8652 13.1802L20.9888 12.5602Z",
    fill: "#F1FC06"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5038 17.5786L15.7603 18.051L15.5505 19.0727L15.3158 18.5814L15.5038 17.5786Z",
    fill: "#00E4F8"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9305 10.4985L21.644 9.72335L21.4632 9.54718L22.7118 10.3224L22.9305 10.4985Z",
    fill: "#FF7A00"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2708 9.48765L19.8898 8.77325L19.7461 8.85361L21.0713 9.54724L21.2708 9.48765Z",
    fill: "#FF4E00"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9705 7.99131L15.7658 7.62579L15.8662 8.06655L16.9786 8.3987L16.9705 7.99131Z",
    fill: "#FF1300"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6625 7.33454L14.5125 7.0838L14.7185 7.39401L15.7663 7.62511L15.6625 7.33454Z",
    fill: "#D60000"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1284 9.33864L16.9849 8.93604L16.9901 9.58934L18.0625 9.93939L18.1284 9.33864Z",
    fill: "#FF5900"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62372 14.9527L7.70647 15.5855L7.72946 14.459L7.64642 13.8213L7.62372 14.9527Z",
    fill: "#97FF60"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1994 8.8462L16.9784 8.39807L16.9851 8.93577L18.1286 9.33837L18.1994 8.8462Z",
    fill: "#FF3B00"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77349 20.5517L8.92923 21.0673L8.56737 20.0762L8.40414 19.5399L8.77349 20.5517Z",
    fill: "#0070FF"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4528 17.6081L22.5182 17.3882L22.6776 17.7797L22.6109 17.9782L22.4528 17.6081Z",
    fill: "#16FFE1"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6009 9.06187L18.2736 8.4762L18.1999 8.84637L19.4586 9.39259L19.6009 9.06187Z",
    fill: "#FF4300"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9909 9.58941L16.0466 9.34698L16.121 10.1515L16.9945 10.3402L16.9909 9.58941Z",
    fill: "#FF6C00"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3226 9.8372L18.129 9.33887L18.0632 9.93963L19.197 10.383L19.3226 9.8372Z",
    fill: "#FF6F00"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6481 13.6067L20.8654 13.18L20.7772 13.8294L21.551 14.1948L21.6481 13.6067Z",
    fill: "#C7FF30"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0246 8.35975L9.3392 8.80125L9.77829 8.20022L10.4007 7.78369L10.0246 8.35975Z",
    fill: "#FF1E00"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3064 6.94024L13.2455 6.83313L13.5566 6.98275L14.5123 7.08411L14.3064 6.94024Z",
    fill: "#BB0000"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3561 11.9137L23.303 11.1466L23.1291 10.776L24.1614 11.5622L24.3561 11.9137Z",
    fill: "#FFBD00"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4585 9.39271L18.1998 8.8465L18.1291 9.33869L19.3227 9.83702L19.4585 9.39271Z",
    fill: "#FF5500"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5505 19.0728L15.6944 19.6355L15.377 20.5605L15.2458 19.9885L15.5505 19.0728Z",
    fill: "#0098FF"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9782 8.39819L15.8659 8.06604L15.9602 8.64517L16.9849 8.9359L16.9782 8.39819Z",
    fill: "#FF2900"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M16.985 8.93624L15.9603 8.64551L16.0459 9.34713L16.9902 9.58955L16.985 8.93624Z",
    fill: "#FF4700"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3129 10.9015L19.1964 10.3829L19.0845 11.0152L20.1594 11.473L20.3129 10.9015Z",
    fill: "#FFA300"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1209 10.1512L15.4305 10.0737L15.5558 11.0102L16.1823 11.0361L16.1209 10.1512Z",
    fill: "#FF8900"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2946 17.8889L25.3928 17.5224L25.5583 17.1001L25.4574 17.5075L25.2946 17.8889Z",
    fill: "#1CFFDB"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0707 9.54745L19.7454 8.85382L19.6004 9.06201L20.8699 9.72479L21.0707 9.54745Z",
    fill: "#FF5200"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2856 15.989L22.0264 15.6816L22.0587 16.2164L22.3191 16.4811L22.2856 15.989Z",
    fill: "#60FF97"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0974 19.1078L23.5332 18.9026L23.8071 18.9663L23.3632 19.1814L23.0974 19.1078Z",
    fill: "#00BCFF"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9428 6.86069L12.002 6.9195L12.4047 6.88511L13.2451 6.83313L12.9428 6.86069Z",
    fill: "#B20000"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3635 19.1813L23.8074 18.9662L24.0852 18.9572L23.633 19.1871L23.3635 19.1813Z",
    fill: "#00B8FF"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5547 22.629L14.6332 23.186L14.0895 23.6686L14.0056 23.1188L14.5547 22.629Z",
    fill: "#0000F1"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8418 18.9682L23.27 18.7676L23.533 18.9024L23.0971 19.1075L22.8418 18.9682Z",
    fill: "#00C4FF"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1443 11.986L20.1595 11.4727L20.0293 12.1094L20.9885 12.5597L21.1443 11.986Z",
    fill: "#FFD700"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M22.097 14.5875L21.5505 14.1948L21.495 14.7967L22.0393 15.1343L22.097 14.5875Z",
    fill: "#A0FF56"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7116 10.3224L21.463 9.54714L21.2704 9.48779L22.479 10.2527L22.7116 10.3224Z",
    fill: "#FF6F00"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7654 7.62496L14.7176 7.39386L14.9178 7.86262L15.8658 8.06569L15.7654 7.62496Z",
    fill: "#E40000"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M20.486 10.411L19.3223 9.83691L19.1968 10.3827L20.3133 10.9013L20.486 10.411Z",
    fill: "#FF8200"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94707 12.0636L7.7767 12.7352L8.01199 11.7221L8.17227 11.0601L7.94707 12.0636Z",
    fill: "#FFD000"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M13.496 23.984L13.5613 24.4353L12.9443 24.5725L12.867 24.1251L13.496 23.984Z",
    fill: "#0000A8"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5556 11.0104L15.1392 11.0906L15.2865 12.1315L15.652 12.0049L15.5556 11.0104Z",
    fill: "#FFB900"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3332 17.1991L22.3978 16.952L22.5181 17.3883L22.4527 17.6082L22.3332 17.1991Z",
    fill: "#30FFC7"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6328 19.1874L24.085 18.9574L24.3599 18.8758L23.8993 19.1253L23.6328 19.1874Z",
    fill: "#00BCFF"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8119 15.6558L25.4996 15.0993L25.4964 14.5553L25.8073 15.156L25.8119 15.6558Z",
    fill: "#87FF70"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 9.72491L19.6004 9.06213L19.458 9.39283L20.6732 10.0154L20.8698 9.72491Z",
    fill: "#FF5900"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3566 13.5293L24.6438 12.8277L24.5182 12.3394L25.2228 13.0744L25.3566 13.5293Z",
    fill: "#E7FF0F"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6034 18.7672L23.0245 18.5657L23.27 18.7684L22.8418 18.969L22.6034 18.7672Z",
    fill: "#00D0FF"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6731 10.0152L19.4579 9.39258L19.3221 9.83693L20.4858 10.411L20.6731 10.0152Z",
    fill: "#FF6C00"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0459 9.3468L15.2791 9.22168L15.43 10.0738L16.1204 10.1513L16.0459 9.3468Z",
    fill: "#FF5D00"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0391 23.9613L11.1181 24.3085L10.5328 23.7974L10.437 23.4355L11.0391 23.9613Z",
    fill: "#0000C4"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7841 13.048L20.9886 12.5599L20.8651 13.1799L21.6478 13.6066L21.7841 13.048Z",
    fill: "#E7FF0F"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8989 19.1253L24.3595 18.8758L24.6244 18.7236L24.1556 18.9968L23.8989 19.1253Z",
    fill: "#00C4FF"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1609 11.5621L23.1286 10.7758L22.9297 10.4985L23.9388 11.2946L24.1609 11.5621Z",
    fill: "#FFA700"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8658 8.06648L14.9178 7.8634L15.1067 8.47822L15.9601 8.64562L15.8658 8.06648Z",
    fill: "#FF1300"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4366 23.436L10.5324 23.7979L9.98706 23.1482L9.87549 22.7674L10.4366 23.436Z",
    fill: "#0000E8"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4574 17.5075L25.5583 17.1L25.6854 16.6403L25.5819 17.0894L25.4574 17.5075Z",
    fill: "#36FFC1"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3885 18.5075L22.8035 18.2996L23.0252 18.5651L22.6041 18.7666L22.3885 18.5075Z",
    fill: "#00E0FB"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9609 8.64525L15.1074 8.47784L15.2797 9.22173L16.0465 9.34684L15.9609 8.64525Z",
    fill: "#FF3400"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2862 12.1318L15.1286 12.3516L15.2624 13.4631L15.3862 13.2042L15.2862 12.1318Z",
    fill: "#FBF100"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3776 20.5604L15.4455 21.1858L15.0392 21.9798L14.9707 21.3586L15.3776 20.5604Z",
    fill: "#0054FF"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6225 7.13527L10.8293 7.37267L11.2979 7.14015L12.0023 6.91943L11.6225 7.13527Z",
    fill: "#BB0000"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5121 7.08428L13.5563 6.98291L13.8678 7.30684L14.7181 7.39448L14.5121 7.08428Z",
    fill: "#BF0000"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3281 11.4741L20.313 10.9014L20.1595 11.4728L21.1442 11.9861L21.3281 11.4741Z",
    fill: "#FFB600"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M22.479 10.2527L21.2704 9.48779L21.071 9.5474L22.2386 10.2918L22.479 10.2527Z",
    fill: "#FF6800"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6679 24.3315L11.7293 24.6686L11.1182 24.3085L11.0392 23.9612L11.6679 24.3315Z",
    fill: "#0000AD"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40388 19.5402L8.56711 20.0766L8.29249 19.0219L8.12338 18.4632L8.40388 19.5402Z",
    fill: "#00B4FF"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7901 16.7283L7.9399 17.3468L7.85798 16.2186L7.70673 15.5856L7.7901 16.7283Z",
    fill: "#53FFA4"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2986 15.4878L22.0399 15.1339L22.0272 15.6818L22.2865 15.9892L22.2986 15.4878Z",
    fill: "#7DFF7A"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97184 9.55146L8.49365 10.1578L8.90449 9.3832L9.33961 8.8009L8.97184 9.55146Z",
    fill: "#FF4E00"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1561 18.9969L24.6249 18.7237L24.8732 18.5047L24.3966 18.8051L24.1561 18.9969Z",
    fill: "#00D4FF"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87592 22.7672L9.98749 23.148L9.49521 22.375L9.36932 21.9715L9.87592 22.7672Z",
    fill: "#0004FF"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2551 16.761L22.3194 16.4816L22.3975 16.9517L22.3329 17.1988L22.2551 16.761Z",
    fill: "#49FFAD"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2629 13.4624L15.3182 13.7947L15.4012 14.9396L15.3304 14.5765L15.2629 13.4624Z",
    fill: "#C1FF36"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2005 18.1978L22.6102 17.9781L22.8026 18.2999L22.3877 18.5078L22.2005 18.1978Z",
    fill: "#0CF4EB"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M22.199 14.0557L21.6482 13.6064L21.5511 14.1945L22.0976 14.5872L22.199 14.0557Z",
    fill: "#C1FF36"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5354 11.0377L20.486 10.4106L20.3133 10.901L21.3283 11.4738L21.5354 11.0377Z",
    fill: "#FF9800"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M15.43 10.0737L14.9479 10.1102L15.1389 11.0905L15.5553 11.0102L15.43 10.0737Z",
    fill: "#FF7E00"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2384 10.2916L21.0708 9.54718L20.87 9.72451L21.9967 10.4385L22.2384 10.2916Z",
    fill: "#FF6C00"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8074 15.1558L25.4965 14.5551L25.4484 14.0272L25.7571 14.6683L25.8074 15.1558Z",
    fill: "#A7FF50"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2221 13.0744L24.5176 12.3394L24.3555 11.9137L25.0499 12.6748L25.2221 13.0744Z",
    fill: "#FFEA00"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9563 12.534L21.1445 11.9861L20.9888 12.5599L21.7842 13.048L21.9563 12.534Z",
    fill: "#FFE600"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9394 11.2949L22.9303 10.4988L22.7116 10.3228L23.6956 11.119L23.9394 11.2949Z",
    fill: "#FF9400"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4013 14.9402L15.6019 15.3522L15.601 16.4931L15.4012 16.0583L15.4013 14.9402Z",
    fill: "#83FF73"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M21.76 10.6897L20.6731 10.0151L20.4858 10.411L21.5352 11.038L21.76 10.6897Z",
    fill: "#FF8200"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9964 10.4386L20.8697 9.72461L20.673 10.0151L21.76 10.6896L21.9964 10.4386Z",
    fill: "#FF7300"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3077 24.537L12.3512 24.8689L11.7289 24.6687L11.6675 24.3315L12.3077 24.537Z",
    fill: "#0000A4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2451 6.83313L12.4048 6.88511L12.8196 7.03473L13.5562 6.98275L13.2451 6.83313Z",
    fill: "#A40000"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5819 17.0892L25.6853 16.6401L25.7705 16.1544L25.6649 16.645L25.5819 17.0892Z",
    fill: "#50FFA7"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3962 18.8049L24.8727 18.5045L25.0981 18.2239L24.6142 18.5544L24.3962 18.8049Z",
    fill: "#00E4F8"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7183 7.39441L13.868 7.30676L14.1712 7.79689L14.9185 7.86318L14.7183 7.39441Z",
    fill: "#CD0000"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6009 16.493L15.869 16.949L15.761 18.0512L15.5046 17.5788L15.6009 16.493Z",
    fill: "#40FFB7"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0475 17.8444L22.4531 17.6079L22.6111 17.978L22.2014 18.1976L22.0475 17.8444Z",
    fill: "#1FFFD7"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64648 13.8214L7.72953 14.459L7.8596 13.3774L7.77646 12.7349L7.64648 13.8214Z",
    fill: "#D7FF1F"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4011 7.7835L9.77866 8.20003L10.278 7.76646L10.8289 7.37268L10.4011 7.7835Z",
    fill: "#DA0000"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0899 23.6683L14.1439 24.1271L13.5614 24.4345L13.4961 23.9832L14.0899 23.6683Z",
    fill: "#0000CD"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36878 21.9714L9.49467 22.3749L9.0675 21.497L8.92905 21.0674L9.36878 21.9714Z",
    fill: "#003CFF"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2798 9.22165L14.7192 9.21838L14.9486 10.1103L15.4306 10.0738L15.2798 9.22165Z",
    fill: "#FF4E00"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3557 14.9901L22.0971 14.587L22.0394 15.1339L22.2981 15.4878L22.3557 14.9901Z",
    fill: "#9DFF5A"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2217 16.3052L22.2864 15.9893L22.32 16.4814L22.2556 16.7608L22.2217 16.3052Z",
    fill: "#63FF94"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9181 7.86298L14.1707 7.79669L14.4571 8.4399L15.1069 8.47778L14.9181 7.86298Z",
    fill: "#E80000"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1594 12.0785L21.3281 11.4742L21.1442 11.9862L21.956 12.5341L22.1594 12.0785Z",
    fill: "#FFC400"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1388 11.0909L14.9316 11.2735L15.1285 12.3516L15.2861 12.1318L15.1388 11.0909Z",
    fill: "#FFAE00"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6954 11.1187L22.7115 10.3224L22.4789 10.2527L23.4364 11.0392L23.6954 11.1187Z",
    fill: "#FF8600"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3414 13.554L21.7843 13.0482L21.6479 13.6067L22.1987 14.0559L22.3414 13.554Z",
    fill: "#DEFF19"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7607 18.0514L15.9135 18.6064L15.6948 19.6359L15.551 19.0731L15.7607 18.0514Z",
    fill: "#00E4F8"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M15.107 8.47832L14.4572 8.44043L14.7187 9.21894L15.2793 9.22221L15.107 8.47832Z",
    fill: "#FF2200"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0391 21.9796L15.1127 22.5456L14.6333 23.1857L14.5549 22.6287L15.0391 21.9796Z",
    fill: "#0018FF"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0501 12.6746L24.3556 11.9135L24.161 11.5621L24.8438 12.3412L25.0501 12.6746Z",
    fill: "#FFD000"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6151 18.5542L25.099 18.2238L25.2956 17.8887L24.805 18.2513L24.6151 18.5542Z",
    fill: "#0FF8E7"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7571 14.6684L25.4485 14.0272L25.3564 13.5291L25.6623 14.206L25.7571 14.6684Z",
    fill: "#C1FF36"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9304 17.4567L22.333 17.1985L22.4526 17.6077L22.047 17.8442L21.9304 17.4567Z",
    fill: "#33FFC4"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9443 24.5725L12.9701 24.904L12.3515 24.8693L12.308 24.5374L12.9443 24.5725Z",
    fill: "#0000A8"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6649 16.6453L25.7705 16.1547L25.8114 15.6556L25.7041 16.1864L25.6649 16.6453Z",
    fill: "#6AFF8D"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 6.91964L11.2972 7.14035L11.7942 7.09433L12.4043 6.88525L12.0016 6.91964Z",
    fill: "#9F0000"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3291 19.3396L23.0976 19.1077L23.3634 19.1813L22.584 19.4223L22.3291 19.3396Z",
    fill: "#00C8FF"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3888 11.6938L21.5352 11.0381L21.3281 11.4742L22.1595 12.0785L22.3888 11.6938Z",
    fill: "#FFAB00"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0842 19.1954L22.8423 18.9686L23.0976 19.1079L22.3292 19.3399L22.0842 19.1954Z",
    fill: "#00D0FF"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4359 11.0392L22.4784 10.2527L22.238 10.2918L23.1686 11.0588L23.4359 11.0392Z",
    fill: "#FF8200"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12344 18.4629L8.29255 19.0217L8.11269 17.9289L7.93945 17.3467L8.12344 18.4629Z",
    fill: "#16FFE1"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17219 11.0591L8.0119 11.7212L8.34773 10.809L8.49382 10.1575L8.17219 11.0591Z",
    fill: "#FF8D00"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5838 19.4227L23.3632 19.1818L23.6327 19.1876L22.8422 19.4414L22.5838 19.4227Z",
    fill: "#00C8FF"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8547 18.9925L22.6033 18.7667L22.8417 18.9685L22.0836 19.1953L21.8547 18.9925Z",
    fill: "#00D8FF"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5565 6.98291L12.8198 7.03489L13.2353 7.36568L13.8679 7.30684L13.5565 6.98291Z",
    fill: "#A80000"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1286 12.3516L15.1532 12.6546L15.3177 13.7954L15.2624 13.463L15.1286 12.3516Z",
    fill: "#FEED00"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6384 11.3905L21.7605 10.6898L21.5356 11.0381L22.3892 11.6938L22.6384 11.3905Z",
    fill: "#FF9800"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1686 11.0588L22.238 10.2918L21.9963 10.4388L22.9002 11.1769L23.1686 11.0588Z",
    fill: "#FF8200"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2327 15.8437L22.2986 15.4879L22.2864 15.9893L22.2217 16.3052L22.2327 15.8437Z",
    fill: "#7DFF7A"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4577 14.5092L22.1986 14.0557L22.0972 14.5871L22.3558 14.9902L22.4577 14.5092Z",
    fill: "#BAFF3C"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5213 13.0946L21.9559 12.5338L21.7839 13.0478L22.341 13.5537L22.5213 13.0946Z",
    fill: "#FBF100"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8426 19.4414L23.6332 19.1877L23.8997 19.1256L23.0979 19.3955L22.8426 19.4414Z",
    fill: "#00C8FF"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8047 18.2518L25.2953 17.8892L25.458 17.5078L24.9616 17.904L24.8047 18.2518Z",
    fill: "#26FFD1"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6479 18.7369L22.3881 18.5079L22.6036 18.767L21.855 18.9928L21.6479 18.7369Z",
    fill: "#02E8F4"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92958 21.0673L9.06803 21.4969L8.71667 20.5347L8.56772 20.0762L8.92958 21.0673Z",
    fill: "#0078FF"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9006 11.1773L21.9967 10.4391L21.7603 10.6901L22.6382 11.3908L22.9006 11.1773Z",
    fill: "#FF8900"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8445 12.3409L24.1617 11.5619L23.9396 11.2944L24.6095 12.0829L24.8445 12.3409Z",
    fill: "#FFB900"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6942 19.6351L15.7618 20.265L15.4447 21.1855L15.3768 20.5601L15.6942 19.6351Z",
    fill: "#0098FF"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70673 15.5859L7.85798 16.2188L7.88134 15.1068L7.72971 14.4593L7.70673 15.5859Z",
    fill: "#97FF60"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9481 10.1104L14.6769 10.2585L14.9319 11.2731L15.1391 11.0906L14.9481 10.1104Z",
    fill: "#FF7300"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8539 17.0447L22.255 16.7607L22.3328 17.1986L21.9302 17.4568L21.8539 17.0447Z",
    fill: "#4DFFAA"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6626 14.2061L25.3568 13.5292L25.223 13.0742L25.5254 13.7811L25.6626 14.2061Z",
    fill: "#DEFF19"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33975 8.80135L8.90463 9.38364L9.39485 8.75838L9.77883 8.20032L9.33975 8.80135Z",
    fill: "#FF1A00"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0974 19.3946L23.8991 19.1247L24.1559 18.9962L23.3432 19.2852L23.0974 19.3946Z",
    fill: "#00D0FF"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4681 18.4341L22.2011 18.1979L22.3882 18.5079L21.6481 18.7369L21.4681 18.4341Z",
    fill: "#13FCE4"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M25.705 16.1865L25.8124 15.6557L25.8078 15.1559L25.6991 15.7247L25.705 16.1865Z",
    fill: "#87FF70"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3182 13.7952L15.506 14.1862L15.6017 15.3521L15.4012 14.9401L15.3182 13.7952Z",
    fill: "#C4FF33"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8675 7.30676L13.2349 7.36561L13.6393 7.8693L14.1707 7.7969L13.8675 7.30676Z",
    fill: "#B60000"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7351 12.6908L22.1598 12.0781L21.9564 12.5337L22.5218 13.0945L22.7351 12.6908Z",
    fill: "#FFD700"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6092 12.083L23.9393 11.2946L23.6955 11.1187L24.3516 11.9074L24.6092 12.083Z",
    fill: "#FFA700"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M14.633 23.1865L14.6767 23.6563L14.1434 24.128L14.0894 23.6692L14.633 23.1865Z",
    fill: "#0000FA"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5614 24.4349L13.5699 24.7711L12.9701 24.9036L12.9443 24.5721L13.5614 24.4349Z",
    fill: "#0000BB"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9609 17.9037L25.4573 17.5075L25.5819 17.0895L25.0807 17.5196L24.9609 17.9037Z",
    fill: "#3CFFBA"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3431 19.2858L24.1558 18.9968L24.3963 18.805L23.5731 19.1155L23.3431 19.2858Z",
    fill: "#00DCFE"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6018 14.0575L22.3416 13.5535L22.1989 14.0555L22.4581 14.5091L22.6018 14.0575Z",
    fill: "#D4FF23"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7182 9.21838L14.3701 9.33615L14.6763 10.2585L14.9475 10.1103L14.7182 9.21838Z",
    fill: "#FF3F00"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2882 15.3877L22.3558 14.9899L22.2981 15.4875L22.2323 15.8433L22.2882 15.3877Z",
    fill: "#9AFF5D"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8291 7.37248L10.2783 7.76626L10.8252 7.51386L11.2978 7.13995L10.8291 7.37248Z",
    fill: "#B20000"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1174 24.3087L11.144 24.5303L10.5803 24.0381L10.5322 23.7977L11.1174 24.3087Z",
    fill: "#0000D6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3192 18.0922L22.0465 17.8447L22.2004 18.1979L21.4674 18.4342L21.3192 18.0922Z",
    fill: "#26FFD1"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5323 23.798L10.5804 24.0384L10.0552 23.4128L9.987 23.1483L10.5323 23.798Z",
    fill: "#0000FA"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8205 16.619L22.2216 16.3058L22.2555 16.7613L21.8543 17.0452L21.8205 16.619Z",
    fill: "#63FF94"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6015 15.3521L15.8706 15.7945L15.8686 16.949L15.6006 16.493L15.6015 15.3521Z",
    fill: "#83FF73"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1707 7.79669L13.6393 7.86909L14.0215 8.53214L14.4571 8.43989L14.1707 7.79669Z",
    fill: "#D60000"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4046 6.88525L11.7944 7.09433L12.3062 7.23771L12.8194 7.03487L12.4046 6.88525Z",
    fill: "#960000"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5251 13.7811L25.2227 13.0742L25.0505 12.6746L25.349 13.4049L25.5251 13.7811Z",
    fill: "#F4F802"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4566 8.43958L14.021 8.53182L14.37 9.33587L14.7181 9.2181L14.4566 8.43958Z",
    fill: "#FF1300"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7293 24.6688L11.7332 24.8773L11.1447 24.5303L11.1182 24.3087L11.7293 24.6688Z",
    fill: "#0000BF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M22.976 12.3539L22.3892 11.694L22.1599 12.0786L22.7352 12.6913L22.976 12.3539Z",
    fill: "#FFC100"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7767 12.7348L7.85985 13.3773L8.09503 12.3691L8.01199 11.7217L7.7767 12.7348Z",
    fill: "#FFD000"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3518 11.907L23.6957 11.1183L23.4367 11.0389L24.0785 11.8188L24.3518 11.907Z",
    fill: "#FF9C00"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6989 15.7247L25.8076 15.1559L25.7574 14.6685L25.6478 15.2719L25.6989 15.7247Z",
    fill: "#A0FF56"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9315 11.2733L14.9105 11.5495L15.1529 12.6545L15.1284 12.3514L14.9315 11.2733Z",
    fill: "#FFAB00"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98691 23.148L10.0552 23.4125L9.58114 22.6685L9.49463 22.3751L9.98691 23.148Z",
    fill: "#0014FF"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 19.1152L24.3966 18.8048L24.6146 18.5543L23.7817 18.8882L23.5734 19.1152Z",
    fill: "#06ECF1"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56728 20.0761L8.71623 20.5346L8.44978 19.511L8.29266 19.0215L8.56728 20.0761Z",
    fill: "#00BCFF"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4454 21.1862L15.515 21.763L15.1127 22.5462L15.0391 21.9802L15.4454 21.1862Z",
    fill: "#0054FF"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2069 17.719L21.9302 17.4565L22.0468 17.8441L21.3195 18.0916L21.2069 17.719Z",
    fill: "#39FFBE"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2381 12.0918L22.6385 11.3904L22.3893 11.6937L22.9762 12.3537L23.2381 12.0918Z",
    fill: "#FFAE00"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 16.9487L16.0257 17.4976L15.9129 18.6059L15.7601 18.0509L15.868 16.9487Z",
    fill: "#40FFB7"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0781 11.8188L23.4363 11.0389L23.1689 11.0584L23.7963 11.8205L24.0781 11.8188Z",
    fill: "#FF9800"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94001 17.347L8.11325 17.9292L8.03357 16.825L7.85809 16.2188L7.94001 17.347Z",
    fill: "#56FFA0"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0814 17.5195L25.5826 17.0893L25.6656 16.6451L25.1607 17.1089L25.0814 17.5195Z",
    fill: "#53FFA4"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7835 13.6483L22.5217 13.0953L22.3413 13.5544L22.6016 14.0583L22.7835 13.6483Z",
    fill: "#EEFF09"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5139 11.9129L22.9007 11.1772L22.6384 11.3908L23.2379 12.0921L23.5139 11.9129Z",
    fill: "#FF9F00"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7962 11.8213L23.1689 11.0592L22.9004 11.1773L23.5135 11.913L23.7962 11.8213Z",
    fill: "#FF9800"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3881 14.9509L22.4579 14.5098L22.3559 14.9907L22.2884 15.3886L22.3881 14.9509Z",
    fill: "#B4FF43"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3517 24.8686L12.3326 25.07L11.7333 24.8769L11.7293 24.6685L12.3517 24.8686Z",
    fill: "#0000B6"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0466 19.4493L22.0838 19.1956L22.3288 19.3401L21.28 19.6003L21.0466 19.4493Z",
    fill: "#00D8FF"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3486 13.4047L25.05 12.6744L24.8438 12.3409L25.1382 13.0875L25.3486 13.4047Z",
    fill: "#FFDE00"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8302 16.1889L22.2326 15.8436L22.2216 16.3051L21.8205 16.6183L21.8302 16.1889Z",
    fill: "#7DFF7A"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2801 19.5998L22.3289 19.3397L22.5838 19.4223L21.5229 19.6914L21.2801 19.5998Z",
    fill: "#00D0FF"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8285 19.2421L21.8551 18.9922L22.0841 19.1949L21.0468 19.4486L20.8285 19.2421Z",
    fill: "#00E0FB"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5234 19.6918L22.5843 19.4227L22.8427 19.4413L21.7693 19.7217L21.5234 19.6918Z",
    fill: "#00D0FF"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49326 10.1582L8.34717 10.8097L8.77597 10.0237L8.9041 9.38361L8.49326 10.1582Z",
    fill: "#FF4E00"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6307 18.9855L21.648 18.7366L21.8551 18.9925L20.8284 19.2424L20.6307 18.9855Z",
    fill: "#09F0EE"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7817 18.8884L24.6146 18.5545L24.8046 18.2516L23.963 18.6103L23.7817 18.8884Z",
    fill: "#19FFDE"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49538 22.375L9.58189 22.6684L9.17067 21.8234L9.06821 21.4971L9.49538 22.375Z",
    fill: "#0048FF"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 17.3255L21.8539 17.0447L21.9302 17.4568L21.2069 17.7193L21.1328 17.3255Z",
    fill: "#50FFA7"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6477 15.272L25.7573 14.6685L25.6624 14.2062L25.5526 14.8402L25.6477 15.272Z",
    fill: "#BEFF39"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8195 7.03497L12.3063 7.23781L12.8188 7.56795L13.2349 7.36576L12.8195 7.03497Z",
    fill: "#960000"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9994 13.29L22.7353 12.6909L22.522 13.0946L22.7839 13.6475L22.9994 13.29Z",
    fill: "#FFE600"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1437 24.1281L14.1358 24.4739L13.5697 24.7717L13.5612 24.4355L14.1437 24.1281Z",
    fill: "#0000DA"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7692 19.7213L22.8426 19.4409L23.0979 19.395L22.0121 19.6886L21.7692 19.7213Z",
    fill: "#00D0FF"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1538 12.6543L15.3154 13.0268L15.5062 14.186L15.3184 13.795L15.1538 12.6543Z",
    fill: "#FFEA00"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4582 18.6846L21.4675 18.4339L21.6475 18.7366L20.6302 18.9855L20.4582 18.6846Z",
    fill: "#16FFE1"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6765 10.2584L14.5964 10.5109L14.9105 11.5492L14.9315 11.273L14.6765 10.2584Z",
    fill: "#FF6C00"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72949 14.4586L7.88112 15.1061L8.01045 14.0388L7.85956 13.377L7.72949 14.4586Z",
    fill: "#D7FF1F"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1603 17.1097L25.6653 16.6459L25.7044 16.187L25.197 16.6833L25.1603 17.1097Z",
    fill: "#6DFF8A"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77851 8.20016L9.39453 8.75823L9.95181 8.30093L10.2779 7.7666L9.77851 8.20016Z",
    fill: "#D10000"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1388 13.0876L24.8444 12.3411L24.6094 12.083L24.8994 12.838L25.1388 13.0876Z",
    fill: "#FFCC00"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9128 18.6064L15.9803 19.2411L15.7618 20.2659L15.6942 19.6359L15.9128 18.6064Z",
    fill: "#00E4F8"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5294 14.5424L22.6021 14.0581L22.4583 14.5097L22.3885 14.9508L22.5294 14.5424Z",
    fill: "#CEFF29"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2978 7.14039L10.8252 7.5143L11.4049 7.45181L11.7948 7.09436L11.2978 7.14039Z",
    fill: "#960000"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8834 15.768L22.2887 15.3887L22.2327 15.8443L21.8303 16.1896L21.8834 15.768Z",
    fill: "#97FF60"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 24.9034L12.928 25.1038L12.3324 25.07L12.3514 24.8687L12.97 24.9034Z",
    fill: "#0000BB"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0117 19.6881L23.0975 19.3946L23.3433 19.2852L22.2453 19.5935L22.0117 19.6881Z",
    fill: "#00D8FF"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1124 22.546L15.147 23.03L14.6767 23.6559L14.633 23.1861L15.1124 22.546Z",
    fill: "#0020FF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9632 18.6107L24.8048 18.252L24.9617 17.9041L24.1127 18.2883L23.9632 18.6107Z",
    fill: "#29FFCE"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3166 18.3475L21.3196 18.0921L21.4679 18.434L20.4586 18.6848L20.3166 18.3475Z",
    fill: "#29FFCE"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2427 12.9951L22.976 12.354L22.7352 12.6914L22.9992 13.2905L23.2427 12.9951Z",
    fill: "#FFD000"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0995 16.921L21.8202 16.6191L21.854 17.0454L21.1329 17.3261L21.0995 16.921Z",
    fill: "#66FF90"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5527 14.8396L25.6626 14.2055L25.5254 13.7806L25.4159 14.4402L25.5527 14.8396Z",
    fill: "#D4FF23"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8991 12.8378L24.609 12.0828L24.3514 11.9072L24.6371 12.6626L24.8991 12.8378Z",
    fill: "#FFB900"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2351 7.36536L12.819 7.56754L13.3179 8.07615L13.6396 7.86905L13.2351 7.36536Z",
    fill: "#A80000"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29265 19.0221L8.44977 19.5116L8.27551 18.4514L8.11279 17.9293L8.29265 19.0221Z",
    fill: "#19FFDE"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5062 14.1859L15.7658 14.6179L15.871 15.7941L15.6019 15.3517L15.5062 14.1859Z",
    fill: "#C4FF33"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3709 9.33643L14.2196 9.56912L14.597 10.5113L14.6771 10.2588L14.3709 9.33643Z",
    fill: "#FF3400"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06801 21.4974L9.17047 21.8237L8.83237 20.8979L8.71664 20.5352L9.06801 21.4974Z",
    fill: "#0080FF"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5078 12.7698L23.238 12.0919L22.9761 12.3538L23.2428 12.9949L23.5078 12.7698Z",
    fill: "#FFC100"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2453 19.5945L23.3433 19.2861L23.5733 19.1158L22.4637 19.4403L22.2453 19.5945Z",
    fill: "#00E4F8"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1968 16.6829L25.7042 16.1866L25.6983 15.7247L25.1896 16.2516L25.1968 16.6829Z",
    fill: "#87FF70"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2083 17.9821L21.2069 17.7194L21.3196 18.0919L20.3165 18.3473L20.2083 17.9821Z",
    fill: "#3CFFBA"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M22.708 14.1742L22.7839 13.6479L22.602 14.058L22.5293 14.5423L22.708 14.1742Z",
    fill: "#E4FF13"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M24.637 12.6629L24.3513 11.9075L24.078 11.8193L24.3593 12.5669L24.637 12.6629Z",
    fill: "#FFB200"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6395 7.86914L13.3179 8.07624L13.7891 8.74959L14.0216 8.53221L13.6395 7.86914Z",
    fill: "#C80000"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0216 8.53235L13.7891 8.74973L14.2194 9.56906L14.3707 9.33637L14.0216 8.53235Z",
    fill: "#F10800"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9786 15.3651L22.388 14.9508L22.2884 15.3886L21.8831 15.7679L21.9786 15.3651Z",
    fill: "#B1FF46"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7866 12.6213L23.5133 11.9129L23.2373 12.0921L23.5071 12.77L23.7866 12.6213Z",
    fill: "#FFB200"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0119 11.7216L8.09494 12.369L8.43046 11.4614L8.34773 10.8094L8.0119 11.7216Z",
    fill: "#FF8D00"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1122 18.2874L24.9612 17.9032L25.081 17.5192L24.2258 17.9289L24.1122 18.2874Z",
    fill: "#40FFB7"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3595 12.5669L24.0782 11.8193L23.7964 11.8211L24.0736 12.5529L24.3595 12.5669Z",
    fill: "#FFAB00"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M24.073 12.5527L23.7958 11.8209L23.5132 11.9126L23.7865 12.621L24.073 12.5527Z",
    fill: "#FFAE00"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1076 16.5147L21.8299 16.1895L21.8202 16.6189L21.0995 16.9208L21.1076 16.5147Z",
    fill: "#7DFF7A"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8022 19.7317L21.0467 19.4487L21.2802 19.5997L20.0239 19.8913L19.8022 19.7317Z",
    fill: "#00DCFE"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5947 19.5176L20.8282 19.242L21.0465 19.4485L19.8021 19.7315L19.5947 19.5176Z",
    fill: "#00E4F8"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85809 16.2183L8.03357 16.8246L8.05717 15.7367L7.88145 15.1063L7.85809 16.2183Z",
    fill: "#97FF60"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4152 14.4404L25.5248 13.7808L25.3487 13.4046L25.2401 14.0841L25.4152 14.4404Z",
    fill: "#EBFF0C"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1447 24.53L11.1193 24.6181L10.5814 24.1483L10.5811 24.0377L11.1447 24.53Z",
    fill: "#0000ED"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7623 20.2657L15.8288 20.8549L15.5148 21.763L15.4452 21.1862L15.7623 20.2657Z",
    fill: "#009CFF"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8703 15.7947L16.0286 16.3392L16.026 17.498L15.8683 16.9492L15.8703 15.7947Z",
    fill: "#83FF73"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0244 19.8917L21.2807 19.6001L21.5235 19.6917L20.2546 19.993L20.0244 19.8917Z",
    fill: "#00D4FF"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5805 24.0383L10.5809 24.149L10.0797 23.552L10.0554 23.4127L10.5805 24.0383Z",
    fill: "#0000FF"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9105 11.5491L15.0331 11.9062L15.3145 13.0266L15.1529 12.6541L14.9105 11.5491Z",
    fill: "#FFA300"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4067 19.2552L20.6305 18.9857L20.8282 19.2426L19.5947 19.5181L19.4067 19.2552Z",
    fill: "#0CF4EB"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4634 19.4394L23.5729 19.115L23.7813 18.888L22.661 19.2292L22.4634 19.4394Z",
    fill: "#0CF4EB"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5698 24.771L13.5054 24.9768L12.9281 25.1039L12.97 24.9035L13.5698 24.771Z",
    fill: "#0000CD"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1367 17.5982L21.1328 17.3255L21.2069 17.7194L20.2083 17.9821L20.1367 17.5982Z",
    fill: "#50FFA7"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M11.733 24.8771L11.6806 24.9494L11.119 24.6182L11.1445 24.5301L11.733 24.8771Z",
    fill: "#0000D6"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9194 13.8556L22.999 13.2899L22.7835 13.6474L22.7075 14.1736L22.9194 13.8556Z",
    fill: "#F8F500"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2539 19.9925L21.5228 19.6912L21.7687 19.7211L20.4869 20.0327L20.2539 19.9925Z",
    fill: "#00D4FF"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7945 7.09436L11.4046 7.45181L12.0014 7.58256L12.3063 7.23775L11.7945 7.09436Z",
    fill: "#890000"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2432 18.9497L20.4587 18.6846L20.6307 18.9854L19.407 19.255L19.2432 18.9497Z",
    fill: "#19FFDE"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6769 23.6561L14.6539 24.0165L14.1357 24.4736L14.1437 24.1277L14.6769 23.6561Z",
    fill: "#0000FF"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1901 16.2511L25.6988 15.7243L25.6477 15.2715L25.1392 15.8261L25.1901 16.2511Z",
    fill: "#A0FF56"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0557 23.4122L10.0801 23.5515L9.62786 22.8417L9.58173 22.6681L10.0557 23.4122Z",
    fill: "#0024FF"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90419 9.38386L8.77606 10.024L9.28752 9.38689L9.3944 8.75861L8.90419 9.38386Z",
    fill: "#FF1600"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1138 14.9917L22.5287 14.5423L22.3878 14.9507L21.9784 15.365L22.1138 14.9917Z",
    fill: "#C7FF30"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2407 14.0848L25.3493 13.4052L25.1388 13.088L25.0317 13.7812L25.2407 14.0848Z",
    fill: "#FEED00"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2261 17.9293L25.0813 17.5195L25.1606 17.109L24.3009 17.5438L24.2261 17.9293Z",
    fill: "#56FFA0"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2781 7.7667L9.952 8.30103L10.5618 8.026L10.825 7.51428L10.2781 7.7667Z",
    fill: "#A80000"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4867 20.0331L21.7685 19.7215L22.0113 19.6888L20.7166 20.0113L20.4867 20.0331Z",
    fill: "#00D4FF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1574 16.1183L21.8831 15.7679L21.8299 16.1895L21.1076 16.5147L21.1574 16.1183Z",
    fill: "#97FF60"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1073 18.6101L20.3163 18.3477L20.4583 18.6849L19.2427 18.9501L19.1073 18.6101Z",
    fill: "#29FFCE"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71615 20.535L8.83187 20.8977L8.57565 19.9132L8.44971 19.5114L8.71615 20.535Z",
    fill: "#00C4FF"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M22.662 19.2291L23.7822 18.8878L23.9635 18.6097L22.8336 18.9682L22.662 19.2291Z",
    fill: "#1CFFDB"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3323 25.0706L12.2523 25.1341L11.6805 24.9498L11.733 24.8776L12.3323 25.0706Z",
    fill: "#0000CD"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1042 17.205L21.0998 16.9202L21.1333 17.3253L20.1372 17.598L20.1042 17.205Z",
    fill: "#66FF90"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1587 13.5962L23.2423 12.9944L22.9988 13.2898L22.9191 13.8555L23.1587 13.5962Z",
    fill: "#FFDE00"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85971 13.3769L8.01059 14.0387L8.2439 13.0442L8.09489 12.3687L7.85971 13.3769Z",
    fill: "#FFD300"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 17.498L16.0942 18.1377L15.9814 19.2411L15.9139 18.6065L16.0267 17.498Z",
    fill: "#40FFB7"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M20.717 20.0114L22.0117 19.689L22.2453 19.5944L20.9379 19.9278L20.717 20.0114Z",
    fill: "#00DCFE"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0314 13.7811L25.1385 13.0878L24.8991 12.8382L24.7941 13.5385L25.0314 13.7811Z",
    fill: "#FFDB00"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1393 15.8265L25.6478 15.2719L25.5527 14.8401L25.0456 15.419L25.1393 15.8265Z",
    fill: "#B7FF40"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3149 13.027L15.5544 13.452L15.7653 14.6182L15.5057 14.1861L15.3149 13.027Z",
    fill: "#FFE600"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58197 22.6683L9.6281 22.8419L9.23583 22.036L9.17075 21.8234L9.58197 22.6683Z",
    fill: "#0054FF"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11356 17.9292L8.27627 18.4512L8.19944 17.3803L8.03387 16.825L8.11356 17.9292Z",
    fill: "#56FFA0"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0039 18.2438L20.2083 17.9822L20.3165 18.3475L19.1075 18.6099L19.0039 18.2438Z",
    fill: "#3CFFBA"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5146 21.7623L15.5415 22.2636L15.1469 23.0296L15.1123 22.5455L15.5146 21.7623Z",
    fill: "#005CFF"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5964 10.5115L14.6681 10.8564L15.0331 11.9068L14.9105 11.5498L14.5964 10.5115Z",
    fill: "#FF6400"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4201 13.4032L23.5078 12.7698L23.2428 12.995L23.1592 13.5967L23.4201 13.4032Z",
    fill: "#FFD000"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2863 14.658L22.7078 14.1744L22.5291 14.5426L22.1143 14.992L22.2863 14.658Z",
    fill: "#DEFF19"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3069 7.23761L12.002 7.58243L12.5993 7.90405L12.8194 7.56774L12.3069 7.23761Z",
    fill: "#890000"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M24.301 17.5438L25.1607 17.109L25.1973 16.6826L24.3347 17.1413L24.301 17.5438Z",
    fill: "#6DFF8A"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7938 13.5379L24.8988 12.8376L24.6368 12.6624L24.5345 13.3628L24.7938 13.5379Z",
    fill: "#FFCC00"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2475 15.7416L21.9784 15.3651L21.8829 15.7678L21.1572 16.1182L21.2475 15.7416Z",
    fill: "#ADFF49"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8329 18.9691L23.9627 18.6106L24.1121 18.2882L22.9741 18.6639L22.8329 18.9691Z",
    fill: "#2CFFCA"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1107 16.8138L21.108 16.515L21.0998 16.921L20.1042 17.2058L20.1107 16.8138Z",
    fill: "#7DFF7A"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M18.512 20.1556L19.9117 19.8184L19.6966 19.631L18.2935 19.9652L18.512 20.1556Z",
    fill: "#00DCFE"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2934 19.9651L19.6965 19.6309L19.4982 19.3917L18.0916 19.7222L18.2934 19.9651Z",
    fill: "#02E8F4"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6959 13.2805L23.7876 12.6209L23.5081 12.7696L23.4204 13.403L23.6959 13.2805Z",
    fill: "#FFC400"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1355 24.4739L14.0499 24.6914L13.5051 24.9775L13.5694 24.7717L14.1355 24.4739Z",
    fill: "#0000ED"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9383 19.9275L22.2457 19.594L22.4641 19.4398L21.1448 19.7841L20.9383 19.9275Z",
    fill: "#02E8F4"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7414 20.2892L20.1379 19.9498L19.9113 19.819L18.5116 20.1562L18.7414 20.2892Z",
    fill: "#00D4FF"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9282 25.1043L12.8207 25.1663L12.2526 25.1339L12.3326 25.0704L12.9282 25.1043Z",
    fill: "#0000D1"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5347 13.3628L24.637 12.6624L24.3594 12.5664L24.2603 13.26L24.5347 13.3628Z",
    fill: "#FFC400"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9355 17.8606L20.1374 17.5981L20.209 17.9821L19.0046 18.2437L18.9355 17.8606Z",
    fill: "#53FFA4"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0917 19.7232L19.4982 19.3927L19.3218 19.1077L17.9118 19.4338L18.0917 19.7232Z",
    fill: "#0FF8E7"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9782 13.2324L24.0737 12.5526L23.7872 12.6208L23.6955 13.2804L23.9782 13.2324Z",
    fill: "#FFC100"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0453 15.4188L25.5524 14.8399L25.4155 14.4406L24.9113 15.0396L25.0453 15.4188Z",
    fill: "#CEFF29"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2602 13.2602L24.3593 12.5666L24.0734 12.5526L23.9779 13.2324L24.2602 13.2602Z",
    fill: "#FFBD00"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9772 20.3617L20.3707 20.021L20.1384 19.95L18.7419 20.2894L18.9772 20.3617Z",
    fill: "#00D4FF"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4903 14.3722L22.9193 13.8563L22.7074 14.1743L22.286 14.6579L22.4903 14.3722Z",
    fill: "#F1FC06"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2196 9.56915L14.2297 9.90567L14.6687 10.8562L14.597 10.5113L14.2196 9.56915Z",
    fill: "#FF2D00"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9114 19.4335L19.3214 19.1074L19.1713 18.7838L17.758 19.1049L17.9114 19.4335Z",
    fill: "#1CFFDB"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34717 10.8092L8.4299 11.4612L8.85818 10.6795L8.77597 10.0233L8.34717 10.8092Z",
    fill: "#FF4E00"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M15.765 14.618L15.9196 15.1599L16.0286 16.3387L15.8703 15.7942L15.765 14.618Z",
    fill: "#C4FF33"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8194 7.56799L12.5993 7.9043L13.1805 8.4087L13.3183 8.07661L12.8194 7.56799Z",
    fill: "#9B0000"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88168 15.1067L8.0574 15.7371L8.18493 14.6933L8.01101 14.0394L7.88168 15.1067Z",
    fill: "#D4FF23"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17032 21.8239L9.2354 22.0365L8.91299 21.1538L8.83221 20.8981L9.17032 21.8239Z",
    fill: "#008CFF"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3344 17.1413L25.197 16.6826L25.1899 16.2513L24.3262 16.7321L24.3344 17.1413Z",
    fill: "#87FF70"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M19.212 20.3712L20.6027 20.03L20.3705 20.0208L18.9771 20.3615L19.212 20.3712Z",
    fill: "#00D4FF"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8246 7.51415L10.5615 8.02587L11.2077 7.9424L11.4043 7.45166L10.8246 7.51415Z",
    fill: "#8D0000"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3761 15.3945L22.1139 14.9915L21.9785 15.3648L21.2476 15.7413L21.3761 15.3945Z",
    fill: "#C4FF33"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9745 18.6635L24.1125 18.2878L24.2261 17.9293L23.0815 18.3217L22.9745 18.6635Z",
    fill: "#43FFB4"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1442 19.7843L22.4636 19.44L22.6612 19.2298L21.3308 19.5846L21.1442 19.7843Z",
    fill: "#0FF8E7"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1466 23.0303L15.1101 23.4098L14.6533 24.0165L14.6764 23.6561L15.1466 23.0303Z",
    fill: "#0028FF"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M15.981 19.2412L16.0455 19.8439L15.8291 20.8551L15.7625 20.2659L15.981 19.2412Z",
    fill: "#02E8F4"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1568 16.4323L21.1577 16.1178L21.108 16.5143L20.1107 16.8132L20.1568 16.4323Z",
    fill: "#94FF63"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44983 19.5112L8.57577 19.913L8.40841 18.8936L8.27557 18.451L8.44983 19.5112Z",
    fill: "#1CFFDB"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1191 24.6181L11.0603 24.573L10.5518 24.1289L10.5812 24.1483L11.1191 24.6181Z",
    fill: "#0000FF"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9022 17.4701L20.1036 17.2051L20.1367 17.598L18.9348 17.8605L18.9022 17.4701Z",
    fill: "#66FF90"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5806 24.1488L10.5512 24.1294L10.0773 23.565L10.0795 23.5519L10.5806 24.1488Z",
    fill: "#0010FF"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7582 19.1051L19.1715 18.784L19.0515 18.4298L17.6351 18.7455L17.7582 19.1051Z",
    fill: "#30FFC7"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9115 15.0394L25.4157 14.4403L25.2405 14.0841L24.7404 14.6986L24.9115 15.0394Z",
    fill: "#E4FF13"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7891 8.74963L13.7289 9.08182L14.2296 9.90549L14.2195 9.56897L13.7891 8.74963Z",
    fill: "#E80000"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3173 8.07666L13.1795 8.40875L13.7283 9.08219L13.7885 8.75L13.3173 8.07666Z",
    fill: "#BB0000"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39482 8.75772L9.28793 9.386L9.86917 8.91672L9.9521 8.30042L9.39482 8.75772Z",
    fill: "#D10000"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7215 14.1423L23.1588 13.5967L22.9192 13.856L22.4902 14.3719L22.7215 14.1423Z",
    fill: "#FEED00"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6808 24.9494L11.5913 24.8863L11.0604 24.5732L11.1192 24.6183L11.6808 24.9494Z",
    fill: "#0000F1"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0334 11.9064L15.2425 12.3278L15.5543 13.4519L15.3148 13.0269L15.0334 11.9064Z",
    fill: "#FF9F00"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4408 20.3175L20.8292 19.9769L20.603 20.0298L19.2122 20.3709L19.4408 20.3175Z",
    fill: "#00D8FF"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0796 23.5521L10.0774 23.5652L9.6498 22.8941L9.62729 22.8423L10.0796 23.5521Z",
    fill: "#0038FF"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5047 24.9769L13.3704 25.0449L12.8198 25.166L12.9273 25.104L13.5047 24.9769Z",
    fill: "#0000E3"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3261 16.7323L25.1898 16.2515L25.1388 15.8265L24.2757 16.3271L24.3261 16.7323Z",
    fill: "#9DFF5A"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6351 18.7453L19.0515 18.4296L18.9649 18.0538L17.5456 18.3638L17.6351 18.7453Z",
    fill: "#43FFB4"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7405 14.6994L25.2406 14.0849L25.0317 13.7814L24.537 14.4062L24.7405 14.6994Z",
    fill: "#F4F802"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3306 19.5843L22.661 19.2295L22.8326 18.9686L21.4924 19.3331L21.3306 19.5843Z",
    fill: "#1FFFD7"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5398 15.0868L22.2861 14.6578L22.114 14.9918L21.3762 15.3947L21.5398 15.0868Z",
    fill: "#D7FF1F"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0706 20.5286L18.5123 20.1558L18.2937 19.9655L16.8433 20.3305L17.0706 20.5286Z",
    fill: "#00D8FF"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0811 18.3223L24.2257 17.9299L24.3005 17.5444L23.1509 17.9527L23.0811 18.3223Z",
    fill: "#56FFA0"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8428 20.3309L18.2932 19.9659L18.0915 19.723L16.6325 20.0782L16.8428 20.3309Z",
    fill: "#00E4F8"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9744 13.9747L23.4204 13.403L23.1594 13.5965L22.7222 14.1421L22.9744 13.9747Z",
    fill: "#FFDE00"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M18.907 17.0821L20.1101 16.8128L20.1036 17.2047L18.9022 17.4698L18.907 17.0821Z",
    fill: "#7DFF7A"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2408 16.0724L21.2475 15.741L21.1572 16.1176L20.1562 16.4322L20.2408 16.0724Z",
    fill: "#AAFF4D"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2522 25.1339L12.1315 25.0607L11.591 24.8865L11.6804 24.9497L12.2522 25.1339Z",
    fill: "#0000E8"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3091 20.6673L18.7418 20.2889L18.512 20.1559L17.0703 20.5287L17.3091 20.6673Z",
    fill: "#00D0FF"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03305 16.8248L8.19862 17.3801L8.22219 16.3254L8.05665 15.7369L8.03305 16.8248Z",
    fill: "#94FF63"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6331 20.0779L18.0921 19.7226L17.9122 19.4332L16.4453 19.7769L16.6331 20.0779Z",
    fill: "#0CF4EB"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6564 20.2021L21.043 19.8629L20.8286 19.9768L19.4401 20.3173L19.6564 20.2021Z",
    fill: "#00E4F8"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0289 16.3392L16.0967 16.9837L16.0937 18.1377L16.0262 17.498L16.0289 16.3392Z",
    fill: "#83FF73"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09491 12.3689L8.24392 13.0444L8.57645 12.1494L8.43043 11.4612L8.09491 12.3689Z",
    fill: "#FF9100"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M14.654 24.0166L14.5488 24.2519L14.0503 24.6912L14.1359 24.4737L14.654 24.0166Z",
    fill: "#0008FF"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5366 14.4055L25.0313 13.7807L24.7941 13.5381L24.3058 14.1678L24.5366 14.4055Z",
    fill: "#FFE600"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5529 20.7423L18.9768 20.3609L18.7415 20.2886L17.3088 20.6669L17.5529 20.7423Z",
    fill: "#00CCFF"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8291 20.855L15.8499 21.3762L15.542 22.2644L15.5151 21.7631L15.8291 20.855Z",
    fill: "#00A0FF"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8321 20.8979L8.91287 21.1536L8.66867 20.2152L8.57587 19.9134L8.8321 20.8979Z",
    fill: "#00CCFF"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2409 13.8745L23.6959 13.2809L23.4205 13.4034L22.9745 13.9751L23.2409 13.8745Z",
    fill: "#FFD300"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62731 22.8417L9.64982 22.8935L9.27902 22.1317L9.23505 22.0358L9.62731 22.8417Z",
    fill: "#0064FF"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4449 19.7775L17.9118 19.4339L17.7583 19.1053L16.2842 19.4358L16.4449 19.7775Z",
    fill: "#1CFFDB"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5454 18.3636L18.9647 18.0536L18.9137 17.6656L17.4919 17.9698L17.5454 18.3636Z",
    fill: "#5AFF9D"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4044 7.45166L11.2077 7.9424L11.8725 8.05431L12.0012 7.58244L11.4044 7.45166Z",
    fill: "#800000"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2757 16.3268L25.1387 15.8263L25.0451 15.4188L24.1846 15.9363L24.2757 16.3268Z",
    fill: "#B4FF43"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3063 14.1679L24.7945 13.5382L24.5352 13.3631L24.0544 13.9921L24.3063 14.1679Z",
    fill: "#FFDB00"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7344 14.8261L22.4902 14.3722L22.2859 14.6579L21.5397 15.0868L21.7344 14.8261Z",
    fill: "#E7FF0F"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5143 13.8428L23.9783 13.2321L23.6956 13.2801L23.2406 13.8737L23.5143 13.8428Z",
    fill: "#FFD000"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7971 20.7536L19.2125 20.3714L18.9776 20.3618L17.5537 20.7433L17.7971 20.7536Z",
    fill: "#00D0FF"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4933 19.3331L22.8336 18.9686L22.9749 18.6634L21.6262 19.0368L21.4933 19.3331Z",
    fill: "#30FFC7"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0546 13.9916L24.5354 13.3626L24.2609 13.2598L23.7883 13.8824L24.0546 13.9916Z",
    fill: "#FFD000"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7877 13.8833L24.2603 13.2607L23.978 13.2329L23.514 13.8437L23.7877 13.8833Z",
    fill: "#FFCC00"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1511 17.9524L24.3006 17.5441L24.3344 17.1416L23.1818 17.5644L23.1511 17.9524Z",
    fill: "#6DFF8A"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9493 16.7079L20.1563 16.4327L20.1102 16.8136L18.9071 17.0829L18.9493 16.7079Z",
    fill: "#94FF63"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M20.362 15.7432L21.3761 15.3943L21.2476 15.7412L20.2409 16.0725L20.362 15.7432Z",
    fill: "#C1FF36"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8559 20.028L21.2411 19.6912L21.044 19.8633L19.6574 20.2025L19.8559 20.028Z",
    fill: "#0CF4EB"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2842 19.4357L17.7584 19.1052L17.6353 18.7456L16.1548 19.0617L16.2842 19.4357Z",
    fill: "#2CFFCA"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6688 10.8566L14.8381 11.278L15.2429 12.3284L15.0338 11.907L14.6688 10.8566Z",
    fill: "#FF6000"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5542 13.4526L15.701 13.9939L15.9198 15.1608L15.7651 14.6188L15.5542 13.4526Z",
    fill: "#FFE600"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8202 25.1663L12.6682 25.0912L12.1313 25.0607L12.2521 25.1339L12.8202 25.1663Z",
    fill: "#0000ED"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2759 18.4509L8.40874 18.8935L8.33524 17.8643L8.19907 17.38L8.2759 18.4509Z",
    fill: "#56FFA0"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4925 17.9703L18.9143 17.6661L18.9004 17.2759L17.4764 17.5741L17.4925 17.9703Z",
    fill: "#6DFF8A"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0327 20.6982L19.4402 20.3179L19.2117 20.3713L17.7962 20.7535L18.0327 20.6982Z",
    fill: "#00D4FF"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77606 10.0239L8.85827 10.6802L9.36903 10.0469L9.28753 9.38684L8.77606 10.0239Z",
    fill: "#FF1A00"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1849 15.9363L25.0454 15.4187L24.9114 15.0396L24.0552 15.5708L24.1849 15.9363Z",
    fill: "#CAFF2C"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0605 24.5734L11.0031 24.4035L10.5266 23.9873L10.5519 24.1293L11.0605 24.5734Z",
    fill: "#000CFF"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M14.05 24.6912L13.8901 24.7727L13.3708 25.0454L13.5051 24.9773L14.05 24.6912Z",
    fill: "#0000FF"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6736 20.939L17.0706 20.529L16.8432 20.3309L15.4321 20.7285L15.6736 20.939Z",
    fill: "#00D0FF"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M15.432 20.7281L16.8431 20.3305L16.6328 20.0778L15.2083 20.4597L15.432 20.7281Z",
    fill: "#00DCFE"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5512 24.1292L10.5258 23.9873L10.0817 23.4583L10.0773 23.5648L10.5512 24.1292Z",
    fill: "#0028FF"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9548 14.6189L22.7213 14.1419L22.49 14.3716L21.7342 14.8255L21.9548 14.6189Z",
    fill: "#F8F500"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95191 8.30042L9.86899 8.91672L10.5048 8.62984L10.5617 8.02539L9.95191 8.30042Z",
    fill: "#A40000"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M15.927 21.0867L17.3096 20.668L17.0708 20.5294L15.6738 20.9394L15.927 21.0867Z",
    fill: "#00C8FF"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5418 22.2645L15.4939 22.6674L15.1107 23.41L15.1472 23.0304L15.5418 22.2645Z",
    fill: "#0064FF"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01025 14.0386L8.18417 14.6925L8.41362 13.7203L8.24356 13.0441L8.01025 14.0386Z",
    fill: "#FFD700"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2352 22.0364L9.27917 22.1323L8.9745 21.2981L8.91278 21.1536L9.2352 22.0364Z",
    fill: "#0098FF"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1552 19.0615L17.6357 18.7454L17.5462 18.3639L16.0604 18.6648L16.1552 19.0615Z",
    fill: "#43FFB4"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 20.4604L16.6329 20.0785L16.445 19.7775L15.0081 20.1408L15.2084 20.4604Z",
    fill: "#06ECF1"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5909 24.8861L11.5001 24.6964L11.0026 24.4031L11.06 24.573L11.5909 24.8861Z",
    fill: "#0000FF"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6252 19.0367L22.9739 18.6633L23.0809 18.3216L21.7254 18.7026L21.6252 19.0367Z",
    fill: "#43FFB4"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1823 17.5643L24.3348 17.1415L24.3266 16.7322L23.173 17.1679L23.1823 17.5643Z",
    fill: "#83FF73"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 7.58264L11.8726 8.05451L12.5375 8.35984L12.5986 7.90425L12.0013 7.58264Z",
    fill: "#840000"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0308 19.7986L21.4151 19.465L21.2403 19.6911L19.8552 20.0279L20.0308 19.7986Z",
    fill: "#19FFDE"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0935 18.1377L16.157 18.7549L16.0451 19.8439L15.9807 19.2412L16.0935 18.1377Z",
    fill: "#40FFB7"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1855 21.1669L17.5536 20.7432L17.3095 20.6678L15.9269 21.0865L16.1855 21.1669Z",
    fill: "#00C4FF"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5167 15.4532L21.54 15.0867L21.3763 15.3947L20.3622 15.7435L20.5167 15.4532Z",
    fill: "#D4FF23"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0282 16.3555L20.241 16.0731L20.1564 16.4329L18.9494 16.7081L19.0282 16.3555Z",
    fill: "#AAFF4D"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0777 23.5647L10.0821 23.4582L9.6814 22.8292L9.65009 22.8936L10.0777 23.5647Z",
    fill: "#004CFF"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2566 20.5784L19.6568 20.2023L19.4405 20.3176L18.0331 20.6979L18.2566 20.5784Z",
    fill: "#00E0FB"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0081 20.1408L16.445 19.7774L16.2843 19.4357L14.8364 19.778L15.0081 20.1408Z",
    fill: "#16FFE1"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M24.055 15.5713L24.9112 15.0401L24.7402 14.6993L23.89 15.2406L24.055 15.5713Z",
    fill: "#DEFF19"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2293 9.90607L14.3504 10.331L14.8376 11.2781L14.6683 10.8566L14.2293 9.90607Z",
    fill: "#FF2900"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1964 14.4728L22.9742 13.9751L22.7221 14.1425L21.9556 14.6195L22.1964 14.4728Z",
    fill: "#FFEA00"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4764 17.5734L18.9004 17.2751L18.9239 16.8926L17.4983 17.1851L17.4764 17.5734Z",
    fill: "#83FF73"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57639 19.9131L8.66919 20.2149L8.50985 19.2435L8.40903 18.8937L8.57639 19.9131Z",
    fill: "#1FFFD7"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1311 25.0607L12.0062 24.8599L11.4998 24.6969L11.5906 24.8866L12.1311 25.0607Z",
    fill: "#0000FF"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4423 21.1776L17.7964 20.753L17.553 20.7427L16.1849 21.1663L16.4423 21.1776Z",
    fill: "#00C4FF"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0602 18.6648L17.546 18.3638L17.4925 17.97L16.0026 18.2552L16.0602 18.6648Z",
    fill: "#56FFA0"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M13.371 25.0455L13.1885 24.9769L12.6685 25.0915L12.8205 25.1666L13.371 25.0455Z",
    fill: "#0000FF"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8361 19.7776L16.2841 19.4353L16.1547 19.0613L14.6973 19.3807L14.8361 19.7776Z",
    fill: "#29FFCE"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8899 15.24L24.7401 14.6988L24.5365 14.4056L23.6938 14.9528L23.8899 15.24Z",
    fill: "#EEFF09"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5985 7.90411L12.5374 8.3597L13.184 8.85067L13.1797 8.40851L12.5985 7.90411Z",
    fill: "#920000"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1103 23.4095L14.9876 23.6684L14.5483 24.2515L14.6536 24.0162L15.1103 23.4095Z",
    fill: "#0038FF"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4512 14.3896L23.2408 13.8741L22.9743 13.9747L22.1965 14.4724L22.4512 14.3896Z",
    fill: "#FFDE00"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1727 17.1679L24.3262 16.7322L24.2759 16.327L23.1234 16.7736L23.1727 17.1679Z",
    fill: "#9AFF5D"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64979 22.8938L9.68111 22.8294L9.33372 22.1155L9.27899 22.132L9.64979 22.8938Z",
    fill: "#0074FF"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7261 18.7028L23.0816 18.3218L23.1515 17.9521L21.7911 18.3395L21.7261 18.7028Z",
    fill: "#5AFF9D"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3963 21.3838L15.6733 20.9385L15.4318 20.728L14.1357 21.1566L14.3963 21.3838Z",
    fill: "#00C4FF"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1357 21.1572L15.4318 20.7287L15.2081 20.4603L13.894 20.8677L14.1357 21.1572Z",
    fill: "#00D0FF"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05664 15.7367L8.22218 16.3251L8.34672 15.3136L8.18416 14.6929L8.05664 15.7367Z",
    fill: "#D1FF26"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M20.701 15.2103L21.7347 14.8263L21.5401 15.0871L20.5168 15.4536L20.701 15.2103Z",
    fill: "#E4FF13"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7289 9.08167L13.7944 9.51354L14.3507 10.3303L14.2296 9.90535L13.7289 9.08167Z",
    fill: "#DF0000"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1791 19.5196L21.563 19.1899L21.4152 19.4646L20.0309 19.7982L20.1791 19.5196Z",
    fill: "#29FFCE"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9196 15.16L15.9879 15.8093L16.0963 16.9833L16.0285 16.3387L15.9196 15.16Z",
    fill: "#C4FF33"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6689 21.5431L15.9264 21.0861L15.6732 20.9388L14.3962 21.384L14.6689 21.5431Z",
    fill: "#00BCFF"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4609 20.3976L19.8549 20.0281L19.6563 20.2026L18.256 20.5786L18.4609 20.3976Z",
    fill: "#09F0EE"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1417 16.0344L20.3622 15.7435L20.2411 16.0728L19.0283 16.3553L19.1417 16.0344Z",
    fill: "#BEFF39"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1795 8.40869L13.1838 8.85085L13.7938 9.51403L13.7282 9.08215L13.1795 8.40869Z",
    fill: "#B20000"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6927 21.1195L18.0334 20.6979L17.797 20.7531L16.4429 21.1778L16.6927 21.1195Z",
    fill: "#00CCFF"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8943 20.8675L15.2084 20.46L15.0081 20.1404L13.6776 20.5228L13.8943 20.8675Z",
    fill: "#00E0FB"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6936 14.9529L24.5363 14.4057L24.3055 14.168L23.4717 14.7171L23.6936 14.9529Z",
    fill: "#FBF100"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43018 11.4617L8.5762 12.1499L9.00045 11.3795L8.85845 10.68L8.43018 11.4617Z",
    fill: "#FF5200"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7131 14.3731L23.5144 13.8433L23.2407 13.8742L22.4512 14.3897L22.7131 14.3731Z",
    fill: "#FFDB00"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2425 12.3279L15.3773 12.8703L15.701 13.9932L15.5543 13.452L15.2425 12.3279Z",
    fill: "#FF9F00"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91283 21.1538L8.97455 21.2983L8.74391 20.4117L8.66864 20.2153L8.91283 21.1538Z",
    fill: "#00D4FF"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0023 24.4029L10.9928 24.1234L10.5499 23.7366L10.5257 23.9867L11.0023 24.4029Z",
    fill: "#0028FF"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9471 21.6301L16.1848 21.1664L15.9262 21.0861L14.6688 21.5431L14.9471 21.6301Z",
    fill: "#00B8FF"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4976 17.1854L18.9232 16.8929L18.9839 16.528L17.5571 16.815L17.4976 17.1854Z",
    fill: "#9AFF5D"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0449 19.8434L16.0615 20.3867L15.8493 21.3757L15.8285 20.8545L16.0449 19.8434Z",
    fill: "#02E8F4"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5263 23.9869L10.5505 23.7368L10.1378 23.2451L10.0822 23.4579L10.5263 23.9869Z",
    fill: "#0040FF"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0019 18.255L17.4917 17.9698L17.4756 17.5737L15.9831 17.8431L16.0019 18.255Z",
    fill: "#6DFF8A"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6979 19.3802L16.1553 19.0609L16.0605 18.6642L14.5956 18.9591L14.6979 19.3802Z",
    fill: "#40FFB7"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4726 14.7172L24.3064 14.168L24.0546 13.9922L23.2308 14.5391L23.4726 14.7172Z",
    fill: "#FFE600"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9754 14.4233L23.7882 13.8829L23.5146 13.8433L22.7132 14.3731L22.9754 14.4233Z",
    fill: "#FFD700"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6678 25.091L12.5088 24.8879L12.006 24.8597L12.131 25.0605L12.6678 25.091Z",
    fill: "#0000FF"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2307 14.5392L24.0544 13.9923L23.7881 13.8831L22.9753 14.4235L23.2307 14.5392Z",
    fill: "#FFDB00"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6776 20.5226L15.0082 20.1402L14.8364 19.7775L13.4912 20.1314L13.6776 20.5226Z",
    fill: "#0FF8E7"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5006 24.6969L11.456 24.3964L10.9937 24.124L11.0032 24.4036L11.5006 24.6969Z",
    fill: "#0018FF"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5623 8.02584L10.5054 8.63029L11.1788 8.53538L11.2084 7.94238L10.5623 8.02584Z",
    fill: "#890000"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5484 24.2518L14.3649 24.3538L13.89 24.7726L14.0498 24.6911L14.5484 24.2518Z",
    fill: "#0018FF"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1237 16.7736L24.2762 16.3269L24.185 15.9363L23.0355 16.3917L23.1237 16.7736Z",
    fill: "#B1FF46"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9097 15.0195L21.9551 14.6188L21.7344 14.8253L20.7007 15.2093L20.9097 15.0195Z",
    fill: "#F1FC06"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 23.4582L10.1381 23.2454L9.76579 22.6608L9.68182 22.8293L10.0825 23.4582Z",
    fill: "#0060FF"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7912 18.3393L23.1516 17.952L23.1824 17.564L21.819 17.9561L21.7912 18.3393Z",
    fill: "#6DFF8A"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2239 21.6429L16.4423 21.1779L16.1849 21.1666L14.9471 21.6303L15.2239 21.6429Z",
    fill: "#00B8FF"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19907 17.3801L8.33524 17.8643L8.35844 16.851L8.22264 16.3253L8.19907 17.3801Z",
    fill: "#94FF63"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9286 20.9929L18.2569 20.5782L18.0334 20.6978L16.6927 21.1194L16.9286 20.9929Z",
    fill: "#00D8FF"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2975 21.8583L14.3964 21.384L14.1359 21.1569L13.0135 21.6106L13.2975 21.8583Z",
    fill: "#00B4FF"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2958 19.1992L21.6798 18.8741L21.5629 19.1904L20.179 19.5201L20.2958 19.1992Z",
    fill: "#3CFFBA"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6428 20.1592L20.0316 19.7986L19.8559 20.028L18.4619 20.3974L18.6428 20.1592Z",
    fill: "#16FFE1"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0136 21.6105L14.136 21.1567L13.8944 20.8672L12.7498 21.2948L13.0136 21.6105Z",
    fill: "#00C0FF"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27928 22.1319L9.33401 22.1154L9.04868 21.3338L8.97461 21.2977L9.27928 22.1319Z",
    fill: "#00A8FF"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2867 15.7533L20.5165 15.4529L20.3619 15.7432L19.1414 16.0341L19.2867 15.7533Z",
    fill: "#D1FF26"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28793 9.38658L9.36944 10.0467L9.9498 9.58065L9.86918 8.9173L9.28793 9.38658Z",
    fill: "#D10000"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5946 22.0319L14.6693 21.543L14.3965 21.3839L13.2975 21.8582L13.5946 22.0319Z",
    fill: "#00A8FF"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4911 20.1312L14.8363 19.7773L14.6974 19.3804L13.3398 19.7032L13.4911 20.1312Z",
    fill: "#23FFD4"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0069 24.86L11.9263 24.5477L11.4559 24.3966L11.5006 24.6971L12.0069 24.86Z",
    fill: "#0010FF"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 21.2953L13.8946 20.8676L13.6778 20.5229L12.513 20.9197L12.7501 21.2953Z",
    fill: "#00D4FF"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5952 18.9593L16.0602 18.6644L16.0026 18.2549L14.5321 18.5246L14.5952 18.9593Z",
    fill: "#56FFA0"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8903 24.7727L13.6788 24.7189L13.1885 24.9768L13.371 25.0454L13.8903 24.7727Z",
    fill: "#0008FF"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9839 17.8432L17.4764 17.5738L17.4984 17.1855L16.0045 17.4394L15.9839 17.8432Z",
    fill: "#83FF73"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5578 16.8152L18.9846 16.5281L19.0809 16.1902L17.6536 16.4723L17.5578 16.8152Z",
    fill: "#B1FF46"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0349 16.3918L24.1845 15.9364L24.0547 15.5709L22.9102 16.0325L23.0349 16.3918Z",
    fill: "#C4FF33"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8973 22.1275L14.9475 21.6305L14.6692 21.5435L13.5946 22.0323L13.8973 22.1275Z",
    fill: "#00A8FF"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1383 14.8885L22.1961 14.4723L21.9552 14.619L20.9099 15.0197L21.1383 14.8885Z",
    fill: "#FEED00"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8499 21.3758L15.7929 21.8058L15.494 22.667L15.5419 22.2641L15.8499 21.3758Z",
    fill: "#00A8FF"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4921 21.5803L16.6921 21.1194L16.4422 21.1777L15.2238 21.6427L15.4921 21.5803Z",
    fill: "#00C0FF"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9939 24.1244L11.0843 23.7556L10.6757 23.3989L10.551 23.7377L10.9939 24.1244Z",
    fill: "#0040FF"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68171 22.8296L9.76568 22.6611L9.44301 21.9976L9.33432 22.1157L9.68171 22.8296Z",
    fill: "#0088FF"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40846 18.8935L8.50928 19.2434L8.43954 18.263L8.33496 17.8643L8.40846 18.8935Z",
    fill: "#5AFF9D"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5502 23.7372L10.675 23.3984L10.2944 22.9448L10.1375 23.2455L10.5502 23.7372Z",
    fill: "#0058FF"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24384 13.0446L8.4139 13.7209L8.74057 12.8465L8.57637 12.1497L8.24384 13.0446Z",
    fill: "#FF9400"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M12.513 20.9194L13.6778 20.5227L13.4914 20.1315L12.3088 20.4931L12.513 20.9194Z",
    fill: "#06ECF1"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4134 22.3509L13.2972 21.8587L13.0132 21.611L12.1021 22.0792L12.4134 22.3509Z",
    fill: "#00A0FF"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1445 20.8007L18.4619 20.3968L18.2571 20.5778L16.9287 20.9925L17.1445 20.8007Z",
    fill: "#02E8F4"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1027 22.0791L13.0139 21.6108L12.7501 21.2952L11.8132 21.7332L12.1027 22.0791Z",
    fill: "#00B0FF"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0967 16.9837L16.1604 17.6159L16.1573 18.7548L16.0938 18.1376L16.0967 16.9837Z",
    fill: "#83FF73"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M11.456 24.3966L11.5105 24.0064L11.0841 23.7554L10.9937 24.1242L11.456 24.3966Z",
    fill: "#0034FF"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8185 17.956L23.1819 17.5639L23.1726 17.1676L21.8083 17.5629L21.8185 17.956Z",
    fill: "#83FF73"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M13.188 24.9762L12.9958 24.7799L12.509 24.8877L12.6679 25.0908L13.188 24.9762Z",
    fill: "#0008FF"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3397 19.7036L14.6973 19.3807L14.595 18.9596L13.2275 19.2494L13.3397 19.7036Z",
    fill: "#39FFBE"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 11.2773L14.957 11.8226L15.3776 12.8701L15.2429 12.3278L14.8381 11.2773Z",
    fill: "#FF6000"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7391 22.5413L13.5947 22.0321L13.2976 21.8584L12.4138 22.3506L12.7391 22.5413Z",
    fill: "#0094FF"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4597 15.52L20.7003 15.2096L20.5162 15.4529L19.2863 15.7532L19.4597 15.52Z",
    fill: "#E1FF16"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M18.794 19.87L20.1788 19.5203L20.0306 19.7989L18.6418 20.1595L18.794 19.87Z",
    fill: "#29FFCE"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3784 18.8441L21.7632 18.5242L21.6803 18.874L20.2962 19.1991L20.3784 18.8441Z",
    fill: "#53FFA4"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1379 23.2454L10.2948 22.9447L9.95155 22.4053L9.76562 22.6608L10.1379 23.2454Z",
    fill: "#0074FF"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1982 22.141L15.2242 21.6423L14.9475 21.6297L13.8973 22.1268L14.1982 22.141Z",
    fill: "#00A8FF"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9105 16.0321L24.0551 15.5705L23.8901 15.2397L22.7523 15.7049L22.9105 16.0321Z",
    fill: "#D7FF1F"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8124 21.7328L12.7493 21.2948L12.5123 20.9193L11.5519 21.3212L11.8124 21.7328Z",
    fill: "#00C4FF"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3805 14.8204L22.451 14.3901L22.1963 14.473L21.1385 14.8892L21.3805 14.8204Z",
    fill: "#FFE600"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66847 20.215L8.74374 20.4114L8.59338 19.494L8.50912 19.2437L8.66847 20.215Z",
    fill: "#26FFD1"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5097 24.8885L12.3933 24.5738L11.9263 24.548L12.0068 24.8603L12.5097 24.8885Z",
    fill: "#0014FF"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5322 18.5247L16.0028 18.255L15.984 17.8431L14.5101 18.0873L14.5322 18.5247Z",
    fill: "#6DFF8A"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M11.208 7.94238L11.1784 8.53538L11.871 8.6365L11.8728 8.05429L11.208 7.94238Z",
    fill: "#800000"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M11.084 23.7551L11.325 23.3206L10.9506 22.9937L10.6755 23.3984L11.084 23.7551Z",
    fill: "#005CFF"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7586 22.8447L12.4134 22.3506L12.1021 22.0789L11.4168 22.5464L11.7586 22.8447Z",
    fill: "#008CFF"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6752 23.3984L10.9503 22.9937L10.6015 22.5778L10.2946 22.9448L10.6752 23.3984Z",
    fill: "#0070FF"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3082 20.4931L13.4909 20.1315L13.3397 19.7034L12.1419 20.0266L12.3082 20.4931Z",
    fill: "#1CFFDB"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4167 22.5464L12.102 22.0789L11.8125 21.733L11.0986 22.1668L11.4167 22.5464Z",
    fill: "#009CFF"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0698 22.6457L13.8967 22.127L13.594 22.0317L12.7385 22.5409L13.0698 22.6457Z",
    fill: "#0094FF"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9263 24.5473L11.9444 24.145L11.5104 24.006L11.4559 24.3961L11.9263 24.5473Z",
    fill: "#002CFF"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7015 13.993L15.7704 14.6469L15.9886 15.8092L15.9203 15.1599L15.7015 13.993Z",
    fill: "#FFE600"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7453 21.4448L16.9282 20.9933L16.6923 21.1198L15.4924 21.5807L15.7453 21.4448Z",
    fill: "#00CCFF"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4937 22.6673L15.3561 22.9551L14.9878 23.6688L15.1105 23.4099L15.4937 22.6673Z",
    fill: "#0070FF"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0042 17.4395L17.4981 17.1857L17.5576 16.8152L16.0639 17.0543L16.0042 17.4395Z",
    fill: "#9AFF5D"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M17.653 16.4722L19.0803 16.1902L19.2101 15.8883L17.7827 16.1659L17.653 16.4722Z",
    fill: "#C4FF33"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M11.325 23.3202L11.7591 22.8443L11.4173 22.546L10.9505 22.9933L11.325 23.3202Z",
    fill: "#0074FF"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1156 23.0544L12.7388 22.5414L12.4134 22.3507L11.7586 22.8448L12.1156 23.0544Z",
    fill: "#0080FF"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5096 24.0064L11.7152 23.5507L11.3242 23.3208L11.0832 23.7553L11.5096 24.0064Z",
    fill: "#004CFF"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97497 21.2981L9.04904 21.3342L8.83316 20.5038L8.74432 20.4114L8.97497 21.2981Z",
    fill: "#00E0FB"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7527 15.7056L23.8904 15.2404L23.6944 14.9532L22.5651 15.4193L22.7527 15.7056Z",
    fill: "#E7FF0F"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9501 22.9938L11.4169 22.5465L11.0988 22.1668L10.6014 22.5779L10.9501 22.9938Z",
    fill: "#0084FF"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6292 14.8153L22.7127 14.373L22.4508 14.3896L21.3802 14.8199L21.6292 14.8153Z",
    fill: "#FFE200"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5522 21.3219L12.5126 20.92L12.3083 20.4937L11.3273 20.8548L11.5522 21.3219Z",
    fill: "#00E0FB"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0987 22.1666L11.8125 21.7329L11.552 21.3213L10.8122 21.715L11.0987 22.1666Z",
    fill: "#00B4FF"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2944 22.9448L10.6013 22.5777L10.287 22.083L9.95117 22.4053L10.2944 22.9448Z",
    fill: "#008CFF"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33401 22.1153L9.4427 21.9971L9.17781 21.2708L9.04868 21.3337L9.33401 22.1153Z",
    fill: "#00B4FF"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7159 23.5505L12.1159 23.0543L11.7589 22.8447L11.3249 23.3206L11.7159 23.5505Z",
    fill: "#0068FF"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8084 17.5633L23.1727 17.168L23.1234 16.7737L21.7603 17.1705L21.8084 17.5633Z",
    fill: "#9AFF5D"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76523 22.661L9.95116 22.4055L9.65383 21.7933L9.44257 21.9975L9.76523 22.661Z",
    fill: "#009CFF"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3346 20.5488L18.6426 20.1592L18.4618 20.3974L17.1444 20.8013L17.3346 20.5488Z",
    fill: "#13FCE4"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4898 22.0745L15.4928 21.5809L15.2245 21.6432L14.1984 22.1419L14.4898 22.0745Z",
    fill: "#00B0FF"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18442 14.6926L8.34698 15.3133L8.5705 14.3715L8.41387 13.7203L8.18442 14.6926Z",
    fill: "#FFDB00"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2277 19.2496L14.5951 18.9598L14.532 18.525L13.1576 18.7807L13.2277 19.2496Z",
    fill: "#53FFA4"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6576 15.3411L20.9101 15.02L20.701 15.2098L19.4604 15.5203L19.6576 15.3411Z",
    fill: "#EEFF09"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5647 15.4191L23.694 14.9531L23.4721 14.7173L22.3527 15.1814L22.5647 15.4191Z",
    fill: "#F4F802"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6016 22.5779L11.099 22.1668L10.8125 21.7151L10.2873 22.0832L10.6016 22.5779Z",
    fill: "#00A0FF"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8787 14.8753L22.9749 14.4232L22.7128 14.373L21.6292 14.8153L21.8787 14.8753Z",
    fill: "#FFE200"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4793 23.1697L13.0705 22.6459L12.7391 22.5411L12.1159 23.0542L12.4793 23.1697Z",
    fill: "#007CFF"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3995 22.6626L14.1982 22.142L13.8974 22.1277L13.0705 22.6465L13.3995 22.6626Z",
    fill: "#0094FF"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M14.988 23.6683L14.7835 23.7978L14.3652 24.3534L14.5487 24.2514L14.988 23.6683Z",
    fill: "#0044FF"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85907 10.6801L9.00106 11.3796L9.50681 10.7559L9.36983 10.0469L8.85907 10.6801Z",
    fill: "#FF1E00"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4236 18.4642L21.8097 18.1499L21.7632 18.5244L20.3784 18.8443L20.4236 18.4642Z",
    fill: "#66FF90"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9444 24.145L12.1139 23.6773L11.716 23.5503L11.5104 24.006L11.9444 24.145Z",
    fill: "#0048FF"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3523 15.1813L23.4717 14.7172L23.2298 14.5391L22.1216 14.9985L22.3523 15.1813Z",
    fill: "#FEED00"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9141 19.5359L20.2963 19.1989L20.1796 19.5197L18.7948 19.8694L18.9141 19.5359Z",
    fill: "#3CFFBA"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1224 14.9986L23.2306 14.5392L22.9753 14.4235L21.8791 14.8755L22.1224 14.9986Z",
    fill: "#FFE200"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1422 20.0267L13.34 19.7035L13.2278 19.2493L12.0182 19.5317L12.1422 20.0267Z",
    fill: "#36FFC1"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1134 23.6771L12.4789 23.1693L12.1155 23.0538L11.7155 23.5501L12.1134 23.6771Z",
    fill: "#0064FF"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 21.7149L11.5523 21.3213L11.3275 20.8541L10.5648 21.2023L10.8125 21.7149Z",
    fill: "#00D0FF"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3506 10.3309L14.4501 10.8807L14.9567 11.8232L14.8378 11.278L14.3506 10.3309Z",
    fill: "#FF2900"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5093 18.0875L15.9832 17.8432L16.0038 17.4395L14.5288 17.6588L14.5093 18.0875Z",
    fill: "#87FF70"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3933 24.5732L12.375 24.1684L11.9443 24.1451L11.9263 24.5474L12.3933 24.5732Z",
    fill: "#0030FF"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3278 20.854L12.3088 20.4929L12.1425 20.0265L11.1442 20.3429L11.3278 20.854Z",
    fill: "#13FCE4"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1568 18.7545L16.1713 19.3217L16.0615 20.3869L16.0449 19.8436L16.1568 18.7545Z",
    fill: "#43FFB4"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95147 22.4052L10.2873 22.0829L10.0152 21.5215L9.65414 21.793L9.95147 22.4052Z",
    fill: "#00ACFF"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3656 24.3535L14.1273 24.3226L13.6792 24.7184L13.8907 24.7723L14.3656 24.3535Z",
    fill: "#002CFF"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86899 8.91773L9.9496 9.58108L10.5844 9.2968L10.5049 8.63086L9.86899 8.91773Z",
    fill: "#A80000"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9767 21.2381L17.1441 20.8013L16.9283 20.9931L15.7455 21.4446L15.9767 21.2381Z",
    fill: "#00DCFE"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8727 8.05383L11.8709 8.63604L12.5635 8.93145L12.5377 8.35917L11.8727 8.05383Z",
    fill: "#800000"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9966 24.78L12.8454 24.4723L12.3934 24.573L12.5097 24.8878L12.9966 24.78Z",
    fill: "#0020FF"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7832 16.1658L19.2105 15.8882L19.3704 15.6304L17.9435 15.9042L17.7832 16.1658Z",
    fill: "#D7FF1F"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2876 22.0831L10.8128 21.7151L10.5651 21.2025L10.0155 21.5217L10.2876 22.0831Z",
    fill: "#00C0FF"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6789 24.7186L13.4552 24.5382L12.9964 24.7802L13.1886 24.9765L13.6789 24.7186Z",
    fill: "#0020FF"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0645 17.0538L17.5582 16.8147L17.654 16.4718L16.1618 16.6972L16.0645 17.0538Z",
    fill: "#B1FF46"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7606 17.1707L23.1237 16.7739L23.0356 16.3921L21.6756 16.7887L21.7606 17.1707Z",
    fill: "#B1FF46"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22266 16.3253L8.35846 16.851L8.47883 15.8797L8.3472 15.3138L8.22266 16.3253Z",
    fill: "#CEFF29"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8396 23.1882L13.3991 22.6622L13.0701 22.6461L12.4789 23.1699L12.8396 23.1882Z",
    fill: "#007CFF"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8731 15.2208L21.1384 14.889L20.9099 15.0201L19.6574 15.3412L19.8731 15.2208Z",
    fill: "#FBF100"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7634 21.9262L15.7449 21.4442L15.4919 21.5801L14.489 22.0737L14.7634 21.9262Z",
    fill: "#00BCFF"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44296 21.9978L9.65422 21.7936L9.41032 21.1235L9.17807 21.2714L9.44296 21.9978Z",
    fill: "#00C4FF"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7178 22.5889L14.4893 22.074L14.198 22.1414L13.3993 22.6621L13.7178 22.5889Z",
    fill: "#009CFF"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1576 18.7802L14.532 18.5246L14.5099 18.0872L13.1315 18.3085L13.1576 18.7802Z",
    fill: "#6DFF8A"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3749 24.1682L12.5086 23.6979L12.1137 23.6772L11.9442 24.1449L12.3749 24.1682Z",
    fill: "#004CFF"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4944 20.2423L18.795 19.8702L18.6429 20.1597L17.3348 20.5493L17.4944 20.2423Z",
    fill: "#23FFD4"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5084 23.6979L12.8397 23.1877L12.479 23.1694L12.1135 23.6772L12.5084 23.6979Z",
    fill: "#0064FF"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5648 21.2024L11.3275 20.8542L11.1439 20.3431L10.3622 20.6415L10.5648 21.2024Z",
    fill: "#09F0EE"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7939 9.51379L13.8711 10.0697L14.4498 10.8803L14.3502 10.3305L13.7939 9.51379Z",
    fill: "#DF0000"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4303 18.0685L21.8181 17.7601L21.8093 18.1495L20.4232 18.4638L20.4303 18.0685Z",
    fill: "#7DFF7A"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04888 21.3337L9.17802 21.2708L8.97777 20.4993L8.83301 20.5033L9.04888 21.3337Z",
    fill: "#02E8F4"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33496 17.8644L8.43954 18.2631L8.46202 17.2985L8.35816 16.8511L8.33496 17.8644Z",
    fill: "#94FF63"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5383 8.35986L12.5641 8.93215L13.2372 9.41429L13.1849 8.85083L12.5383 8.35986Z",
    fill: "#920000"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M18.997 19.1671L20.3779 18.8441L20.2957 19.199L18.9136 19.5361L18.997 19.1671Z",
    fill: "#50FFA7"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0185 19.5319L13.2281 19.2495L13.1579 18.7806L11.9401 19.0208L12.0185 19.5319Z",
    fill: "#50FFA7"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1442 20.3431L12.1425 20.0267L12.0185 19.5317L11.0067 19.8007L11.1442 20.3431Z",
    fill: "#30FFC7"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6756 16.7882L23.0355 16.3916L22.9107 16.0323L21.556 16.427L21.6756 16.7882Z",
    fill: "#C4FF33"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74411 20.4116L8.83295 20.504L8.69237 19.6451L8.59375 19.4943L8.74411 20.4116Z",
    fill: "#2CFFCA"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6539 21.7929L10.0149 21.5214L9.79196 20.907L9.41 21.1229L9.6539 21.7929Z",
    fill: "#00D4FF"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50969 19.2434L8.59394 19.4937L8.52831 18.5683L8.43994 18.263L8.50969 19.2434Z",
    fill: "#5AFF9D"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1844 8.85059L13.2368 9.41405L13.8716 10.0697L13.7944 9.51376L13.1844 8.85059Z",
    fill: "#B20000"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0155 21.5219L10.5651 21.2026L10.3624 20.6417L9.79248 20.9075L10.0155 21.5219Z",
    fill: "#00E4F8"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1018 15.1623L21.3802 14.8198L21.1383 14.8887L19.873 15.2205L20.1018 15.1623Z",
    fill: "#FFEA00"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5296 17.659L16.0046 17.4397L16.0643 17.0545L14.5907 17.25L14.5296 17.659Z",
    fill: "#9DFF5A"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9435 15.9044L19.3703 15.6306L19.5562 15.4236L18.1305 15.6945L17.9435 15.9044Z",
    fill: "#E7FF0F"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M16.18 20.9664L17.3342 20.549L17.144 20.8014L15.9766 21.2383L16.18 20.9664Z",
    fill: "#09F0EE"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0619 20.387L15.9986 20.8473L15.7927 21.8061L15.8496 21.3761L16.0619 20.387Z",
    fill: "#06ECF1"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8451 24.4729L12.7915 24.0752L12.3747 24.1688L12.393 24.5736L12.8451 24.4729Z",
    fill: "#003CFF"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1884 23.1079L13.7174 22.5884L13.3989 22.6616L12.8394 23.1875L13.1884 23.1079Z",
    fill: "#0088FF"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M15.988 15.8094L16.0531 16.4567L16.1602 17.6155L16.0964 16.9834L15.988 15.8094Z",
    fill: "#C4FF33"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3776 12.8699L15.4474 13.528L15.7703 14.6468L15.7014 13.9929L15.3776 12.8699Z",
    fill: "#FF9F00"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1613 16.6975L17.6535 16.4722L17.7832 16.1658L16.294 16.3789L16.1613 16.6975Z",
    fill: "#C7FF30"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57666 12.1494L8.74086 12.8462L9.15736 12.0939L9.00091 11.379L8.57666 12.1494Z",
    fill: "#FF5900"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0147 21.7023L15.9767 21.2383L15.7455 21.4447L14.764 21.9267L15.0147 21.7023Z",
    fill: "#00D0FF"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5558 16.427L22.9105 16.0324L22.7523 15.7052L21.4046 16.0962L21.5558 16.427Z",
    fill: "#D7FF1F"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0174 22.4281L14.7636 21.9268L14.489 22.0744L13.7175 22.5892L14.0174 22.4281Z",
    fill: "#00ACFF"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3375 15.1678L21.6291 14.8149L21.3801 14.8195L20.1017 15.162L20.3375 15.1678Z",
    fill: "#FFE600"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8911 23.6117L13.1893 23.1084L12.8403 23.1881L12.509 23.6982L12.8911 23.6117Z",
    fill: "#0070FF"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 24.0753L12.8905 23.6121L12.5084 23.6986L12.3747 24.1689L12.7915 24.0753Z",
    fill: "#0054FF"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1315 18.3083L14.5099 18.0871L14.5295 17.6583L13.1503 17.8458L13.1315 18.3083Z",
    fill: "#87FF70"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3988 17.6687L21.7889 17.3662L21.8182 17.7605L20.4303 18.0689L20.3988 17.6687Z",
    fill: "#94FF63"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3615 20.642L11.1433 20.3435L11.0058 19.8011L10.2092 20.0466L10.3615 20.642Z",
    fill: "#26FFD1"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6191 19.8875L18.9143 19.5358L18.7949 19.8692L17.4943 20.2413L17.6191 19.8875Z",
    fill: "#39FFBE"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M13.455 24.5381L13.2708 24.2469L12.8451 24.4724L12.9962 24.7801L13.455 24.5381Z",
    fill: "#0038FF"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17812 21.2709L9.41037 21.123L9.22622 20.4114L8.97787 20.4994L9.17812 21.2709Z",
    fill: "#0CF4EB"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0424 18.7719L20.4236 18.464L20.3784 18.844L18.9974 19.1671L19.0424 18.7719Z",
    fill: "#66FF90"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7922 21.8063L15.6427 22.1277L15.3557 22.9552L15.4932 22.6674L15.7922 21.8063Z",
    fill: "#00B0FF"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4052 16.0961L22.7528 15.705L22.5653 15.4188L21.2264 15.8047L21.4052 16.0961Z",
    fill: "#E4FF13"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9398 19.0205L13.1576 18.7803L13.1315 18.3086L11.9092 18.5063L11.9398 19.0205Z",
    fill: "#6AFF8D"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5742 15.2384L21.8789 14.8758L21.6294 14.8157L20.3377 15.1686L20.5742 15.2384Z",
    fill: "#FFE600"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0065 19.8007L12.0184 19.5317L11.94 19.0206L10.9188 19.2404L11.0065 19.8007Z",
    fill: "#49FFAD"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1307 15.6942L19.5564 15.4234L19.7635 15.2731L18.3395 15.5418L18.1307 15.6942Z",
    fill: "#F4F802"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5054 8.63059L10.5849 9.29653L11.2572 9.20347L11.1788 8.53564L10.5054 8.63059Z",
    fill: "#8D0000"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1272 24.3229L13.8745 24.1671L13.4554 24.5383L13.6791 24.7187L14.1272 24.3229Z",
    fill: "#0040FF"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79202 20.9071L10.362 20.6414L10.2097 20.046L9.62402 20.2549L9.79202 20.9071Z",
    fill: "#1FFFD7"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41023 21.1233L9.79219 20.9074L9.62416 20.2552L9.22607 20.4118L9.41023 21.1233Z",
    fill: "#16FFE1"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2254 15.8048L22.5643 15.4189L22.3524 15.1812L21.0238 15.5605L21.2254 15.8048Z",
    fill: "#F1FC06"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5907 17.2501L16.0643 17.0547L16.1616 16.6981L14.6917 16.8714L14.5907 17.2501Z",
    fill: "#B4FF43"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8046 15.3697L22.1217 14.9982L21.8784 14.8751L20.5737 15.2377L20.8046 15.3697Z",
    fill: "#FFE600"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3563 22.9554L15.1339 23.1187L14.7835 23.7986L14.988 23.6691L15.3563 22.9554Z",
    fill: "#007CFF"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0241 15.5602L22.3527 15.1809L22.122 14.998L20.8049 15.3695L21.0241 15.5602Z",
    fill: "#FEED00"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3503 20.6359L17.4938 20.2422L17.3342 20.5492L16.18 20.9666L16.3503 20.6359Z",
    fill: "#1CFFDB"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7833 23.798L14.5211 23.7977L14.1268 24.3227L14.3651 24.3537L14.7833 23.798Z",
    fill: "#0054FF"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36932 10.0466L9.50631 10.7556L10.0808 10.2972L9.94966 9.58057L9.36932 10.0466Z",
    fill: "#D60000"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5171 22.9326L14.0175 22.428L13.7175 22.5891L13.1885 23.1086L13.5171 22.9326Z",
    fill: "#0098FF"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2939 16.3793L17.7831 16.1662L17.9434 15.9046L16.4587 16.1072L16.2939 16.3793Z",
    fill: "#D7FF1F"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41391 13.7208L8.57054 14.372L8.88842 13.5254L8.74059 12.8463L8.41391 13.7208Z",
    fill: "#FF9C00"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83281 20.5038L8.97757 20.4998L8.84737 19.7021L8.69223 19.6448L8.83281 20.5038Z",
    fill: "#30FFC7"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3296 17.2737L21.7224 16.9772L21.7891 17.3659L20.399 17.6683L20.3296 17.2737Z",
    fill: "#AAFF4D"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2707 24.2469L13.1837 23.866L12.7914 24.0747L12.845 24.4724L13.2707 24.2469Z",
    fill: "#0050FF"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2349 21.4065L16.1801 20.9664L15.9767 21.2383L15.0146 21.7023L15.2349 21.4065Z",
    fill: "#00E4F8"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2914 22.1826L15.0146 21.7021L14.7639 21.9265L14.0178 22.4279L14.2914 22.1826Z",
    fill: "#00C0FF"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3391 15.5419L19.7631 15.2732L19.9861 15.1836L18.5642 15.4511L18.3391 15.5419Z",
    fill: "#FEED00"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1502 17.8463L14.5294 17.6589L14.5904 17.2498L13.2137 17.4049L13.1502 17.8463Z",
    fill: "#A0FF56"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7053 19.4961L18.9974 19.1671L18.9141 19.5362L17.6188 19.8879L17.7053 19.4961Z",
    fill: "#50FFA7"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2503 23.4199L13.5174 22.9326L13.1889 23.1087L12.8906 23.612L13.2503 23.4199Z",
    fill: "#0080FF"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2094 20.0462L11.006 19.8006L10.9182 19.2404L10.1115 19.4311L10.2094 20.0462Z",
    fill: "#46FFB1"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1604 17.616L16.1748 18.208L16.1717 19.3221L16.1572 18.7549L16.1604 17.616Z",
    fill: "#83FF73"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0475 18.3613L20.4304 18.0693L20.4234 18.4646L19.0422 18.7725L19.0475 18.3613Z",
    fill: "#7DFF7A"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1837 23.8658L13.2501 23.4193L12.8904 23.6113L12.7914 24.0745L13.1837 23.8658Z",
    fill: "#0068FF"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59347 19.4936L8.69209 19.6445L8.63092 18.7783L8.52783 18.5682L8.59347 19.4936Z",
    fill: "#5DFF9A"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9569 11.8226L15.0277 12.4842L15.4473 13.5281L15.3776 12.8701L14.9569 11.8226Z",
    fill: "#FF6000"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34717 15.3139L8.4788 15.8798L8.69438 14.9759L8.57069 14.3722L8.34717 15.3139Z",
    fill: "#FFE200"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9092 18.5065L13.1315 18.3089L13.1503 17.8463L11.9274 18.0021L11.9092 18.5065Z",
    fill: "#87FF70"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9185 19.2404L11.9397 19.0207L11.9091 18.5063L10.883 18.6765L10.9185 19.2404Z",
    fill: "#6AFF8D"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2238 16.8952L21.6196 16.6045L21.7222 16.9774L20.3294 17.2739L20.2238 16.8952Z",
    fill: "#BEFF39"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97786 20.4992L9.2262 20.4112L9.10675 19.6758L8.84766 19.7015L8.97786 20.4992Z",
    fill: "#36FFC1"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6916 16.871L16.1615 16.6976L16.2943 16.379L14.8303 16.5326L14.6916 16.871Z",
    fill: "#CAFF2C"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4583 16.1072L17.943 15.9045L18.13 15.6946L16.651 15.8889L16.4583 16.1072Z",
    fill: "#E7FF0F"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43994 18.2633L8.52831 18.5686L8.54985 17.6584L8.46243 17.2986L8.43994 18.2633Z",
    fill: "#90FF66"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35858 16.8507L8.46244 17.2981L8.57758 16.3739L8.47896 15.8794L8.35858 16.8507Z",
    fill: "#CAFF2C"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62444 20.2555L10.2101 20.0467L10.1121 19.4316L9.51581 19.5815L9.62444 20.2555Z",
    fill: "#40FFB7"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5645 15.4513L19.9863 15.1838L20.2194 15.1575L18.8001 15.4249L18.5645 15.4513Z",
    fill: "#FFE600"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8739 24.1673L13.6594 23.9019L13.2707 24.2473L13.4548 24.5385L13.8739 24.1673Z",
    fill: "#0054FF"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4836 20.2543L17.6191 19.8882L17.4944 20.242L16.3509 20.6357L16.4836 20.2543Z",
    fill: "#33FFC4"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2259 20.4119L9.62399 20.2553L9.5154 19.5814L9.10645 19.6765L9.2259 20.4119Z",
    fill: "#3CFFBA"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8169 22.6636L14.2913 22.1823L14.0177 22.4275L13.5173 22.9321L13.8169 22.6636Z",
    fill: "#00ACFF"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1784 8.53564L11.2568 9.20347L11.9482 9.30563L11.871 8.6368L11.1784 8.53564Z",
    fill: "#800000"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7699 14.6473L15.8376 15.3094L16.0531 16.457L15.988 15.8097L15.7699 14.6473Z",
    fill: "#FFEA00"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0847 16.5431L21.4837 16.2578L21.6195 16.605L20.2237 16.8957L20.0847 16.5431Z",
    fill: "#D1FF26"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0129 17.9448L20.399 17.6689L20.4305 18.0692L19.0476 18.3612L19.0129 17.9448Z",
    fill: "#94FF63"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4193 21.0459L16.3507 20.6353L16.1804 20.966L15.2352 21.4061L15.4193 21.0459Z",
    fill: "#16FFE1"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5315 21.8584L15.2346 21.4059L15.0144 21.7017L14.2912 22.1822L14.5315 21.8584Z",
    fill: "#00D8FF"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7508 19.0771L19.0423 18.7725L18.9972 19.1677L17.7051 19.4967L17.7508 19.0771Z",
    fill: "#66FF90"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7997 15.4249L20.219 15.1575L20.4558 15.1954L19.0395 15.4635L18.7997 15.4249Z",
    fill: "#FFE200"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2137 17.4044L14.5904 17.2493L14.6915 16.8706L13.3204 16.9957L13.2137 17.4044Z",
    fill: "#B7FF40"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1716 19.3218L16.1049 19.8147L15.9985 20.8473L16.0618 20.387L16.1716 19.3218Z",
    fill: "#43FFB4"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00067 11.3794L9.15712 12.0942L9.65339 11.4856L9.50642 10.7557L9.00067 11.3794Z",
    fill: "#FF2500"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1115 19.431L10.9183 19.2403L10.8828 18.6764L10.0708 18.8118L10.1115 19.431Z",
    fill: "#66FF90"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5784 23.1265L13.8172 22.6641L13.5175 22.9326L13.2503 23.4198L13.5784 23.1265Z",
    fill: "#0098FF"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5208 23.7976L14.2422 23.6748L13.8737 24.1669L14.1265 24.3226L14.5208 23.7976Z",
    fill: "#0068FF"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9154 16.2257L21.3179 15.9453L21.4834 16.2574L20.0843 16.5427L19.9154 16.2257Z",
    fill: "#E1FF16"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6512 15.8883L18.1302 15.6941L18.339 15.5416L16.8667 15.7298L16.6512 15.8883Z",
    fill: "#F8F500"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6593 23.9017L13.5416 23.547L13.1836 23.8663L13.2706 24.2472L13.6593 23.9017Z",
    fill: "#006CFF"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4499 10.8802L14.5218 11.5448L15.0272 12.4843L14.9564 11.8227L14.4499 10.8802Z",
    fill: "#FF2900"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69236 19.6443L8.8475 19.7015L8.79113 18.8975L8.6312 18.7781L8.69236 19.6443Z",
    fill: "#60FF97"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0397 15.4639L20.4561 15.1958L20.6906 15.297L19.2774 15.5668L19.0397 15.4639Z",
    fill: "#FFE600"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8299 16.5329L16.2939 16.3793L16.4587 16.1072L15.0028 16.2438L14.8299 16.5329Z",
    fill: "#DEFF19"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9271 18.0016L13.15 17.8458L13.2134 17.4044L11.9939 17.5202L11.9271 18.0016Z",
    fill: "#A4FF53"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 23.5469L13.578 23.1263L13.2499 23.4197L13.1836 23.8662L13.5416 23.5469Z",
    fill: "#0080FF"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M10.883 18.6763L11.9091 18.5062L11.9273 18.0018L10.9009 18.1231L10.883 18.6763Z",
    fill: "#87FF70"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7217 15.9528L21.1278 15.6768L21.3186 15.9455L19.9161 16.2259L19.7217 15.9528Z",
    fill: "#EEFF09"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2773 15.5666L20.6905 15.2967L20.9163 15.4585L19.5066 15.7311L19.2773 15.5666Z",
    fill: "#FFEA00"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94955 9.58079L10.0807 10.2974L10.7089 10.0184L10.5843 9.29651L9.94955 9.58079Z",
    fill: "#AD0000"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5068 15.7312L20.9165 15.4586L21.1276 15.6768L19.7215 15.9529L19.5068 15.7312Z",
    fill: "#FBF100"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 20.8468L15.8412 21.2059L15.6437 22.1271L15.7932 21.8056L15.9991 20.8468Z",
    fill: "#0CF4EB"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9388 17.5333L20.3294 17.2734L20.3988 17.6681L19.0128 17.944L18.9388 17.5333Z",
    fill: "#AAFF4D"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5749 19.8313L17.7056 19.4959L17.6191 19.8876L16.4836 20.2537L16.5749 19.8313Z",
    fill: "#4DFFAA"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 23.1182L14.8515 23.1555L14.5215 23.7977L14.7837 23.7981L15.1341 23.1182Z",
    fill: "#0088FF"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8709 8.63654L11.9481 9.30537L12.6394 9.60099L12.5635 8.93193L11.8709 8.63654Z",
    fill: "#800000"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51546 19.5807L10.1118 19.4308L10.0711 18.8115L9.46942 18.9018L9.51546 19.5807Z",
    fill: "#66FF90"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M15.643 22.127L15.4063 22.3296L15.1335 23.1177L15.3559 22.9544L15.643 22.127Z",
    fill: "#00B8FF"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0798 22.3087L14.5314 21.8584L14.2911 22.1821L13.8167 22.6634L14.0798 22.3087Z",
    fill: "#00C8FF"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7543 18.6398L19.0474 18.3607L19.0421 18.7718L17.7507 19.0764L17.7543 18.6398Z",
    fill: "#7DFF7A"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84708 19.7018L9.10618 19.6761L9.05488 18.9351L8.79071 18.8978L8.84708 19.7018Z",
    fill: "#60FF97"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8669 15.7302L18.3392 15.542L18.5643 15.4513L17.0998 15.6359L16.8669 15.7302Z",
    fill: "#FFEA00"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8713 10.0696L13.9445 10.7365L14.5219 11.5449L14.4499 10.8802L13.8713 10.0696Z",
    fill: "#DF0000"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10647 19.6766L9.51543 19.5815L9.46938 18.9026L9.05518 18.9356L9.10647 19.6766Z",
    fill: "#63FF94"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52783 18.5685L8.63092 18.7787L8.65141 17.9273L8.54937 17.6583L8.52783 18.5685Z",
    fill: "#90FF66"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5621 20.631L16.4832 20.2544L16.3506 20.6358L15.4191 21.0465L15.5621 20.631Z",
    fill: "#2CFFCA"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3203 16.9963L14.6914 16.8712L14.8301 16.5328L13.4677 16.631L13.3203 16.9963Z",
    fill: "#D1FF26"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74106 12.8466L8.88889 13.5257L9.2939 12.7979L9.15755 12.0944L8.74106 12.8466Z",
    fill: "#FF6000"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7319 21.4646L15.4185 21.0462L15.2344 21.4063L14.5312 21.8589L14.7319 21.4646Z",
    fill: "#0CF4EB"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5635 8.93195L12.6393 9.601L13.3111 10.0825L13.2366 9.41409L12.5635 8.93195Z",
    fill: "#920000"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0033 16.2432L16.4591 16.1066L16.6518 15.8883L15.2059 16.0113L15.0033 16.2432Z",
    fill: "#EEFF09"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8273 17.1395L20.2237 16.895L20.3293 17.2737L18.9387 17.5336L18.8273 17.1395Z",
    fill: "#C1FF36"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2426 23.6746L14.0012 23.4437L13.6597 23.9013L13.8742 24.1667L14.2426 23.6746Z",
    fill: "#007CFF"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2365 9.41455L13.311 10.0829L13.9445 10.7371L13.8713 10.0702L13.2365 9.41455Z",
    fill: "#B20000"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0531 16.4564L16.0697 17.0736L16.1746 18.2072L16.1601 17.6152L16.0531 16.4564Z",
    fill: "#C1FF36"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0708 18.8124L10.8828 18.677L10.9007 18.1238L10.0887 18.2047L10.0708 18.8124Z",
    fill: "#8AFF6D"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 15.6355L18.5642 15.4509L18.7998 15.4244L17.3437 15.6081L17.0996 15.6355Z",
    fill: "#FFE200"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9938 17.5204L13.2133 17.4047L13.3199 16.9959L12.1079 17.0744L11.9938 17.5204Z",
    fill: "#BEFF39"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8663 22.7383L14.0801 22.3092L13.8171 22.6639L13.5783 23.1263L13.8663 22.7383Z",
    fill: "#00B4FF"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4468 13.5283L15.5183 14.2045L15.8374 15.3092L15.7697 14.6471L15.4468 13.5283Z",
    fill: "#FFA300"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46191 17.2984L8.54933 17.6581L8.65837 16.7865L8.57704 16.3741L8.46191 17.2984Z",
    fill: "#C7FF30"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9009 18.1229L11.9273 18.0015L11.9942 17.52L10.9721 17.5946L10.9009 18.1229Z",
    fill: "#A7FF50"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57016 14.3724L8.69385 14.9762L9.00013 14.1642L8.88805 13.5259L8.57016 14.3724Z",
    fill: "#FFA300"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6222 19.3791L17.7511 19.0768L17.7054 19.4964L16.5747 19.8318L16.6222 19.3791Z",
    fill: "#63FF94"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7157 18.198L19.0128 17.9448L19.0475 18.3612L17.7544 18.6403L17.7157 18.198Z",
    fill: "#97FF60"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M8.479 15.8799L8.57763 16.3744L8.78346 15.5148L8.69459 14.9761L8.479 15.8799Z",
    fill: "#FFEA00"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6816 16.7727L20.0849 16.5426L20.224 16.8952L18.8276 17.1396L18.6816 16.7727Z",
    fill: "#D4FF23"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 23.4435L13.8561 23.1238L13.5417 23.5464L13.6593 23.9011L14.0008 23.4435Z",
    fill: "#0090FF"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M13.856 23.1241L13.866 22.7381L13.578 23.1261L13.5417 23.5467L13.856 23.1241Z",
    fill: "#00A0FF"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 15.6081L18.7998 15.4244L19.0397 15.4631L17.5925 15.6486L17.3438 15.6081Z",
    fill: "#FFDE00"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6312 18.7783L8.79113 18.8977L8.81061 18.1076L8.65168 17.9269L8.6312 18.7783Z",
    fill: "#8DFF6A"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4676 16.6304L14.83 16.5322L15.0029 16.2432L13.652 16.3183L13.4676 16.6304Z",
    fill: "#E4FF13"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2059 16.0119L16.6518 15.889L16.8673 15.7305L15.4332 15.8436L15.2059 16.0119Z",
    fill: "#FEED00"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46942 18.9024L10.0711 18.8121L10.0889 18.2044L9.48754 18.236L9.46942 18.9024Z",
    fill: "#8AFF6D"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M14.299 21.8767L14.7318 21.4645L14.5312 21.8588L14.0796 22.3091L14.299 21.8767Z",
    fill: "#02E8F4"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8511 23.1555L14.5504 23.0734L14.2424 23.6749L14.521 23.7977L14.8511 23.1555Z",
    fill: "#0098FF"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6603 20.1706L16.5748 19.832L16.4835 20.2545L15.5623 20.631L15.6603 20.1706Z",
    fill: "#46FFB1"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5051 16.4423L19.9161 16.2252L20.0851 16.5423L18.6818 16.7723L18.5051 16.4423Z",
    fill: "#E4FF13"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5843 9.29602L10.7089 10.0179L11.3741 9.9276L11.2566 9.20294L10.5843 9.29602Z",
    fill: "#920000"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50684 10.7559L9.65381 11.4859L10.2173 11.0391L10.0813 10.2975L9.50684 10.7559Z",
    fill: "#DF0000"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5928 15.6489L19.0399 15.4635L19.2776 15.5664L17.8397 15.7562L17.5928 15.6489Z",
    fill: "#FFDE00"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8877 21.009L15.5619 20.6304L15.4189 21.0459L14.7323 21.4642L14.8877 21.009Z",
    fill: "#26FFD1"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M16.175 18.2076L16.108 18.7348L16.1052 19.8146L16.1719 19.3217L16.175 18.2076Z",
    fill: "#83FF73"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3016 16.1584L19.7212 15.9526L19.9156 16.2257L18.5046 16.4427L18.3016 16.1584Z",
    fill: "#F1FC06"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8394 15.7567L19.2772 15.5669L19.5065 15.7314L18.0779 15.928L17.8394 15.7567Z",
    fill: "#FFE600"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7915 18.8976L9.05567 18.9349L9.07434 18.2071L8.81099 18.1075L8.7915 18.8976Z",
    fill: "#8DFF6A"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05518 18.9346L9.46939 18.9017L9.48749 18.2353L9.07384 18.2068L9.05518 18.9346Z",
    fill: "#8DFF6A"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6351 17.7613L18.9385 17.5338L19.0125 17.9445L17.7154 18.1976L17.6351 17.7613Z",
    fill: "#ADFF49"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0778 15.9271L19.5064 15.7305L19.7211 15.9522L18.3015 16.158L18.0778 15.9271Z",
    fill: "#FEED00"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1086 17.0743L13.3207 16.9958L13.468 16.6305L12.2671 16.6756L12.1086 17.0743Z",
    fill: "#D7FF1F"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M16.624 18.9075L17.7545 18.6398L17.7509 19.0764L16.6219 19.3788L16.624 18.9075Z",
    fill: "#7DFF7A"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0887 18.204L10.9007 18.1231L10.9719 17.5948L10.1651 17.6235L10.0887 18.204Z",
    fill: "#AAFF4D"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4064 22.3304L15.1077 22.4118L14.8511 23.1559L15.1336 23.1185L15.4064 22.3304Z",
    fill: "#00C4FF"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M15.433 15.8434L16.867 15.7303L17.0999 15.636L15.6789 15.7433L15.433 15.8434Z",
    fill: "#FFE200"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9717 17.5954L11.9937 17.5208L12.1078 17.0748L11.0947 17.1059L10.9717 17.5954Z",
    fill: "#C4FF33"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1066 22.2653L14.2997 21.8771L14.0802 22.3095L13.8664 22.7386L14.1066 22.2653Z",
    fill: "#00D8FF"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1048 19.8141L15.9424 20.2139L15.8407 21.2058L15.9985 20.8467L16.1048 19.8141Z",
    fill: "#46FFB1"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54901 17.6584L8.65104 17.9273L8.75343 17.1124L8.65805 16.7867L8.54901 17.6584Z",
    fill: "#C1FF36"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0277 12.4842L15.1039 13.1734L15.5188 14.2043L15.4473 13.5281L15.0277 12.4842Z",
    fill: "#FF6400"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6523 16.3182L15.0032 16.2431L15.2059 16.0112L13.8692 16.0678L13.6523 16.3182Z",
    fill: "#F8F500"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5502 23.0738L14.2859 22.8854L14.0007 23.4444L14.2421 23.6754L14.5502 23.0738Z",
    fill: "#00A8FF"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8411 21.2065L15.5943 21.4532L15.4069 22.3304L15.6436 22.1277L15.8411 21.2065Z",
    fill: "#0FF8E7"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5155 17.3426L18.8274 17.14L18.9388 17.534L17.6353 17.7615L17.5155 17.3426Z",
    fill: "#C4FF33"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7101 19.6764L16.622 19.3787L16.5746 19.8314L15.66 20.17L15.7101 19.6764Z",
    fill: "#63FF94"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8374 15.3089L15.8584 15.9511L16.0696 17.0737L16.0529 16.4565L15.8374 15.3089Z",
    fill: "#FFEA00"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15692 12.0942L9.29326 12.7978L9.77558 12.2095L9.65317 11.4857L9.15692 12.0942Z",
    fill: "#FF3000"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M14.119 22.6087L14.1068 22.2653L13.8666 22.7385L13.8566 23.1246L14.119 22.6087Z",
    fill: "#00C8FF"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6787 15.743L17.0997 15.6358L17.3438 15.6084L15.9369 15.714L15.6787 15.743Z",
    fill: "#FFDB00"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2866 22.8845L14.119 22.6079L13.8566 23.1238L14.0014 23.4435L14.2866 22.8845Z",
    fill: "#00B8FF"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4692 21.3776L14.8876 21.0096L14.7321 21.4648L14.2993 21.877L14.4692 21.3776Z",
    fill: "#1CFFDB"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4873 18.2358L10.0887 18.2042L10.1651 17.6237L9.56956 17.5989L9.4873 18.2358Z",
    fill: "#ADFF49"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2565 9.20294L11.3741 9.9276L12.058 10.03L11.9479 9.3051L11.2565 9.20294Z",
    fill: "#840000"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5804 18.4304L17.7158 18.1979L17.7545 18.6402L16.624 18.9079L16.5804 18.4304Z",
    fill: "#97FF60"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9938 20.5041L15.6598 20.1697L15.5618 20.6302L14.8877 21.0088L14.9938 20.5041Z",
    fill: "#43FFB4"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57748 16.3743L8.65881 16.7867L8.85345 15.9765L8.78332 15.5148L8.57748 16.3743Z",
    fill: "#FBF100"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3592 16.9525L18.6815 16.7729L18.8275 17.1399L17.5156 17.3426L17.3592 16.9525Z",
    fill: "#D7FF1F"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2664 16.6761L13.4673 16.631L13.6518 16.3188L12.4656 16.3354L12.2664 16.6761Z",
    fill: "#EEFF09"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65155 17.9272L8.81048 18.108L8.90599 17.3522L8.75394 17.1123L8.65155 17.9272Z",
    fill: "#BEFF39"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8688 16.0677L15.2055 16.0111L15.4328 15.8428L14.1125 15.8858L13.8688 16.0677Z",
    fill: "#FFE600"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 15.714L17.3443 15.6084L17.5932 15.6488L16.2011 15.7571L15.9375 15.714Z",
    fill: "#FFD700"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88837 13.5254L9.00045 14.1636L9.39042 13.466L9.29337 12.7975L8.88837 13.5254Z",
    fill: "#FF6C00"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1652 17.6236L10.972 17.5949L11.095 17.1055L10.2985 17.0854L10.1652 17.6236Z",
    fill: "#CAFF2C"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07391 18.2077L9.48756 18.2361L9.56983 17.5992L9.16262 17.5118L9.07391 18.2077Z",
    fill: "#B4FF43"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69385 14.9759L8.78272 15.5146L9.07491 14.7429L9.00013 14.1639L8.69385 14.9759Z",
    fill: "#FFAE00"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0954 17.1057L12.1085 17.0746L12.267 16.6759L11.2673 16.668L11.0954 17.1057Z",
    fill: "#DEFF19"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5223 11.545L14.6042 12.2457L15.1039 13.1737L15.0277 12.4845L14.5223 11.545Z",
    fill: "#FF2D00"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1704 16.6012L18.5047 16.4425L18.6815 16.7726L17.3593 16.9521L17.1704 16.6012Z",
    fill: "#EBFF0C"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1081 22.4115L14.79 22.3768L14.5508 23.0734L14.8514 23.1556L15.1081 22.4115Z",
    fill: "#00CCFF"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0814 10.2974L10.2174 11.039L10.8335 10.7677L10.7097 10.0184L10.0814 10.2974Z",
    fill: "#BB0000"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81024 18.1081L9.07359 18.2077L9.1623 17.5118L8.90575 17.3524L8.81024 18.1081Z",
    fill: "#B7FF40"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2004 15.7573L17.5924 15.649L17.8393 15.7563L16.4624 15.8714L16.2004 15.7573Z",
    fill: "#FFD700"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7102 19.1623L16.6237 18.9075L16.6216 19.3788L15.7097 19.6764L15.7102 19.1623Z",
    fill: "#7DFF7A"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4917 17.9586L17.6351 17.7609L17.7154 18.1972L16.58 18.4298L16.4917 17.9586Z",
    fill: "#B1FF46"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2924 21.718L14.4694 21.3774L14.2995 21.8769L14.1064 22.2651L14.2924 21.718Z",
    fill: "#16FFE1"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9539 16.2992L18.3016 16.1585L18.5046 16.4428L17.1702 16.6015L16.9539 16.2992Z",
    fill: "#F8F500"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4624 15.8716L17.8394 15.7565L18.0779 15.9278L16.7158 16.0539L16.4624 15.8716Z",
    fill: "#FFDB00"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9482 9.30548L12.0584 10.0304L12.7421 10.3236L12.6395 9.60112L11.9482 9.30548Z",
    fill: "#890000"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7163 16.0534L18.0783 15.9274L18.302 16.1583L16.9544 16.299L16.7163 16.0534Z",
    fill: "#FFE600"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0701 17.074L16.0059 17.6361L16.1079 18.7348L16.175 18.2076L16.0701 17.074Z",
    fill: "#C1FF36"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1122 15.8859L15.4325 15.8428L15.6785 15.7427L14.3764 15.7777L14.1122 15.8859Z",
    fill: "#FFD700"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4658 16.3351L13.652 16.3186L13.8688 16.0682L12.7006 16.0616L12.4658 16.3351Z",
    fill: "#FFEA00"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 19.9632L15.7095 19.6766L15.6595 20.1702L14.9935 20.5046L15.0471 19.9632Z",
    fill: "#60FF97"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5851 20.8228L14.9938 20.5042L14.8878 21.0089L14.4694 21.3769L14.5851 20.8228Z",
    fill: "#3CFFBA"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9445 10.7361L14.0329 11.4463L14.6038 12.2451L14.5219 11.5445L13.9445 10.7361Z",
    fill: "#E40000"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7898 22.3765L14.5075 22.2376L14.2863 22.8847L14.5506 23.0731L14.7898 22.3765Z",
    fill: "#00D8FF"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5943 21.4531L15.2841 21.5838L15.1082 22.4116L15.407 22.3302L15.5943 21.4531Z",
    fill: "#16FFE1"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3219 22.0113L14.2924 21.7176L14.1064 22.2647L14.1186 22.6081L14.3219 22.0113Z",
    fill: "#0CF4EB"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56952 17.5988L10.165 17.6236L10.2984 17.0854L9.71431 17.0081L9.56952 17.5988Z",
    fill: "#D1FF26"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6392 9.60089L12.7418 10.3234L13.4063 10.7999L13.3109 10.0824L12.6392 9.60089Z",
    fill: "#9B0000"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65887 16.7863L8.75426 17.112L8.9367 16.355L8.85351 15.9762L8.65887 16.7863Z",
    fill: "#F4F802"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3615 17.5067L17.5159 17.3426L17.6358 17.7614L16.4923 17.9591L16.3615 17.5067Z",
    fill: "#C7FF30"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5184 14.2046L15.5459 14.8707L15.8586 15.9515L15.8376 15.3093L15.5184 14.2046Z",
    fill: "#FFA700"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3114 10.0826L13.4067 10.8001L14.0332 11.4469L13.9448 10.7367L13.3114 10.0826Z",
    fill: "#BB0000"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5074 22.2376L14.3219 22.0114L14.1187 22.6081L14.2863 22.8847L14.5074 22.2376Z",
    fill: "#02E8F4"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1077 18.735L15.9445 19.1775L15.9424 20.2146L16.1049 19.8148L16.1077 18.735Z",
    fill: "#80FF77"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2671 16.6678L12.2668 16.6757L12.4659 16.335L11.4838 16.2936L11.2671 16.6678Z",
    fill: "#F8F500"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6616 18.641L16.5806 18.4298L16.6241 18.9073L15.7107 19.1622L15.6616 18.641Z",
    fill: "#9AFF5D"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9426 20.2145L15.6901 20.5089L15.5941 21.453L15.8409 21.2064L15.9426 20.2145Z",
    fill: "#49FFAD"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3766 15.7783L15.6788 15.7432L15.937 15.7142L14.6544 15.7469L14.3766 15.7783Z",
    fill: "#FFD000"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2987 17.086L11.0952 17.106L11.2671 16.6682L10.4859 16.6045L10.2987 17.086Z",
    fill: "#E7FF0F"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65332 11.4857L9.77573 12.2095L10.3232 11.7781L10.2168 11.0389L9.65332 11.4857Z",
    fill: "#F10800"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1626 17.5114L9.56981 17.5988L9.71459 17.0081L9.31966 16.8657L9.1626 17.5114Z",
    fill: "#DBFF1C"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1906 17.0855L17.3587 16.9528L17.5151 17.3429L16.3607 17.507L16.1906 17.0855Z",
    fill: "#DEFF19"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M12.701 16.0617L13.8692 16.0683L14.1129 15.8864L12.9654 15.8631L12.701 16.0617Z",
    fill: "#FFD700"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75409 17.1125L8.90614 17.3524L9.0759 16.6507L8.93654 16.3555L8.75409 17.1125Z",
    fill: "#EBFF0C"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7088 10.0183L10.8326 10.7676L11.4848 10.681L11.3741 9.92804L10.7088 10.0183Z",
    fill: "#9F0000"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4185 21.1107L14.5847 20.8232L14.469 21.3774L14.292 21.718L14.4185 21.1107Z",
    fill: "#36FFC1"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78339 15.5142L8.85352 15.976L9.12959 15.2491L9.07557 14.7425L8.78339 15.5142Z",
    fill: "#FFB900"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6541 15.7469L15.9367 15.7142L16.2004 15.7572L14.9381 15.7935L14.6541 15.7469Z",
    fill: "#FFCC00"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0464 19.3997L15.7101 19.1631L15.7095 19.6772L15.0471 19.9638L15.0464 19.3997Z",
    fill: "#80FF77"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 17.3517L9.1628 17.5111L9.31985 16.8655L9.07601 16.65L8.90625 17.3517Z",
    fill: "#E1FF16"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9863 16.7057L17.1705 16.6012L17.3593 16.9521L16.1912 17.0849L15.9863 16.7057Z",
    fill: "#F1FC06"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6429 20.2283L15.0473 19.963L14.9937 20.5044L14.585 20.823L14.6429 20.2283Z",
    fill: "#5DFF9A"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29282 12.7983L9.38987 13.4668L9.85406 12.9033L9.77514 12.21L9.29282 12.7983Z",
    fill: "#FF3B00"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2839 21.5833L14.9535 21.6018L14.79 22.3765L15.1081 22.4112L15.2839 21.5833Z",
    fill: "#1CFFDB"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5632 18.1266L16.4916 17.9586L16.5799 18.4298L15.661 18.641L15.5632 18.1266Z",
    fill: "#B7FF40"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9382 15.7927L16.2004 15.7565L16.4625 15.8706L15.2208 15.9161L14.9382 15.7927Z",
    fill: "#FFCC00"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00067 14.1633L9.07545 14.7423L9.44726 14.0797L9.39065 13.4656L9.00067 14.1633Z",
    fill: "#FF7A00"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M15.752 16.3794L16.9541 16.2993L17.1704 16.6016L15.9862 16.7061L15.752 16.3794Z",
    fill: "#FFEA00"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4836 16.2938L12.4658 16.3352L12.7005 16.0617L11.7396 15.9933L11.4836 16.2938Z",
    fill: "#FFDB00"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2214 15.9167L16.4631 15.8712L16.7165 16.0535L15.495 16.1137L15.2214 15.9167Z",
    fill: "#FFD000"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71436 17.0087L10.2984 17.0861L10.4856 16.6046L9.91839 16.48L9.71436 17.0087Z",
    fill: "#F4F802"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4948 16.1138L16.7163 16.0535L16.9543 16.2991L15.7522 16.3792L15.4948 16.1138Z",
    fill: "#FFDB00"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9647 15.8633L14.1122 15.8866L14.3764 15.7785L13.2517 15.7451L12.9647 15.8633Z",
    fill: "#FFC800"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1042 13.1735L15.1401 13.8618L15.5466 14.8706L15.5191 14.2045L15.1042 13.1735Z",
    fill: "#FF6C00"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8591 15.9518L15.8008 16.5483L16.006 17.6364L16.0702 17.0744L15.8591 15.9518Z",
    fill: "#FBF100"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4597 21.3487L14.4185 21.1105L14.292 21.7178L14.3214 22.0115L14.4597 21.3487Z",
    fill: "#30FFC7"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4858 16.6045L11.267 16.6682L11.4837 16.294L10.7224 16.1927L10.4858 16.6045Z",
    fill: "#FFE600"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9534 21.6024L14.6584 21.519L14.5077 22.2382L14.79 22.3771L14.9534 21.6024Z",
    fill: "#23FFD4"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6585 21.5188L14.4604 21.3489L14.3221 22.0118L14.5077 22.238L14.6585 21.5188Z",
    fill: "#29FFCE"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4191 17.6326L16.3609 17.5062L16.4917 17.9586L15.5633 18.1266L15.4191 17.6326Z",
    fill: "#D1FF26"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9919 18.8271L15.6617 18.6414L15.7108 19.1625L15.0471 19.3992L14.9919 18.8271Z",
    fill: "#9DFF5A"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85336 15.9764L8.93656 16.3552L9.19511 15.6764L9.12944 15.2495L8.85336 15.9764Z",
    fill: "#FFC400"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6894 20.5091L15.3727 20.6931L15.2832 21.584L15.5934 21.4533L15.6894 20.5091Z",
    fill: "#4DFFAA"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3745 9.92804L11.4853 10.681L12.1557 10.7827L12.0585 10.0304L11.3745 9.92804Z",
    fill: "#920000"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M13.252 15.7452L14.3767 15.7786L14.6544 15.7472L13.5542 15.7109L13.252 15.7452Z",
    fill: "#FFC100"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31967 16.8654L9.71461 17.0078L9.91864 16.479L9.54155 16.2871L9.31967 16.8654Z",
    fill: "#FEED00"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4822 20.4583L14.6431 20.2283L14.5852 20.823L14.4189 21.1105L14.4822 20.4583Z",
    fill: "#5AFF9D"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2165 11.0391L10.3229 11.7784L10.9212 11.5172L10.8326 10.7679L10.2165 11.0391Z",
    fill: "#C80000"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0054 17.6356L15.8456 18.1217L15.9442 19.1768L16.1074 18.7343L16.0054 17.6356Z",
    fill: "#BEFF39"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6411 19.6084L15.0464 19.399L15.0471 19.9631L14.6427 20.2284L14.6411 19.6084Z",
    fill: "#80FF77"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7391 15.9936L12.7001 16.062L12.9644 15.8634L12.0279 15.7752L11.7391 15.9936Z",
    fill: "#FFC800"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9448 19.1769L15.6912 19.5214L15.6901 20.5084L15.9427 20.214L15.9448 19.1769Z",
    fill: "#80FF77"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2328 17.1721L16.1912 17.0846L16.3613 17.5061L15.4195 17.6325L15.2328 17.1721Z",
    fill: "#E7FF0F"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93637 16.3555L9.07573 16.6508L9.316 16.022L9.19492 15.6768L8.93637 16.3555Z",
    fill: "#FFD300"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6037 12.2449L14.6497 12.953L15.1393 13.8613L15.1034 13.173L14.6037 12.2449Z",
    fill: "#FF3400"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07553 16.6506L9.31937 16.866L9.54126 16.2877L9.31579 16.0218L9.07553 16.6506Z",
    fill: "#FFDE00"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5539 15.7109L14.6542 15.7472L14.9381 15.7938L13.8633 15.7618L13.5539 15.7109Z",
    fill: "#FFB900"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91864 16.4791L10.4859 16.6037L10.7225 16.1919L10.177 16.0267L9.91864 16.4791Z",
    fill: "#FFD700"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7219 16.1923L11.4832 16.2936L11.7392 15.9931L11.0019 15.8615L10.7219 16.1923Z",
    fill: "#FFCC00"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07471 14.7427L9.12873 15.2493L9.47983 14.6256L9.44651 14.0801L9.07471 14.7427Z",
    fill: "#FF8600"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8828 18.2623L15.5634 18.1271L15.6612 18.6415L14.9914 18.8272L14.8828 18.2623Z",
    fill: "#BAFF3C"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0581 10.0306L12.1553 10.7829L12.8254 11.0711L12.7419 10.3238L12.0581 10.0306Z",
    fill: "#960000"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0081 16.7579L15.9863 16.7054L16.1911 17.0846L15.2327 17.1721L15.0081 16.7579Z",
    fill: "#FBF100"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5294 20.6368L14.4822 20.4586L14.4189 21.1108L14.4602 21.349L14.5294 20.6368Z",
    fill: "#56FFA0"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3736 20.693L15.0363 20.769L14.9536 21.6023L15.2841 21.5838L15.3736 20.693Z",
    fill: "#4DFFAA"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77539 12.2092L9.85431 12.9026L10.381 12.49L10.3229 11.7778L9.77539 12.2092Z",
    fill: "#FF1300"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M13.864 15.7614L14.9388 15.7933L15.2214 15.9167L14.1721 15.8961L13.864 15.7614Z",
    fill: "#FFBD00"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5465 14.8702L15.4973 15.5001L15.801 16.5476L15.8593 15.951L15.5465 14.8702Z",
    fill: "#FFAE00"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0332 11.4466L14.0907 12.1714L14.6502 12.9535L14.6042 12.2454L14.0332 11.4466Z",
    fill: "#F10800"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M12.028 15.775L12.9645 15.8632L13.2516 15.745L12.342 15.645L12.028 15.775Z",
    fill: "#FFB900"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7518 16.4013L15.752 16.379L15.9863 16.7057L15.0082 16.7583L14.7518 16.4013Z",
    fill: "#FFDB00"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39047 13.4659L9.44708 14.08L9.88946 13.5453L9.85468 12.9025L9.39047 13.4659Z",
    fill: "#FF4A00"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1716 15.8965L15.2209 15.9171L15.4945 16.1141L14.4703 16.1118L14.1716 15.8965Z",
    fill: "#FFC100"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4702 16.1113L15.4944 16.1137L15.7518 16.3791L14.7516 16.4013L14.4702 16.1113Z",
    fill: "#FFCC00"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7417 10.3235L12.8252 11.0708L13.4763 11.5381L13.4062 10.8001L12.7417 10.3235Z",
    fill: "#A40000"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5801 18.9794L14.9918 18.827L15.047 19.399L14.6416 19.6084L14.5801 18.9794Z",
    fill: "#A0FF56"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4066 10.8004L13.4768 11.5384L14.0906 12.172L14.0331 11.4471L13.4066 10.8004Z",
    fill: "#C40000"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7343 20.745L14.5297 20.636L14.4604 21.3482L14.6585 21.5182L14.7343 20.745Z",
    fill: "#53FFA4"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M14.48 19.7779L14.6415 19.6082L14.6431 20.2282L14.4821 20.4581L14.48 19.7779Z",
    fill: "#80FF77"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0359 20.7684L14.734 20.7451L14.6582 21.5182L14.9532 21.6016L15.0359 20.7684Z",
    fill: "#50FFA7"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 17.7189L15.4199 17.6323L15.564 18.1263L14.8834 18.2616L14.7241 17.7189Z",
    fill: "#D7FF1F"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54184 16.2875L9.91892 16.4794L10.1773 16.0269L9.82329 15.7923L9.54184 16.2875Z",
    fill: "#FFC800"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8325 10.7674L10.9212 11.5167L11.5544 11.4344L11.4847 10.6808L10.8325 10.7674Z",
    fill: "#AD0000"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12924 15.249L9.1949 15.6759L9.5235 15.0939L9.48034 14.6253L9.12924 15.249Z",
    fill: "#FF9800"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0026 15.8619L11.7399 15.9936L12.0286 15.7752L11.319 15.6214L11.0026 15.8619Z",
    fill: "#FFB600"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6913 19.522L15.3735 19.7621L15.3735 20.693L15.6902 20.509L15.6913 19.522Z",
    fill: "#80FF77"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M12.343 15.6445L13.2525 15.7445L13.5547 15.7102L12.6739 15.6068L12.343 15.6445Z",
    fill: "#FFAE00"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1774 16.0274L10.7229 16.1926L11.0029 15.8618L10.4837 15.6637L10.1774 16.0274Z",
    fill: "#FFB900"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8002 16.5483L15.6478 17.0778L15.8456 18.1225L16.0054 17.6364L15.8002 16.5483Z",
    fill: "#F8F500"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31641 16.0218L9.54188 16.2877L9.82332 15.7925L9.62151 15.483L9.31641 16.0218Z",
    fill: "#FFB600"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19516 15.6761L9.31623 16.0213L9.62134 15.4825L9.52375 15.0941L9.19516 15.6761Z",
    fill: "#FFA700"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8462 18.1222L15.5965 18.5179L15.6913 19.5218L15.9449 19.1773L15.8462 18.1222Z",
    fill: "#BAFF3C"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5174 17.2136L15.2324 17.1725L15.4192 17.6328L14.7234 17.7194L14.5174 17.2136Z",
    fill: "#F1FC06"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4597 18.3582L14.883 18.2622L14.9916 18.8271L14.5799 18.9796L14.4597 18.3582Z",
    fill: "#C1FF36"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5272 19.8935L14.48 19.7783L14.4821 20.4585L14.5294 20.6367L14.5272 19.8935Z",
    fill: "#80FF77"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1392 13.8619L15.1017 14.5227L15.4964 15.5005L15.5457 14.8707L15.1392 13.8619Z",
    fill: "#FF7300"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6733 15.6068L13.5541 15.7102L13.8634 15.7611L13.0125 15.6625L12.6733 15.6068Z",
    fill: "#FFA700"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44745 14.0801L9.48076 14.6256L9.89831 14.1228L9.88981 13.5454L9.44745 14.0801Z",
    fill: "#FF5D00"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4116 19.0874L14.5795 18.9791L14.6411 19.6081L14.4796 19.7778L14.4116 19.0874Z",
    fill: "#A4FF53"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3231 11.7778L10.3812 12.4899L10.9567 12.2408L10.9214 11.5166L10.3231 11.7778Z",
    fill: "#DA0000"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2708 16.7585L15.0087 16.7583L15.2332 17.1726L14.5182 17.2137L14.2708 16.7585Z",
    fill: "#FFE200"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3184 15.6207L12.028 15.7745L12.342 15.6445L11.6628 15.4774L11.3184 15.6207Z",
    fill: "#FFA300"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3734 19.762L15.035 19.8986L15.0361 20.7689L15.3734 20.6929L15.3734 19.762Z",
    fill: "#80FF77"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4852 10.6808L11.5549 11.4344L12.2058 11.5344L12.1556 10.7825L11.4852 10.6808Z",
    fill: "#A40000"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0127 15.6629L13.8636 15.7614L14.1718 15.8962L13.3509 15.811L13.0127 15.6629Z",
    fill: "#FFAB00"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82343 15.7926L10.1774 16.0272L10.4837 15.6636L10.1575 15.3943L9.82343 15.7926Z",
    fill: "#FFA700"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7322 19.9381L14.5272 19.8931L14.5294 20.6363L14.734 20.7453L14.7322 19.9381Z",
    fill: "#80FF77"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85434 12.9025L9.88912 13.5453L10.3909 13.1543L10.3811 12.4899L9.85434 12.9025Z",
    fill: "#FF2500"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9885 16.366L14.752 16.4012L15.0084 16.7582L14.2705 16.7584L13.9885 16.366Z",
    fill: "#FFCC00"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3513 15.811L14.1722 15.8963L14.4709 16.1116L13.6794 16.0476L13.3513 15.811Z",
    fill: "#FFAE00"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0349 19.8979L14.7323 19.9379L14.7341 20.7451L15.036 20.7683L15.0349 19.8979Z",
    fill: "#80FF77"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4834 15.6631L11.0026 15.8612L11.3189 15.6207L10.8298 15.3984L10.4834 15.6631Z",
    fill: "#FF9F00"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6792 16.047L14.4707 16.1109L14.752 16.401L13.9885 16.3658L13.6792 16.047Z",
    fill: "#FFBD00"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2839 17.7609L14.7239 17.7194L14.8832 18.262L14.4599 18.358L14.2839 17.7609Z",
    fill: "#E1FF16"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6504 12.9537L14.6273 13.6422L15.1025 14.5228L15.14 13.862L14.6504 12.9537Z",
    fill: "#FF3F00"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47998 14.6259L9.52314 15.0946L9.91373 14.6258L9.89752 14.1232L9.47998 14.6259Z",
    fill: "#FF6F00"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4968 15.5001L15.3557 16.0713L15.6481 17.0771L15.8005 16.5476L15.4968 15.5001Z",
    fill: "#FFB600"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6634 15.4777L12.3427 15.6448L12.6736 15.607L12.0268 15.4359L11.6634 15.4777Z",
    fill: "#FF9800"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62079 15.4829L9.82259 15.7925L10.1566 15.3942L9.98322 15.0493L9.62079 15.4829Z",
    fill: "#FF9400"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5966 18.5177L15.2832 18.8152L15.3736 19.7617L15.6914 19.5216L15.5966 18.5177Z",
    fill: "#B7FF40"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1558 10.7825L12.2059 11.5344L12.8564 11.815L12.8259 11.0707L12.1558 10.7825Z",
    fill: "#A40000"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4534 19.1383L14.4124 19.0874L14.4804 19.7778L14.5276 19.893L14.4534 19.1383Z",
    fill: "#A7FF50"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2798 18.4055L14.4599 18.3582L14.5801 18.9796L14.4122 19.0878L14.2798 18.4055Z",
    fill: "#C7FF30"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52393 15.0941L9.62151 15.4826L9.98394 15.049L9.91452 14.6253L9.52393 15.0941Z",
    fill: "#FF8200"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6479 17.0773L15.4069 17.5239L15.596 18.5177L15.8457 18.122L15.6479 17.0773Z",
    fill: "#F1FC06"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M14.056 17.2042L14.5173 17.2136L14.7233 17.7194L14.2833 17.7609L14.056 17.2042Z",
    fill: "#FBF100"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0904 12.1717L14.0837 12.8838L14.6267 13.6422L14.6498 12.9537L14.0904 12.1717Z",
    fill: "#FF1300"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9212 11.5167L10.9565 12.2409L11.5653 12.1633L11.5544 11.4344L10.9212 11.5167Z",
    fill: "#C40000"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8255 11.0706L12.856 11.8149L13.488 12.2688L13.4766 11.5379L12.8255 11.0706Z",
    fill: "#B60000"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0264 15.4359L12.6732 15.607L13.0123 15.6628L12.399 15.4971L12.0264 15.4359Z",
    fill: "#FF9400"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8301 15.3984L11.3192 15.6206L11.6636 15.4773L11.2075 15.2405L10.8301 15.3984Z",
    fill: "#FF8D00"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1571 15.3938L10.4834 15.6631L10.8298 15.3984L10.5352 15.1038L10.1571 15.3938Z",
    fill: "#FF8D00"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4766 11.5377L13.4879 12.2686L14.0837 12.8834L14.0904 12.1713L13.4766 11.5377Z",
    fill: "#D10000"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88934 13.5458L9.89784 14.1233L10.3712 13.7559L10.3911 13.1548L9.88934 13.5458Z",
    fill: "#FF3800"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6522 19.1183L14.4531 19.1387L14.5273 19.8934L14.7323 19.9384L14.6522 19.1183Z",
    fill: "#ADFF49"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M15.283 18.8156L14.9496 19.014L15.0351 19.8986L15.3734 19.762L15.283 18.8156Z",
    fill: "#B4FF43"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7834 16.7029L14.27 16.7582L14.5174 17.2135L14.0561 17.2041L13.7834 16.7029Z",
    fill: "#FFD300"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3809 12.49L10.3907 13.1544L10.9387 12.9189L10.9563 12.2408L10.3809 12.49Z",
    fill: "#F10800"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3991 15.4969L13.0124 15.6626L13.3506 15.8107L12.771 15.6598L12.3991 15.4969Z",
    fill: "#FF9400"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9498 19.0142L14.6525 19.1186L14.7326 19.9387L15.0353 19.8988L14.9498 19.0142Z",
    fill: "#B1FF46"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0861 17.7495L14.2839 17.7611L14.4599 18.3582L14.2798 18.4054L14.0861 17.7495Z",
    fill: "#EBFF0C"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1017 14.5228L14.9756 15.1329L15.3553 16.0718L15.4964 15.5006L15.1017 14.5228Z",
    fill: "#FF7E00"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4733 16.2708L13.9886 16.3657L14.2707 16.758L13.7841 16.7027L13.4733 16.2708Z",
    fill: "#FFB900"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M12.771 15.6597L13.3506 15.8105L13.6787 16.0471L13.1321 15.9201L12.771 15.6597Z",
    fill: "#FF9C00"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3084 18.3924L14.2798 18.4054L14.4122 19.0877L14.4531 19.1386L14.3084 18.3924Z",
    fill: "#CEFF29"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1323 15.92L13.6789 16.0471L13.9882 16.3659L13.4729 16.271L13.1323 15.92Z",
    fill: "#FFA700"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98373 15.0496L10.1571 15.3945L10.5353 15.1045L10.3943 14.7335L9.98373 15.0496Z",
    fill: "#FF7700"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2069 15.2412L11.663 15.478L12.0264 15.4362L11.6055 15.1949L11.2069 15.2412Z",
    fill: "#FF8200"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89828 14.1227L9.91449 14.6253L10.3571 14.2832L10.3717 13.7554L9.89828 14.1227Z",
    fill: "#FF4A00"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5544 11.4344L11.5653 12.1633L12.191 12.2607L12.2052 11.5344L11.5544 11.4344Z",
    fill: "#B60000"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M15.407 17.524L15.1034 17.8786L15.2826 18.8154L15.596 18.5179L15.407 17.524Z",
    fill: "#EBFF0C"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91455 14.6256L9.98398 15.0492L10.3945 14.7332L10.3572 14.2835L9.91455 14.6256Z",
    fill: "#FF6000"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5355 15.1037L10.8301 15.3984L11.2076 15.2405L10.9478 14.9305L10.5355 15.1037Z",
    fill: "#FF7700"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3554 16.0714L15.1278 16.5671L15.4068 17.5238L15.6478 17.0772L15.3554 16.0714Z",
    fill: "#FFC100"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8363 17.1375L14.0568 17.2041L14.284 17.7608L14.0863 17.7492L13.8363 17.1375Z",
    fill: "#FFE200"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4953 18.3069L14.3083 18.3922L14.453 19.1385L14.6521 19.1181L14.4953 18.3069Z",
    fill: "#D7FF1F"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M14.627 13.6422L14.519 14.2874L14.9761 15.133L15.1023 14.5228L14.627 13.6422Z",
    fill: "#FF4A00"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6057 15.1942L12.0265 15.4354L12.3992 15.4966L12.0147 15.2612L11.6057 15.1942Z",
    fill: "#FF7A00"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3918 13.1543L10.3719 13.7555L10.8889 13.5348L10.9398 12.9188L10.3918 13.1543Z",
    fill: "#FF1A00"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9567 12.2411L10.9391 12.9191L11.5188 12.8468L11.5656 12.1636L10.9567 12.2411Z",
    fill: "#DA0000"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0966 17.6746L14.0861 17.7492L14.2798 18.4052L14.3084 18.3922L14.0966 17.6746Z",
    fill: "#F4F802"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1037 17.8789L14.7811 18.1388L14.9495 19.0141L15.283 18.8157L15.1037 17.8789Z",
    fill: "#E4FF13"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2059 11.5345L12.1916 12.2608L12.8168 12.5313L12.8563 11.8151L12.2059 11.5345Z",
    fill: "#BB0000"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M13.536 16.5874L13.7836 16.7036L14.0563 17.2048L13.8358 17.1382L13.536 16.5874Z",
    fill: "#FFC100"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7811 18.1385L14.4955 18.3071L14.6523 19.1182L14.9495 19.0138L14.7811 18.1385Z",
    fill: "#DEFF19"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3939 14.7331L10.5349 15.104L10.9472 14.9308L10.8419 14.5439L10.3939 14.7331Z",
    fill: "#FF6000"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M12.015 15.2617L12.3994 15.4972L12.7714 15.6601L12.4234 15.4406L12.015 15.2617Z",
    fill: "#FF7E00"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9473 14.9304L11.207 15.2404L11.6056 15.1941L11.3829 14.8792L10.9473 14.9304Z",
    fill: "#FF6C00"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0836 12.8838L13.9966 13.5588L14.5187 14.2873L14.6266 13.6422L14.0836 12.8838Z",
    fill: "#FF1E00"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1942 16.1121L13.4727 16.2712L13.7835 16.7031L13.5359 16.5869L13.1942 16.1121Z",
    fill: "#FFA700"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8561 11.8145L12.8166 12.5307L13.424 12.9673L13.488 12.2683L12.8561 11.8145Z",
    fill: "#C80000"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4235 15.4399L12.7715 15.6594L13.1326 15.9199L12.8203 15.7261L12.4235 15.4399Z",
    fill: "#FF8600"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3718 13.7555L10.3573 14.2833L10.8405 14.0782L10.8887 13.5348L10.3718 13.7555Z",
    fill: "#FF3000"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9763 15.1323L14.7664 15.6739L15.1284 16.5669L15.3561 16.0712L14.9763 15.1323Z",
    fill: "#FF8900"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8198 15.7264L13.1321 15.9202L13.4727 16.2711L13.1941 16.1121L12.8198 15.7264Z",
    fill: "#FF9400"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4876 12.2693L13.4237 12.9683L13.9964 13.5591L14.0834 12.8841L13.4876 12.2693Z",
    fill: "#E40000"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1282 16.567L14.8397 16.9766L15.1036 17.8782L15.4072 17.5236L15.1282 16.567Z",
    fill: "#FFC800"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3564 14.2835L10.3938 14.7332L10.8417 14.5441L10.8396 14.0784L10.3564 14.2835Z",
    fill: "#FF4A00"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8224 17.0057L13.8355 17.1379L14.0855 17.7496L14.096 17.675L13.8224 17.0057Z",
    fill: "#FFD300"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 17.5265L14.0967 17.6745L14.3085 18.392L14.4955 18.3067L14.2656 17.5265Z",
    fill: "#FEED00"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5661 12.1636L11.5194 12.8468L12.1151 12.9406L12.1918 12.2609L11.5661 12.1636Z",
    fill: "#CD0000"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3835 14.88L11.6061 15.1949L12.0152 15.2619L11.8308 14.9529L11.3835 14.88Z",
    fill: "#FF6400"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9396 12.9187L10.8887 13.5347L11.4354 13.4677L11.5193 12.8463L10.9396 12.9187Z",
    fill: "#F10800"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8398 16.9772L14.5337 17.2965L14.7811 18.1386L15.1037 17.8787L14.8398 16.9772Z",
    fill: "#FFD300"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8423 14.5441L10.9477 14.9309L11.3833 14.8797L11.3158 14.4878L10.8423 14.5441Z",
    fill: "#FF5200"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5333 17.2962L14.2651 17.5267L14.495 18.307L14.7807 18.1384L14.5333 17.2962Z",
    fill: "#FFE200"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4953 16.4026L13.5366 16.5869L13.8364 17.1377L13.8234 17.0054L13.4953 16.4026Z",
    fill: "#FFB200"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5186 14.2876L14.3303 14.8705L14.7657 15.6748L14.9756 15.1332L14.5186 14.2876Z",
    fill: "#FF5900"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8303 14.9525L12.0147 15.2614L12.4232 15.4403L12.2771 15.1479L11.8303 14.9525Z",
    fill: "#FF6400"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8881 13.5351L10.8398 14.0785L11.3507 14.0169L11.4348 13.4681L10.8881 13.5351Z",
    fill: "#FF2200"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9678 16.799L13.8224 17.0056L14.096 17.675L14.2649 17.527L13.9678 16.799Z",
    fill: "#FFC400"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8398 14.0782L10.8419 14.5438L11.3154 14.4876L11.3508 14.0166L10.8398 14.0782Z",
    fill: "#FF3800"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7663 15.6743L14.4979 16.1354L14.8399 16.9769L15.1283 16.5673L14.7663 15.6743Z",
    fill: "#FF9400"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1919 12.2604L12.1151 12.94L12.7103 13.1982L12.8171 12.5309L12.1919 12.2604Z",
    fill: "#D10000"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1209 15.8834L13.1944 16.1125L13.5361 16.5872L13.4948 16.403L13.1209 15.8834Z",
    fill: "#FF9400"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M12.277 15.1478L12.4231 15.4401L12.8199 15.7262L12.7112 15.4607L12.277 15.1478Z",
    fill: "#FF6C00"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7108 15.4611L12.8195 15.7265L13.1938 16.1122L13.1204 15.8831L12.7108 15.4611Z",
    fill: "#FF7E00"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9964 13.5592L13.833 14.1775L14.3302 14.8706L14.5185 14.2877L13.9964 13.5592Z",
    fill: "#FF3000"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3159 14.4878L11.3835 14.8797L11.8308 14.9527L11.8022 14.5666L11.3159 14.4878Z",
    fill: "#FF4A00"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5187 12.8463L11.4348 13.4677L11.9964 13.5571L12.1144 12.9401L11.5187 12.8463Z",
    fill: "#E80000"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8168 12.5314L12.71 13.1987L13.2883 13.6147L13.4242 12.968L12.8168 12.5314Z",
    fill: "#DF0000"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2132 16.5101L13.9681 16.7986L14.2652 17.5266L14.5334 17.296L14.2132 16.5101Z",
    fill: "#FFB200"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4238 12.9676L13.2878 13.6143L13.8331 14.1767L13.9965 13.5584L13.4238 12.9676Z",
    fill: "#FA0F00"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4974 16.1357L14.2131 16.5106L14.5332 17.2965L14.8393 16.9773L14.4974 16.1357Z",
    fill: "#FFA300"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6121 16.1431L13.4953 16.4026L13.8234 17.0054L13.9687 16.7988L13.6121 16.1431Z",
    fill: "#FF9F00"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3309 14.8702L14.0869 15.3777L14.498 16.1357L14.7664 15.6746L14.3309 14.8702Z",
    fill: "#FF6800"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3513 14.0166L11.3159 14.4876L11.8022 14.5663L11.8761 14.101L11.3513 14.0166Z",
    fill: "#FF3000"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8018 14.5667L11.8303 14.9528L12.2772 15.1483L12.2876 14.779L11.8018 14.5667Z",
    fill: "#FF4A00"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M11.435 13.4681L11.3509 14.0169L11.8757 14.1013L11.9967 13.5575L11.435 13.4681Z",
    fill: "#FF1A00"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2051 15.5782L13.1209 15.8834L13.4948 16.403L13.6116 16.1434L13.2051 15.5782Z",
    fill: "#FF7E00"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M12.115 12.9407L11.9971 13.5577L12.5583 13.8018L12.7102 13.199L12.115 12.9407Z",
    fill: "#ED0400"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2875 14.7791L12.277 15.1484L12.7112 15.4614L12.7596 15.1193L12.2875 14.7791Z",
    fill: "#FF5500"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8288 15.8021L13.6117 16.1428L13.9682 16.7985L14.2133 16.51L13.8288 15.8021Z",
    fill: "#FF8D00"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M12.76 15.1193L12.7116 15.4614L13.1212 15.8834L13.2054 15.5783L12.76 15.1193Z",
    fill: "#FF6800"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0867 15.3773L13.8289 15.8022L14.2135 16.5101L14.4978 16.1353L14.0867 15.3773Z",
    fill: "#FF7A00"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 14.1769L13.6174 14.7241L14.0864 15.3774L14.3305 14.8699L13.8333 14.1769Z",
    fill: "#FF4300"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8756 14.1012L11.8018 14.5666L12.2876 14.7788L12.4 14.3298L11.8756 14.1012Z",
    fill: "#FF3400"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7097 13.1987L12.5578 13.8016L13.1031 14.1941L13.288 13.6147L12.7097 13.1987Z",
    fill: "#FA0F00"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9968 13.5576L11.8758 14.1014L12.4002 14.3301L12.558 13.8017L11.9968 13.5576Z",
    fill: "#FF1A00"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2879 13.6146L13.103 14.194L13.6173 14.7242L13.8332 14.1769L13.2879 13.6146Z",
    fill: "#FF2200"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3899 15.1925L13.2048 15.5783L13.6113 16.1435L13.8284 15.8027L13.3899 15.1925Z",
    fill: "#FF6800"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6175 14.7238L13.3903 15.1917L13.8289 15.8019L14.0866 15.377L13.6175 14.7238Z",
    fill: "#FF5500"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 14.3299L12.2876 14.7789L12.7597 15.1191L12.9096 14.6969L12.4 14.3299Z",
    fill: "#FF3B00"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9095 14.6969L12.7596 15.1191L13.205 15.5781L13.3901 15.1923L12.9095 14.6969Z",
    fill: "#FF4E00"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5577 13.8018L12.3999 14.3301L12.9094 14.6971L13.103 14.1943L12.5577 13.8018Z",
    fill: "#FF2500"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1029 14.194L12.9094 14.6967L13.39 15.1922L13.6172 14.7242L13.1029 14.194Z",
    fill: "#FF3800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    width: 17,
    height: 13,
    rx: 1,
    fill: "#174F99"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M17.33 10V3H18.95V8.68H22.46V10H17.33ZM23.3749 10V3H24.9949V8.68H28.5049V10H23.3749Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6545_375133",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E8EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLlamalend);
export default __webpack_public_path__ + "static/media/page-llamalend.bef3dc8e791e55a253b8e6d37a5844fc.svg";
export { ForwardRef as ReactComponent };